var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');
var nestable = require('./tripletrax.nestable.js');
var changes = require('./tripletrax.changes.js');
var initialize = require('./tripletrax.initialize.js');
var validator = require('./tripletrax.validator.js');
var patients = require('./tripletrax.patients.js');
var views = require('./tripletrax.views.js');
var integrities = require('./tripletrax.integrities.js');
var reports = require('./tripletrax.reports.js');
var access = require('./tripletrax.access.js');

function registerCommonEvents() {

    // Umstellung Tabs von links nach oben falls Breite kleiner 992 Pixel wird
    $(window).resize(function () {

        if ($(this).width() < 992) {
            $('.tt-row-tab').find('.tt-nav-tabs').height('inherit');

            $('.tt-nav-tab').removeClass('tabs-left');
            $('.tt-nav-row').removeClass('row');
            $('.tt-nav-header-article').removeClass('col-xs-4').removeClass('col-sm-3').removeClass('col-md-2').removeClass('col-lg-1');
            $('.tt-nav-content-article').removeClass('col-xs-8').removeClass('col-sm-9').removeClass('col-md-10').removeClass('col-lg-11');
            $('.tt-nav-content-article').removeClass('tt-nav-tab-content');
            $('.tt-nav-content-article').addClass('padding-12');
        } else {
            $('.tt-nav-tab').addClass('tabs-left');
            $('.tt-nav-row').addClass('row');
            $('.tt-nav-header-article').addClass('col-xs-4').addClass('col-sm-3').addClass('col-md-2').addClass('col-lg-1');
            $('.tt-nav-content-article').addClass('col-xs-8').addClass('col-sm-9').addClass('col-md-10').addClass('col-lg-11');
            $('.tt-nav-content-article').addClass('tt-nav-tab-content');
            $('.tt-nav-content-article').removeClass('padding-12');
        }
    });

    // Auf Änderungen prüfen und ggf. speichern (click)
    document.body.addEventListener('click', function (e) {
        if (!$(e.target).hasClass('tt-datatable-patient-search')) {
            changes.saveChanges(e);
        }
    }, true);

    // Auf Änderungen prüfen und ggf. speichern (mousedown)
    document.addEventListener('mousedown', function (e) {
        if ($(e.target).parents('.dd-handle').length || ($(e.target).is('.dd-handle') && !$(e.target).is('.dd3-handle'))) {
            //console.log('mousedown addEventListener');
            changes.saveChanges(e);
        }
    }, true);

    // Für Select2 und Datepicker Form Validator aufrufen
    $(document).on('change', '.tt-select2,.datepicker', function () {
        validator.triggerValidation(this, true, false);
    });

    // Navigation
    $(document).on('click', 'nav a[href!="#"]', function (e) {
        if ($(this).hasClass('disabled')) {
            return false;
        }

        // Wenn die Seite bereits ausgewählt ist, dann nicht nochmals laden
        // Fall die Seite "Patienten" auf Doku-Seite ausgewählt ist, dann immer auf die Patientenliste springen
        if ($(this).parent().hasClass('active')) {
            if ($(this)[0].id === "patient_nav") {
                if (!$('[href="#content-detail-patientlist"]').parent().hasClass('active')) {
                    $('[href="#content-detail-patientlist"]').click();
                }
            }
            return false;
        }

        e.preventDefault();

		$(this).parents('nav').find('a').addClass('disabled');

        var element = this;
        var url = $(e.currentTarget).attr('href');
        ajax.ajaxCall(url, 'GET', null, true, function (data) {
            utils.setHtmlData($("#content"), data, true);

            if ($('#import_form').length || $('#import_query_form').length) {
                if ($('[name="previous_import_state"]').val() === 'wait') {

					if ($('[name="previous_import_type"]').val() === '1') {
						$('.tt-import-progress-text').text(trans('tripletrax.please_wait_import_running'));
						$('.tt-please-wait-import').removeClass('hide');
						$('.tt-section-import-progress').removeClass('hide');
					} else {
						$('.tt-import-progress-text').text(trans('tripletrax.please_wait_import_preview_running'));
						$('.tt-please-wait-import-preview').removeClass('hide');
						$('.tt-section-import-preview-progress').removeClass('hide');
					}

					if (!utils.GLOBALS.importRunning && $('#import_form').length) {
						var importData = new FormData($('#import_form')[0]);
						validator.doImport('admin/import/import/0', importData, $('#import_form')[0]);
					}

					if (!utils.GLOBALS.importQueryRunning && $('#import_query_form').length) {
						var importData = new FormData($('#import_query_form')[0]);
						validator.doImport('admin/import_query/import/0', importData, $('#import_query_form')[0]);
					}
				}
            } else if ($('#table_aggregation_execution_4_form').length) {
                if ($('[name="previous_aggregation_state"]').val() === 'wait') {

					if (!utils.GLOBALS.aggregationRunning) {
						var aggregationData = { 'aggregation_time_stamp': $('[name="aggregation_time_stamp"]').val()};
						validator.doAggregation('admin/aggregation_execution/step4/check', aggregationData);
					}
				}
            } else if ($('#facility_report_form').length) {
                reports.setFacilityChartPage();
            }

            utils.setIDATData($("#content"));

            changes.calculateLeftNavHeight();
            $(element).parents('nav').find('a').removeClass('disabled');
        });
    });

    // Navigation (Tabs links)
    $(document).on('click', '.tt-nav-tabs a[href!="#"]', function (e) {
        e.preventDefault();

        if (!utils.GLOBALS.programmaticClick) {
            changes.selectNavigationTab($(this), null);
        }
    });

    // Uhrzeit Angabe - Validierung
    $(document).on('changeTime.timepicker', '.timepicker-container', function (e) {
        utils.updateGlobals('showValidationErrorMessageBox', false);
        $(this).parents('.tt-validation-form').valid();
        utils.updateGlobals('showValidationErrorMessageBox', true);
    });

    // Startseite des Admins anzeigen
    $('body').on('click', '.tt-admin-home,.tt-stats-home', function (e) {
        e.preventDefault();

        ajax.ajaxCall($(this).attr('href'), 'GET', null, true, function(data) {
            utils.setHtmlData($("#content"), data, true);
        });
    });

    // Löschen Button
    $('body').on('click', '.tt-delete,.tt-delete-value-modal', function (e) {
        e.preventDefault();

        var table = $(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-dialog,.tt-datatable-data,.dd');
        if (table[0].id === "table_patientlist") {
            $('#label_patient_delete').text(trans('tripletrax.delete_patient_x', {patient: views.setPatientDisplayName()}));
            return;
        }
        if ($(this).hasClass('tt-delete-dialog')) {
            event.stopPropagation();
        }

        var title = 'TODO';
        var content = 'TODO';
        var element = $(this);
        var aPos = $(this).parents('.tt-content-datatable').find('.tt-selected-pos').val();
        var id = $(this).parents('.tt-content-datatable').find('.tt-selected-id').val();

        checkForExistingData(element, table, id, aPos).done(function (existing, additionalText) {

            if (existing) {
                return;
            }

            // Muss für jeden Bereich definiert werden!
            if (table[0].id === "table_users") {
                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_user', {"username": "<span class='txt-color-orangeDark'><strong>" + $("#username").val() + "</strong></span>"});
                content = Lang.get('tripletrax.delete_user_desc');
            } else if (table[0].id === "table_users_roles") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_facility_roles', {"facility": "<span class='txt-color-orangeDark'><strong>" + aData[1] + "</strong></span>"});
                content = Lang.get('tripletrax.delete_facility_roles_desc');
            } else if (table[0].id === "table_facilities") {
                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_facility', {"facility": "<span class='txt-color-orangeDark'><strong>" + $("#facilityname").val() + "</strong></span>"});
                content = Lang.get('tripletrax.delete_facility_desc');
            } else if (table[0].id === "table_roles") {
                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_role', {"role": "<span class='txt-color-orangeDark'><strong>" + $("#rolename").val() + "</strong></span>"});
                content = Lang.get('tripletrax.delete_role_desc');
            } else if (table[0].id === "table_data_collection_types") {
                if (additionalText === '') {
                    title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_datacollectiontype', {"datacollectiontype": "<span class='txt-color-orangeDark'><strong>" + $("#model").val() + "</strong></span>"});
                    content = Lang.get('tripletrax.delete_datacollectiontype_desc');
                } else {
                    title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_datacollectiontype', {"datacollectiontype": "<span class='txt-color-orangeDark'><strong>" + $("#model").val() + "</strong></span>"});
                    content = Lang.get('tripletrax.delete_datacollectiontype_with_models_desc', {"models": additionalText});
                }
            } else if (table[0].id === "table_data_collection_type_master_views") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_master_view', {"master_view": "<span class='txt-color-orangeDark'><strong>" + aData[1] + "</strong></span>"});
                content = Lang.get('tripletrax.delete_master_view_desc');
            } else if (table[0].id === 'table_data_collection_type_course_views_register') {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_course_view', {"course_view": "<span class='txt-color-orangeDark'><strong>" + aData[1] + "</strong></span>"});
                content = Lang.get('tripletrax.delete_course_view_desc');
			} else if (table[0].id === 'table_data_collection_type_questionnaire_projects') {
				var aData = table.dataTable().fnGetData(aPos);

				title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_questionnaire_project', {"course_view": "<span class='txt-color-orangeDark'><strong>" + aData[1] + "</strong></span>"});
				content = Lang.get('tripletrax.delete_questionnaire_project_desc');
			} else if (table[0].id === 'table_data_collection_type_questionnaires') {
				var aData = table.dataTable().fnGetData(aPos);

				title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_questionnaire', {"questionnaire": "<span class='txt-color-orangeDark'><strong>" + aData[1] + "</strong></span>"});
				content = Lang.get('tripletrax.delete_questionnaire_desc');
            } else if (table[0].id === "dd_course_views") {
                var aData = element.parents('.tt-content-datatable').find("[data-id='" + id + "']").find('.dd-handle')[0].innerHTML;

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_course_view', {"course_view": "<span class='txt-color-orangeDark'><strong>" + aData + "</strong></span>"});
                content = Lang.get('tripletrax.delete_course_view_desc');
            } else if (table[0].id === "dd_data_views") {
                var item = element.parents('.tt-content-datatable').find("[data-id='" + id + "']");
                var parent_item = $(item.parents('.dd-item')[0]);
                var aData = item.find('.dd-handle')[0].textContent;
                aData = aData.substring(0, aData.indexOf("(") - 1);

                if (item.data().type === 'field') {
                    if (parent_item.data().category === 'not_used_fields') {
                        title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_data_view_field_complete', {"field_name": "<span class='txt-color-orangeDark'><strong>" + aData + "</strong></span>"});
                        content = Lang.get('tripletrax.delete_data_view_field_complete_desc', {"field_name": aData});
                    } else {
                        title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_data_view_field', {"field_name": "<span class='txt-color-orangeDark'><strong>" + aData + "</strong></span>"});
                        content = Lang.get('tripletrax.delete_data_view_field_desc');
                    }
                } else {
                    title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_data_view_field_complete', {"field_name": "<span class='txt-color-orangeDark'><strong>" + aData + "</strong></span>"});
                    content = Lang.get('tripletrax.delete_data_view_element_desc', {"element_name": aData});
                }
            } else if (table[0].id === "table_agreement_type_documents") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_document', {"document": "<span class='txt-color-orangeDark'><strong>" + aData[1] + "</strong></span>"});
                content = Lang.get('tripletrax.delete_document_desc');
            } else if (table[0].id === "table_agreement_types") {
                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_agreement_type', {"agreement_type": "<span class='txt-color-orangeDark'><strong>" + $("#agreement_description").val() + "</strong></span>"});
                content = Lang.get('tripletrax.delete_agreement_type_desc');
            } else if (table[0].id === "table_data_views_units") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_unit', {"unit": "<span class='txt-color-orangeDark'><strong>" + aData[2] + "</strong></span>"});
                content = Lang.get('tripletrax.delete_unit_desc');
			} else if (table[0].id === "table_data_views_display_restrictions") {
				var aData = table.dataTable().fnGetData(aPos);

				var display_text = '';
				if (!utils.isUndefined(aData[2]) && aData[2] !== '') {
					display_text = trans('tripletrax.from_date', {'from_date': utils.dateToLocaleString(aData[2])});
				}
				if (!utils.isUndefined(aData[3]) && aData[3] !== '') {
					if (display_text.length > 0) {
						display_text += ' ';
					}
					display_text += trans('tripletrax.till_date', {'till_date': utils.dateToLocaleString(aData[3])});
				}

				title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_display_restriction', {"display_restriction": "<span class='txt-color-orangeDark'><strong>" + aData[1] + ": " + display_text + "</strong></span>"});
				content = Lang.get('tripletrax.delete_display_restriction_desc');
            } else if (table[0].id === "table_data_views_restrictions") {

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_integrity', {"integrity": "<span class='txt-color-orangeDark'><strong>" + aData[2] + "</strong></span>"});
                content = Lang.get('tripletrax.delete_integrity_desc');
            } else if (table[0].id === "table_data_views_integrities") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_integrity', {"integrity": "<span class='txt-color-orangeDark'><strong>" + aData[2] + "</strong></span>"});
                if (table.parents('.modal-content').find('form').find('[name="integrity_data_collection_type"]').find(":selected").data("coloredCompletenessActivated") === 1) {

                    var integrity_type_id = table.parents('.modal-content').find('form').find('[name="integrity_type"]').select2('data')[0].id;
                    var integrity_completeness_frequency = '';

                    if (integrity_type_id === 'completeness') {
                        if (!utils.isUndefined(table.parents('.modal-content').find('form').find('[name="completeness_frequency"]:checked')) && table.parents('.modal-content').find('form').find('[name="completeness_frequency"]:checked').length > 0) {
                            integrity_completeness_frequency = table.parents('.modal-content').find('form').find('[name="completeness_frequency"]:checked').val();
                        }
                    } else if (integrity_type_id === 'dependency') {
                        integrity_completeness_frequency = table.parents('.modal-content').find('form').find('[name="integrity_dependency_frequency"]:checked').val();
                    }

                    if (integrity_type_id === 'completeness' || (integrity_type_id === 'dependency' && integrity_completeness_frequency !== 'no')) {

                        content = Lang.get('tripletrax.delete_integrity_colored_completeness_activated_desc');
                    } else {
                        content = Lang.get('tripletrax.delete_integrity_desc');
                    }
                } else {
                    content = Lang.get('tripletrax.delete_integrity_desc');
                }
            } else if (table[0].id === "table_data_collection_type_integrities") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_integrity', {"integrity": "<span class='txt-color-orangeDark'><strong>" + aData[2] + "</strong></span>"});
                if ($('[name="colored_completeness_activated"]').val() === '1') {

                    if (aData[4] === 'completeness' || (aData[4] === 'dependency' && aData[20] !== 'no')) {
                        content = Lang.get('tripletrax.delete_integrity_colored_completeness_activated_desc');
                    } else {
                        content = Lang.get('tripletrax.delete_integrity_desc');
                    }
                } else {
                    content = Lang.get('tripletrax.delete_integrity_desc');
                }
            } else if (table[0].id === "table_patient_agreement") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_agreement', {"model": "<span class='txt-color-orangeDark'><strong>" + aData.description + "</strong></span>"});
                content = Lang.get('tripletrax.delete_agreement_desc');
            } else if (table[0].id === "table_patient_examination") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_exam', {"examination": "<span class='txt-color-orangeDark'><strong>" + utils.dateToLocaleTimeString(views.getExaminationDate()) + "</strong></span>"});
                content = Lang.get('tripletrax.delete_examination_desc');
                if (additionalText !== '') {
                    content += '<br>';
                    content += additionalText;
                }
            } else if (table[0].id === "table_news") {
                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_news', {"news": "<span class='txt-color-orangeDark'><strong>" + $("#news_title").val() + "</strong></span>"});
                content = Lang.get('tripletrax.delete_news_desc');
            } else if (table[0].id === "table_documents") {
                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_documents', {"documents": "<span class='txt-color-orangeDark'><strong>" + $("#documents_title").val() + "</strong></span>"});
                content = Lang.get('tripletrax.delete_documents_desc');
            } else if (table[0].id === "table_monitoring") {
                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_monitoring', {"monitoring": "<span class='txt-color-orangeDark'><strong>" + $("#monitoring_description").val() + "</strong></span>"});
                content = Lang.get('tripletrax.delete_monitoring_desc');
            } else if (table[0].id === "table_aggregation_definition") {
				var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_aggregation_definition', {"data_view_field": "<span class='txt-color-orangeDark'><strong>" + aData.source_desc + "</strong></span>"});
				content = Lang.get('tripletrax.delete_aggregation_definition_desc');
            }  else if (table[0].id === "table_devices") {
				title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_user', {"username": "<span class='txt-color-orangeDark'><strong>" + $("#username").val() + "</strong></span>"});
				content = Lang.get('tripletrax.delete_device_desc');
			} else if (table[0].id === "table_locked_periods") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_locked_period', {"locked_period": "<span class='txt-color-orangeDark'><strong>" + utils.dateToLocaleString(aData[4]) + " - " + utils.dateToLocaleString(aData[5]) + "</strong></span>"});
                content = Lang.get('tripletrax.delete_locked_period_desc');
            } else if (table[0].id === "table_locked_patients") {
                var aData = table.dataTable().fnGetData(aPos);

                title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_locked_patient', {"locked_patient": "<span class='txt-color-orangeDark'><strong>" + aData[1] + "</strong></span>"});
                content = Lang.get('tripletrax.delete_locked_patient_desc');
            }

            $.SmartMessageBox({
                title: title,
                content: content,
                buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
            }, function (ButtonPressed) {
                if (ButtonPressed === Lang.get('tripletrax.yes')) {
                    if (table[0].id === "dd_data_views") {
                        if (id == 0) {
                            element.parents('.tt-content-datatable').find("[data-id='" + id + "']").remove();
                            $("#content-detail").empty();
                            $("#content-modal").empty();
                        } else {
                            ajax.ajaxCall(element[0].getAttribute("action") + "/" + id, element[0].getAttribute("method"), '_method=DELETE', false, function (data) {
                                nestable.showDataViewNestableItemClicked(data);
                            });
                        }
                    } else if (table.hasClass('tt-datatable-detail') || table.hasClass('tt-datatable-dialog')) {
                        table.dataTable().fnDeleteRow(aPos);

                        if (table[0].id === "table_data_collection_type_integrities") {
                            if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
                                $("#content-detail").find('.tt-datatable-changes').val("changed");
                                $("#content-detail").find('form').trigger('checkform.areYouSure');
                            }

                            if ($('[name="colored_completeness_activated"]').val() === '1') {
                                $('[name="colored_completeness_activated"]').val('0');
                            }
                        } else {
                            if (element.parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
                                element.parents('.tt-content-detail').find('.tt-datatable-changes').val("changed");
                                $("#content-detail").find('form').trigger('checkform.areYouSure');
                            }
                        }

                        $("#content-detail").find('.tt-content-datatable').find('.tt-update').addClass('disabled');
                        $("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');

                        element.parents('.modal-content').find('.tt-content-datatable').find('.tt-delete').addClass('disabled');
                        element.parents('.modal-content').find('.widget-dialog-title').removeClass('hide');
                        element.parents('.modal-content').find('.widget-dialog-content').addClass('hide');

                        if (table[0].id === 'table_data_collection_type_master_views' || table[0].id === 'table_data_collection_type_course_views_register' || table[0].id === 'table_data_collection_type_questionnaires') {

                            integrities.setIntegrityComboboxItems($('#table_collection_type_integrities_form'), '', true);
                        }

                    } else if (table.hasClass('dd')) {

                        var parent_item = element.parents('.tt-content-datatable').find("[data-id='" + id + "']").parent().parent();

                        element.parents('.tt-content-datatable').find("[data-id='" + id + "']").remove();

                        if (!utils.isUndefined(parent_item)) {
                            nestable.unsetNestableParent(parent_item);
                        }

                        if (table[0].id === "dd_course_views" && !table.find('.dd-list').find('.dd-item').length) {
                            $('#dd_course_views').append('<ol class="dd-list"></ol>');
                        }

                        if (element.parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
                            element.parents('.tt-content-detail').find('.tt-datatable-changes').val("changed");
                            $("#content-detail").find('form').trigger('checkform.areYouSure');
                        }

                        $("#content-detail").find('.tt-content-datatable').find('.tt-update').addClass('disabled');
                        $("#content-detail").find('.tt-content-datatable').find('.tt-set-start').addClass('disabled');
                        $("#content-detail").find('.tt-content-datatable').find('.tt-delete').addClass('disabled');

                        if (table.parents('.tt-content-course-views-study').length) {

                            integrities.setIntegrityComboboxItems($('#table_collection_type_integrities_form'), '', true);
                        }

                    } else {
                        if (table[0].id === "table_patient_agreement") {

                            ajax.ajaxCall(element[0].getAttribute("action") + "/" + aData.patient_agreement_ids, element[0].getAttribute("method"), '_method=DELETE', false, function (data) {

                                //var url = $('#table_patient_agreement').dataTable().data().tableUrl.substring(0, $('#table_patient_agreement').dataTable().data().tableUrl.lastIndexOf('/')) + "/" + $('.tt-nav-content-article').find('.tt-selected-id').val() + "/datatable";
                                //changes.reloadTable('#table_patient_agreement', url);
                                patients.loadAgreementList($('.tt-nav-content-article').find('.tt-selected-id').val(), views.getPatientIsLocked());

                                patients.loadPatientlist(false).done(function (patientData) {

                                    var patientId = $('.tt-nav-content-article').find('.tt-selected-id').val();
                                    var list_data = patients.getPatientlist(patientData);
                                    var foundPatient = false;
                                    for (var i = 0; i < list_data.length; i++) {
                                        if (list_data[i].id === parseInt(patientId)) {
                                            foundPatient = true;
                                            break;
                                        }
                                    }
                                    if (!foundPatient) {
                                        patientId = '';
                                    }

                                    $('#table_patientlist').dataTable().api().clear().rows.add(list_data).draw();

                                    if (patientId !== '' && parseInt(patientId) > 0) {
                                        $('#table_patientlist').DataTable().page.jumpToData(parseInt(patientId), 0);
                                        $('#table_patientlist').find('tr[id="' + patientId + '"]').addClass('selected-row');

                                        validator.setDataCollectionTypesForPatient().done(function () {

                                            validator.setQuestionnaireSelectionList();
                                            validator.setExaminationList(true);
                                            validator.setReportSelectionList();
                                        });
                                    } else {
                                        changes.cancelViews(true, true);
                                    }
                                });
                            });
                        } else if (table[0].id === "table_patient_examination") {

                            ajax.ajaxCall(element[0].getAttribute("action") + "/" + views.getExaminationId(), element[0].getAttribute("method"), '_method=DELETE', false, function (data) {

                                changes.cancelViews(false, true);
                                validator.setExaminationList(true);
                            });
                        } else {

                            ajax.ajaxCall(element[0].getAttribute("action") + "/" + $('#content-detail').find('.tt-selected-id').val(), element[0].getAttribute("method"), '_method=DELETE', false, function (data) {

                                element.parents('.tt-content-datatable').find(".tt-datatable-search").val("");
                                element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data').dataTable().fnFilterClear();
                                element.parents('.tt-content-datatable').find('.tt-delete,.tt-roles-overview').addClass('disabled');
                                utils.setHtmlData($("#content-detail"), data, true);

                                if (table[0].id === "table_aggregation_definition") {
                                    element.parents('.tt-content-datatable').find('.tt-aggregation-tabs-restriction').val(null).trigger('change');

                                    // Tabelle mit den Aggregationsregeln neu laden
                                    var sourceModelId = '';
                                    var targetModelId = '';
                                    if ($('#table_aggregation_definition_form').find('[name="source_model"]').select2('data').length > 0 && $('#table_aggregation_definition_form').find('[name="source_model"]').select2('data')[0].id !== '') {
                                        sourceModelId = $('#table_aggregation_definition_form').find('[name="source_model"]').select2('data')[0].id;
                                    }
                                    if ($('#table_aggregation_definition_form').find('[name="target_model"]').select2('data').length > 0 && $('#table_aggregation_definition_form').find('[name="target_model"]').select2('data')[0].id !== '') {
                                        targetModelId = $('#table_aggregation_definition_form').find('[name="target_model"]').select2('data')[0].id;
                                    }

                                    validator.reloadAggregationDefinitionList(sourceModelId, targetModelId, false);
                                }
                            });
                        }
                    }
                }
            });
        });
    });

    // Tabelle zurück Button
    $('body').on('click', '.tt-datatable-previous', function (e) {
        e.preventDefault();

        $(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-dialog,.tt-datatable-data').dataTable().fnPageChange('previous');
    });

    // Tabelle weiter Button
    $('body').on('click', '.tt-datatable-next', function (e) {
        e.preventDefault();

        $(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-dialog,.tt-datatable-data').dataTable().fnPageChange('next');

        initialize.initializeSelect2($(this).parents('.tt-content-datatable').find('.tt-select2:not(.select2-container)'));
    });

    // Tabelle zur Seite springen
    $('body').on('click', '.tt-button-paginate', function (e) {
        e.preventDefault();

        $(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-dialog,.tt-datatable-data').DataTable().page(parseInt($(this).data().page) - 1).draw(false);
    });

    // Tabelle Suche
    $('body').on('keyup', '.tt-datatable-search', function (e) {
        e.preventDefault();
        var element = this;

        var code = e.keyCode || e.which;
        if (code == 13) {
            if ($(element).parents('.tt-content-datatable').find('table').length && $(element).parents('.tt-content-datatable').find('table')[0].id === "table_mails") {
                utils.GLOBALS.mailsUnselected.length = 0;
                utils.GLOBALS.mailsSelected.length = 0;

                var searchValue = 'none';
                if ($(element).val() !== '') {
                    searchValue = $(element).val();
                }
                var url = $('#table_mails')[0].dataset.tableUrl.substring(0, $('#table_mails')[0].dataset.tableUrl.lastIndexOf('/selection')) + "/selection/none/search/" + searchValue;
                $('#table_mails')[0].dataset.tableUrl = url;
                $('#table_mails').DataTable().ajax.url(url).load(null, false);
            } else if ($(element).parents('.tt-content-datatable').find('table').length && $(element).parents('.tt-content-datatable').find('table')[0].id === "table_patientlist" && $('#cancel_patient_search').val() === '1') {
                // Speicherrückfrage und Zurücksetzen des Patienten wenn in den Einstellungen angegeben
                changes.saveChanges(e).done(function(notCanceled) {
                    if (!notCanceled) {
                        e.preventDefault();
                    } else {
                        changes.cancelViews(true, true, false);
                        $(element).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable().search($(element).val().replace(/"/g, '\\b'), true, true).draw();
                    }
                });
            } else {
                $(element).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable().search($(element).val().replace(/"/g, '\\b'), true, true).draw();
            }
        }
        if ($(element).parent().find('.tt-clear-search').length) {
            if ($(element).val().length) {
                $(element).parent().find('.tt-clear-search').removeClass('hide');
            } else {
                $(element).parent().find('.tt-clear-search').addClass('hide');
            }
        }
    });

    // Tabelle Suche zurücksetzen
    $('body').on('click', '.tt-clear-search', function (e) {
        e.preventDefault();

        if ($(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').attr('id') === "table_mails") {
            utils.GLOBALS.mailsUnselected.length = 0;
            utils.GLOBALS.mailsSelected.length = 0;

            var url = $('#table_mails')[0].dataset.tableUrl.substring(0, $('#table_mails')[0].dataset.tableUrl.lastIndexOf('/selection')) + "/selection/none/search/none";
            $('#table_mails')[0].dataset.tableUrl = url;
            $('#table_mails').DataTable().ajax.url(url).load(null, false);

            $(this).parents('.input-group').find('.tt-datatable-search').val('');
            $(this).addClass('hide');

        } else {
            var table = $(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').DataTable();
            $(this).parents('.input-group').find('.tt-datatable-search').val('');
            $(this).addClass('hide');
            table.search('', true, true).draw();
        }

        if ($(this).parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-detail,.tt-datatable-data').attr('id') === 'table_patientlist') {
            var patientId = $('.tt-nav-content-article').find('.tt-selected-id').val();
            if (patientId !== '') {
                table.page.jumpToData(parseInt(patientId), 0);
            }
        }
    });

    // Tabelle mit Mehrfachauswahl - Zeile als ausgewählt / nicht ausgewählt markieren
	$('body').on('click', '.tt-datatable.tt-multiple-select tbody tr,.tt-datatable-data.tt-multiple-select tbody tr', function (e) {
		e.preventDefault();

		$(this).toggleClass('selected-row');
	});

    // Tabellen Zeile & Tabellen Zeile Doppelklick
    $('body').on('click', '.tt-datatable:not(.tt-tree-datatable,.tt-datatable-not-clicked) tbody td,.tt-datatable-data:not(.tt-tree-datatable,.tt-datatable-not-clicked) tbody td', function (e) {
        e.preventDefault();

        var element = $(this);
        var parentElement = $(this).parent();

        if (parentElement.hasClass('clicked')){
            parentElement.removeClass('clicked');
            $.when.apply($, utils.GLOBALS.runningTableClickRequests).done(function () {
                utils.GLOBALS.runningTableClickRequests.push(changes.tableSingleClick(parentElement, element).done(function () {
                    utils.GLOBALS.runningTableClickRequests.length = 0;
                    changes.tableDoubleClick(element);
                }));
            });
        } else {
            parentElement.addClass('clicked');
            setTimeout(function() {
                if (parentElement.hasClass('clicked')){
                    parentElement.removeClass('clicked');
                    utils.GLOBALS.runningTableClickRequests.push(changes.tableSingleClick(parentElement, element).done(function() {
                        utils.GLOBALS.runningTableClickRequests.length = 0;
                    }));
                }
            }, 200);
        }
    });

    // Tabellen (Detail, Dialog) Zeile
    $('body').on('click', '.tt-datatable-detail:not(.tt-tree-datatable,.tt-datatable-select-cell) tbody tr,.tt-datatable-dialog:not(.tt-tree-datatable) tbody tr', function (e) {
        //e.preventDefault();

        if ($(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable()[0].id === "table_export_facilities"
            || $(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable()[0].id === "table_database_export_facilities") {
            return;
        }

        if (!$(this).hasClass('selected-row')) {
            $(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable().$('tr.selected-row').removeClass('selected-row');
            $(this).addClass('selected-row');
        }

        var aPos = $(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable().fnGetPosition(this);
        var aData = $(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable().fnGetData(aPos);

        if (!utils.isUndefined(aData) && $(this).parents('.tt-content-datatable').find('.tt-selected-id').length > 0) {
            $(this).parents('.tt-content-datatable').find('.tt-selected-id').val(aData[0]);
        }
        if (!utils.isUndefined(aData) && $(this).parents('.tt-content-datatable').find('.tt-selected-pos').length > 0) {
            $(this).parents('.tt-content-datatable').find('.tt-selected-pos').val(aPos);
        }
        if (!($(this).parents('.tt-datatable').length && ($("#username").val() === "administrator"))
            && !$(this).parents('.tt-content-datatable').find('.tt-right-button-delete').hasClass('no-rights')) {
            $(this).parents('.tt-content-datatable').find('.tt-delete,.tt-show-document,.tt-delete-list-item').removeClass('disabled');
            if (!utils.isUndefined(aData) && aData.length >= 2) {
                $(this).parents('.tt-content-datatable').find('.tt-show-document').attr('href', aData[2]);
            }
        } else {
            $(this).parents('.tt-content-datatable').find('.tt-delete,.tt-show-document,.tt-delete-list-item').addClass('disabled');
            $(this).parents('.tt-content-datatable').find('.tt-show-document').removeAttr('href');
        }

        $(this).parents('.modal-content').find('.widget-dialog-title').addClass('hide');
        $(this).parents('.modal-content').find('.widget-dialog-content').removeClass('hide');

        if ($(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable()[0].id === "table_data_views_units") {

			$(this).parents('.modal-content').find('[name="selected_id"]').val(aData[0]);
			$(this).parents('.modal-content').find('[name="unit"]').val(aData[2]);
			if (!utils.isUndefined(aData[3]) && aData[3] !== '') {
				$(this).parents('.modal-content').find('[name="conversion_factor"]').val(utils.numberToString(parseFloat(aData[3])));
            } else {
				$(this).parents('.modal-content').find('[name="conversion_factor"]').val('');
            }
			$(this).parents('.modal-content').find('[name="display_decimals"]').val(aData[4]);
			$(this).parents('.modal-content').find('[name="conversion_formula"]').val(aData[5]).trigger('change.select2');

			jQuery.each($(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable().fnGetNodes(), function (i, val) {
				if (val.children[0].children[0].children[0].checked) {
					if (aData[2] === val.children[1].textContent) {
						$(this).parents('.modal-content').find('[name="conversion_factor_default_unit"]').addClass('hide');
						$(this).parents('.modal-content').find('[name="conversion_factor"]').prop('disabled', 'disabled');
						$(this).parents('.modal-content').find('[name="conversion_factor"]').parent().addClass('state-disabled');
						$(this).parents('.modal-content').find('[name="conversion_formula"]').prop('disabled', 'disabled');
					} else {
						$(this).parents('.modal-content').find('[name="conversion_factor_default_unit"]').removeClass('hide');
						$(this).parents('.modal-content').find('[name="conversion_factor_default_unit"]').text(aData[2] + ' = 1 ' + val.children[1].textContent);
						$(this).parents('.modal-content').find('[name="conversion_factor"]').prop('disabled', '');
						$(this).parents('.modal-content').find('[name="conversion_factor"]').parent().removeClass('state-disabled');
						$(this).parents('.modal-content').find('[name="conversion_formula"]').prop('disabled', '');
					}
				}
			});

		} else if ($(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable()[0].id === "table_data_views_display_restrictions") {

			$(this).parents('.modal-content').find('[name="selected_id"]').val(aData[0]);
			$(this).parents('.modal-content').find('[name="display_restriction_data_collection_type"]').val(aData[4]).trigger('change.select2');
			if (utils.isUndefined(aData[2]) || aData[2] === '') {
				$(this).parents('.modal-content').find('[name="display_restriction_from_date"]').data('picker').setDate(null);
			} else {
				$(this).parents('.modal-content').find('[name="display_restriction_from_date"]').data('picker').setDate(aData[2]);
            }
			if (utils.isUndefined(aData[3]) || aData[3] === '') {
				$(this).parents('.modal-content').find('[name="display_restriction_till_date"]').data('picker').setDate(null);
			} else {
				$(this).parents('.modal-content').find('[name="display_restriction_till_date"]').data('picker').setDate(aData[3]);
			}
			if (utils.isUndefined(aData[5]) || aData[5] === '') {
				$(this).parents('.modal-content').find('[name="display_restriction_repetition_column"]').val(null).trigger('change.select2');
			} else {
				$(this).parents('.modal-content').find('[name="display_restriction_repetition_column"]').val(aData[5]).trigger('change.select2');
            }
			if (utils.isUndefined(aData[6]) || aData[6] === '') {
				$(this).parents('.modal-content').find('[name="date_range_display_restriction_id"]').val('');
			} else {
				$(this).parents('.modal-content').find('[name="date_range_display_restriction_id"]').val(aData[6]);
			}

        } else if ($(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable()[0].id === "table_data_views_integrities" || $(this).parents('.tt-datatable-detail,.tt-datatable-dialog').dataTable()[0].id === "table_data_views_restrictions") {

            integrities.setIntegritySavedValues(this, aData);
        }
    });

    // Tabellen (Detail) einzelne Zelle
    $('body').on('click', '.tt-datatable-select-cell tbody td', function (e) {

        if ($(this).parents('table').length && $(this).parents('table')[0].id === 'table_merge_conflicts_hidden' && $(this).index() === 0) {
            return;
        }

        if ($(this).hasClass('selected-cell')) {
            $(this).removeClass('selected-cell');
        } else {
            $(this).parents('tr').find('td').removeClass('selected-cell');
            $(this).addClass('selected-cell');
        }
    });

    // Tabellen (Detail) Checkbox
    $('body').on('change', '.tt-checkbox-datatable', function (e) {

        if ($(this).parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
            $(this).parents('.tt-content-detail').find('.tt-datatable-changes').val("changed");
            $("#content-detail").find('form').trigger('checkform.areYouSure');
        }

        // Die Detail-Tabelle der Rollen kann ebenfalls in einer größeren Übersicht (modaler Dialog) bearbeitet werden
        // an dieser Stelle muss dann allerdings nicht die Form der Übersicht / des modalen Dialogs, sondern die Form der Detail-Ansicht verwendet werden
        if ($(this).parents('form').length && $(this).parents('form')[0].id === 'table_role_rights_overview_form') {
            if ($(this).parents('.tt-content').find('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
                $(this).parents('.tt-content').find('.tt-content-detail').find('.tt-datatable-changes').val("changed");
                $("#content-detail").find('form').trigger('checkform.areYouSure');
            }
        }

        var aCurrentLevel = 0;

        if ($(this).parents('tbody tr').length && !utils.isUndefined($(this).parents('tbody tr')[0].dataset)) {
            aCurrentLevel = $(this).parents('tbody tr')[0].dataset.ttLevel;
        }

        var tr = $(this).parents('tbody tr');
        var aCurrentCheckbox = $(this)[0].children[0];
        var aCurrentPos = 0;
        var aPos = 0;
        if (tr.length) {
            aCurrentPos = $(this).parents('.tt-datatable,.tt-datatable-dialog,.tt-datatable-detail').dataTable().fnGetPosition(tr[0]);
            aPos = $(this).parents('.tt-datatable,.tt-datatable-dialog,.tt-datatable-detail').dataTable().fnGetPosition(tr[0]);
        }

        var table_id = '';
        if (tr.parents('.tt-datatable-detail').length > 0) {
            table_id = tr.parents('.tt-datatable-detail')[0].id;
        }

        // Kinder anhaken / abhaken
        while ((tr.length > 0 && parseInt(tr[0].dataset.ttLevel) > parseInt(aCurrentLevel)) || aPos === aCurrentPos) {

            if (aCurrentCheckbox.checked) {
                if (aCurrentCheckbox.name === "all_rights") {
                    jQuery.each(tr.find('.tt-checkbox-datatable'), function (i, val) {
                        if (val.children[0].name !== "create_query" && val.children[0].name !== "close_query" && val.children[0].name !== "delete_query") {
                            if (!((table_id === 'table_export_data_views' || table_id === 'table_database_export_tables') && val.children[0].disabled)) {
                                val.children[0].checked = true;
                            }
                        }
                    });
                } else {
                    jQuery.each(tr.find('.tt-checkbox-datatable'), function (i, val) {
                        if (val.children[0].name === aCurrentCheckbox.name) {
                            if (!((table_id === 'table_export_data_views' || table_id === 'table_database_export_tables') && val.children[0].disabled)) {
                                val.children[0].checked = true;
                            }
                        }
                    });

                    var allChecked = true;
                    jQuery.each(tr.find('.tt-checkbox-datatable'), function (i, val) {
                        if (val.children[0].name !== "create_query" && val.children[0].name !== "close_query" && val.children[0].name !== "delete_query" && val.children[0].name !== "all_rights" && !val.children[0].checked) {
                            allChecked = false;
                        }
                    });

                    if (allChecked) {
                        if (tr.find("#right_all_rights").length) {
                            tr.find("#right_all_rights")[0].children[0].checked = true;
                        }
                    }
                }
            }
            else if (!aCurrentCheckbox.checked) {
                if (aCurrentCheckbox.name !== "create_query" && aCurrentCheckbox.name !== "close_query" && aCurrentCheckbox.name !== "delete_query") {
                    jQuery.each(tr.find('.tt-checkbox-datatable'), function (i, val) {
                        if (val.children[0].name === aCurrentCheckbox.name || val.children[0].name === "all_rights") {
                            val.children[0].checked = false;
                        }
                    });
                } else {
                    jQuery.each(tr.find('.tt-checkbox-datatable'), function (i, val) {
                        if (val.children[0].name === aCurrentCheckbox.name) {
                            val.children[0].checked = false;
                        }
                    });
                }
            }

            aPos = aPos + 1;
            tr = $(this).parents('.tt-datatable,.tt-datatable-dialog,.tt-datatable-detail').find('tbody tr').eq(aPos);
        }

        tr = $(this).parents('tbody tr');
        aPos = aCurrentPos;

        // wieder entfernt, da Rechte setzen für obere Elemente (z.B. Tabs, Spalten) nicht funktioniert

        // Eltern abhaken
        //if (!aCurrentCheckbox.checked) {
        //
        //  for (var i = aPos; i >= 0; i--) {
        //
        //      if (tr[0].id.split('|')[0] === ids[1] && aPos !== aCurrentPos) {
        //
        //          if (aCurrentCheckbox.name !== "create_query" && aCurrentCheckbox.name !== "close_query") {
        //              jQuery.each(tr.find('.tt-checkbox-datatable'), function (i, val) {
        //                  if (val.children[0].name === aCurrentCheckbox.name || val.children[0].name === "all_rights") {
        //                      val.children[0].checked = false;
        //                  }
        //              });
        //          } else {
        //              jQuery.each(tr.find('.tt-checkbox-datatable'), function (i, val) {
        //                  if (val.children[0].name === aCurrentCheckbox.name) {
        //                      val.children[0].checked = false;
        //                  }
        //              });
        //          }
        //
        //          if (tr[0].id.split('|')[1] === 0) {
        //              break;
        //          }
        //
        //          ids = tr[0].id.split('|');
        //      }
        //
        //      aPos = aPos - 1;
        //      tr = $(this).parents('.tt-datatable,.tt-datatable-dialog').find('tbody tr').eq(aPos);
        //  }
        //}

        // Eingabehilfe beim Export und Patient wiederherstellen Haken wieder entfernen
        if (!aCurrentCheckbox.checked) {
            if ($(aCurrentCheckbox).parents('.tt-datatable-detail').find('.tt-export-all-items').length) {
                $(aCurrentCheckbox).parents('.tt-datatable-detail').find('.tt-export-all-items')[0].checked = false;
            }
            if ($(aCurrentCheckbox).parents('.tt-datatable-data').find('.tt-restore-all-patients').length) {
                $(aCurrentCheckbox).parents('.tt-datatable-data').find('.tt-restore-all-patients')[0].checked = false;
            }
        }
    });

    // Tabellen (Laboreinheiten) Checkbox
    $('body').on('change', '.tt-checkbox-units', function (e) {
        e.preventDefault();

        var element = $(this);
        var tr = $(this).parents('tbody tr');
        var aPos = $(this).parents('.tt-datatable-dialog').dataTable().fnGetPosition(tr[0]);
        var conversion_factor = $(this).parents('.tt-datatable-dialog').dataTable().fnGetData(aPos)[3];
        var conversion_formula = $(this).parents('.tt-datatable-dialog').dataTable().fnGetData(aPos)[5];

        if (!element[0].checked) {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_default_unit'),
                content: Lang.get('tripletrax.delete_default_unit_not_possible_desc'),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
            });
            event.stopPropagation();
            element[0].checked = true;
            return;
        }

        $.SmartMessageBox({
            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_default_unit'),
            content: Lang.get('tripletrax.change_default_unit_desc'),
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === Lang.get('tripletrax.yes')) {

                jQuery.each(element.parents('.tt-datatable-dialog').dataTable().fnGetNodes(), function (i, val) {
                    if (i === aPos) {
                        val.children[2].textContent = '1.00';
                        element.parents('.tt-datatable-dialog').dataTable().fnGetData(i)[3] = '1';
                        element.parents('.tt-datatable-dialog').dataTable().fnGetData(i)[5] = '';
                        element.parents('.tt-datatable-dialog').dataTable().fnGetData(i)[6] = '';
                        element.parents('.modal-content').find('[name="conversion_factor_default_unit"]').addClass('hide');
                        element.parents('.modal-content').find('[name="conversion_factor"]').val('1');
						element.parents('.modal-content').find('[name="conversion_formula"]').val(null).trigger('change.select2');
                    } else {
                        val.children[0].children[0].children[0].checked = false;
                        if (conversion_formula !== '') {
							element.parents('.tt-datatable-dialog').dataTable().fnGetData(i)[3] = '';
							var new_conversion_formula = '';
							var new_conversion_formula_desc = '';
							if (conversion_formula == 'percent_to_mmol_mol') {
								new_conversion_formula = 'mmol_mol_to_percent';
							} else {
								new_conversion_formula = 'percent_to_mmol_mol';
                            }

                            $.each(element.parents('.modal-content').find('[name="conversion_formula"]').find('option'), function(i, option) {
                               if (option.value == new_conversion_formula)  {
								   new_conversion_formula_desc = option.text;
                               }
                            });
							element.parents('.tt-datatable-dialog').dataTable().fnGetData(i)[5] = new_conversion_formula;
							element.parents('.tt-datatable-dialog').dataTable().fnGetData(i)[6] = new_conversion_formula_desc;
							val.children[2].textContent = new_conversion_formula_desc;
                        } else {
							var x = new BigNumber(val.children[2].textContent);
							var y = new BigNumber(conversion_factor);
							val.children[2].textContent = x.div(y).toNumber();
							element.parents('.tt-datatable-dialog').dataTable().fnGetData(i)[3] = x.div(y).toNumber();
						}
                    }
                });

                element.parents('.tt-datatable-dialog').dataTable().fnStandingRedraw();
            } else {
                element[0].checked = false;
            }
        });
    });

    // Tabellen (Detail) Zeile Doppelklick
    $('body').on('dblclick', '.tt-datatable-detail tbody tr', function (e) {
        e.preventDefault();

        if ($(this).parents('.tt-content-detail').find('.tt-locked-user').length == 0 || $(this).parents('.tt-content-detail').find('.tt-locked-user').val() === "") {
            var aPos = $(this).parents('.tt-datatable-detail').dataTable().fnGetPosition(this);
            var aData = $(this).parents('.tt-datatable-detail').dataTable().fnGetData(aPos);

            if ($(this).parents('.tt-datatable-detail')[0].id === "table_users_roles") {

                $('#table_users_roles_form').find('select.tt-select2').val(aData[0]).trigger('change.select2');
                $('#table_users_roles_form').find('select.tt-select2').prop('disabled', 'disabled');

                var role_ids = aData[3].split(',');

                jQuery.each(role_ids, function (i, val) {
                    $('.tt-checkbox-role-' + val.trim(), $('#table_users_roles_form').find('.tt-datatable-dialog').dataTable().fnGetNodes()).prop('checked', true);
                });

                $(this).parents('.tt-content-detail').find('.tt-dialog-open').click();

            } else if ($(this).parents('.tt-datatable-detail')[0].id === "table_data_collection_type_integrities") {

                integrities.setIntegritySavedValues($('#table_collection_type_integrities_form'), aData);

                $('#table_collection_type_integrities_form').find('[name="selected_id"]').val(aData[0]);

                $(this).parents('.tt-content-detail').find('.tt-dialog-open').click();

            } else if ($(this).parents('.tt-datatable-detail')[0].id === "table_locked_periods") {

                $('#table_locked_period_form').find('[name="freeze_facility_data_locked_period_from"]').data('picker').setDate(aData[4]);
                $('#table_locked_period_form').find('[name="freeze_facility_data_locked_period_till"]').data('picker').setDate(aData[5]);

                $('#table_locked_period_form').find('[name="selected_id"]').val(aData[0]);

                $(this).parents('.tt-content-datatable').find('.tt-dialog-open').click();

            } else if ($(this).parents('.tt-datatable-detail')[0].id === "table_locked_patients") {

                $('#table_locked_patient_form').find('[name="freeze_facility_data_locked_patient"]').val(aData[4]).trigger('change.select2');

                $('#table_locked_patient_form').find('[name="selected_id"]').val(aData[0]);

                $(this).parents('.tt-content-datatable').find('.tt-dialog-open').click();

            }
        }
    });

    // Speichern Button / Speichern Button (Dialog Neu)
    $('body').on('click', '.tt-save-examination', function (e) {
        e.preventDefault();

        var element = $(this);

        if (utils.GLOBALS.timerIntegrity) {
            clearTimeout(utils.GLOBALS.timerIntegrity); //cancel the previous timer.
            utils.GLOBALS.timerIntegrity = null;
            views.checkIntegrity($.merge([], utils.GLOBALS.integrityControlList), true, false, null, true);
        }

        $.when.apply($, $.merge([], utils.GLOBALS.runningAjaxRequests)).done(function () {
            clickSubmitButton(element);
        });
    });

    // Speichern Button / Speichern Button (Dialog Neu)
    $('body').on('click', '.tt-save', function (e) {
        e.preventDefault();

        clickSubmitButton($(this));
    });

    // Speichern Button - Zweites Widget
    $('body').on('click', '.tt-save-sub-form', function (e) {
        e.preventDefault();

        $('#content-detail').find('.tt-content-detail').find('.tt-save').click();
    });

    // Abbrechen Button (Dialog)
    $('body').on('click', '.tt-dialog-cancel', function (e) {
        e.preventDefault();
    });

    // Abbrechen Button
    $('body').on('click', '.tt-cancel', function (e) {
        e.preventDefault();

        var element = $(this);

        ajax.ajaxCall($(this)[0].getAttribute("action"), $(this)[0].getAttribute("method"), null, false, function (data) {

            $('#content').find('.tt-content-datatable').find('.tt-datatable-search').val("");
            $('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnFilterClear();
            $('#content').find('.tt-content-datatable').find('.tt-delete,.tt-roles-overview').addClass('disabled');
            utils.setHtmlData($("#content-detail"), data, true);
        });
    });

    // Abbrechen Button - Zweites Widget
    $('body').on('click', '.tt-cancel-sub-form', function (e) {
        e.preventDefault();

        $('#content-detail').find('.tt-content-detail').find('.tt-cancel').click();
    });

    // Benutzer sperren Button
    $('body').on('click', '.tt-lock-user', function (e) {
        e.preventDefault();

        var element = $(this);

        ajax.ajaxCall($(this)[0].getAttribute('action'), $(this)[0].getAttribute('method'), null, false, function (data) {
            $('#content').find('.tt-content-datatable').find('.tt-datatable').dataTable().fnStandingRedraw();
            utils.setHtmlData($("#content-detail"), data, true);
        });
    });

    // Dokument anzeigen
    $('body').on('click', '.tt-show-document', function (e) {
        e.preventDefault();

        if ($(this).attr('href') !== '#') {
            window.open($(this).attr('href'), '_blank');
        } else {
            $(this).parent().find('ul').find('li').find('a').addClass('document-show-dropdown-element');
            $(this).parent().find('ul').find('li').find('a').removeClass('document-print-dropdown-element');
        }
    });

    // Dokument drucken
    $('body').on('click', '.tt-print-document', function (e) {
        e.preventDefault();

        if ($(this).attr('href') !== '#') {
            var print_document = window.open($(this).attr('href'), '_blank');
            print_document.print();
        } else {
            $(this).parent().find('ul').find('li').find('a').addClass('document-print-dropdown-element');
            $(this).parent().find('ul').find('li').find('a').removeClass('document-show-dropdown-element');
        }
    });

    // Dokument auswählen (Open-Folder-Dialog anzeigen)
    $('body').on('click', '.tt-select-file', function (e) {
        e.preventDefault();

        $('#file_upload')[0].click();
    });

    // Dokument auswählen (Übernahme des Dateinamens in das Input-Feld)
    $('body').on('change', '#file_upload', function (e) {
        $('#document_filename').val($('#file_upload')[0].files[0].name);
    });

    // Dialog schließen
    $('body').on('hide.bs.modal', '.tt-content-dialog', function (e) {
        if (!utils.isUndefined($(this).find('form')[0])) {

            // Diese Forms haben keinen Submit-Button, lediglich einen Schließen-Button (Ähnlich dem Abbrechen-Button)
            if ($(this).find('form')[0].id === 'table_data_views_roles_form') {

                var data = '';

                jQuery.each($('#table_data_views_roles').dataTable().fnGetNodes(), function (i, modal_val) {
                    jQuery.each($('#table_data_view_properties').find('.tt-right'), function (k, val) {
                        if (val.getAttribute('data-tt-id') === 'role_rights_' + modal_val.id.substring(0, modal_val.id.indexOf('|'))) {

                            $(val).empty();

                            if ($(val).hasClass('hide')) {
                                $(val).removeClass('hide');
                            }

                            if (i > 0) {
                                data = data + '|';
                            }

                            var html = '';
                            var current_data = '';
                            jQuery.each(modal_val.children, function (j, val_child) {

                                if (current_data !== '' && current_data.substr(-1) !== ',') {
                                    current_data = current_data + ',';
                                }

                                if (j > 0) {
                                    if (val_child.childNodes[0].children[0].checked) {
                                        if ($(modal_val).find('#right_all_rights')[0].childNodes[0].checked) {

                                            if (val_child.childNodes[0].children[0].name === 'all_rights') {
                                                html += '<i class="fad fa-check" style="color:#96bf48"></i>  ';
                                                current_data += 'all_rights.1,read.1,write.1,update.1,delete.1,export.1,audittrail.1,answer_query.1';
                                            }

                                            if (val_child.childNodes[0].children[0].name === 'create_query') {
                                                html += '<i class="fad fa-file" style="color:#ac5287"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'close_query') {
                                                html += '<i class="fad fa-file-excel" style="color:#ac5287"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'delete_query') {
                                                html += '<i class="fad fa-trash-alt" style="color:#ac5287"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                        } else {
                                            if (val_child.childNodes[0].children[0].name === 'read') {
                                                html += '<i class="fad fa-search" style="color:#57889c"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'write') {
                                                html += '<i class="fad fa-plus" style="color:#96bf48"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'update') {
                                                html += '<i class="fad fa-pencil-alt" style="color:#E2B14A"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'delete') {
                                                html += '<i class="fad fa-trash-alt" style="color:#DB4A67"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'export') {
                                                html += '<i class="fad fa-upload" style="color:#3276b1"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'audittrail') {
                                                html += '<i class="fad fa-history"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'create_query') {
                                                html += '<i class="fad fa-file" style="color:#ac5287"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'answer_query') {
                                                html += '<i class="fad fa-file-alt" style="color:#ac5287"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'close_query') {
                                                html += '<i class="fad fa-file-excel" style="color:#ac5287"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                            if (val_child.childNodes[0].children[0].name === 'delete_query') {
                                                html += '<i class="fad fa-trash-alt" style="color:#ac5287"></i>  ';
                                                current_data += val_child.childNodes[0].children[0].name + ".1";
                                            }
                                        }
                                    } else {
                                        current_data += val_child.childNodes[0].children[0].name + ".0";
                                    }
                                }
                            });

                            if (html !== '') {
                                html = '<td colspan="3" style="width:100%"><span class="indenter" style="padding-left: 15px;"></span>- ' + val.getAttribute('data-name') + ' ' + html + '</i></td>';
                                $(html).appendTo(val);
                                $(val).removeClass('hide');
                            } else {
                                html = '<td colspan="3" style="width:100%"><span class="indenter" style="padding-left: 15px;"></span>- ' + val.getAttribute('data-name') + '</i></td>';
                                $(html).appendTo(val);
                                $(val).addClass('hide');
                            }

                            data += modal_val.id.substring(0, modal_val.id.indexOf('|')) + "//" + modal_val.getAttribute('data-role-id') + "--" + current_data;

                            return false;
                        }
                    });
                });

                var editRoleButtonId = $(this).find('[name="button_id"]').val();
                var editRoleButton = $("#content-detail").find('#' + editRoleButtonId);

                if (editRoleButton.length) {
                    var dialogId = $(editRoleButton).attr('href');
                    var input = $("#content-detail").find('[name="' + editRoleButtonId.substring(editRoleButtonId.indexOf('_') + 1) + '"]');
                    input.val(data);
                }

                $("#content-detail").find('form').trigger('checkform.areYouSure');

            } else if ($(this).find('form')[0].id === 'table_data_views_units_form') {

                var contentString = '';
                var editUnitButtonId = $(this).find('[name="button_id"]').val();
                var editUnitButton = $("#content-detail").find('#' + editUnitButtonId);
                var tr = $("#content-detail").find('#' + editUnitButtonId).parents('tr');
                var parent_id = tr[0].getAttribute('data-tt-parent-id');

                $('#table_data_view_properties').find('.tt-unit' + editUnitButtonId.replace('button_edit_units', '')).remove();

                var default_unit_string = '';
                jQuery.each($('#table_data_views_units').dataTable().fnGetNodes(), function (i, modal_val) {
                    var modal_data = $('#table_data_views_units').dataTable().fnGetData(i);

                    if (i > 0) {
                        contentString = contentString + '|';
                    }

                    var default_unit = '';
                    if (modal_val.children[0].children[0].children[0].checked) {
                        default_unit = '(' + Lang.get('tripletrax.default_unit') + ')';
                    }

                    var html = '<tr class="tt-unit' + editUnitButtonId.replace('button_edit_units', '') + '" data-tt-id="lab_units_' + modal_data[0] + '" data-tt-parent-id="' + parent_id + '" ' + 'data-name="' + modal_data[2] + '">';
                    html += '<td colspan="3" style="width:100%">- ' + modal_data[2] + ' ' + default_unit + '</i>';
                    html += '</td>';
                    html += '</tr>';

                    if (modal_val.children[0].children[0].children[0].checked) {
                        default_unit_string = html;
                    } else {
                        $("#table_data_view_properties").treetable("loadBranch", $("#table_data_view_properties").treetable("node", tr[0].getAttribute('data-tt-id')), html);
                    }

                    contentString += modal_data[0] + '#' + modal_val.children[0].children[0].children[0].checked + '#' + modal_data[2] + '#' + modal_data[3] + '#' + modal_data[4] + '#' + modal_data[5] + '#' + modal_data[6];
                });

                if (default_unit_string !== '') {
                    // Standardeinheit soll immer ganz oben stehen
                    $("#table_data_view_properties").treetable("loadBranch", $("#table_data_view_properties").treetable("node", tr[0].getAttribute('data-tt-id')), default_unit_string);
                }

                if (editUnitButton.length) {
                    var dialogId = $(editUnitButton).attr('href');
                    var input = $("#content-detail").find('[name="' + editUnitButtonId.substring(editUnitButtonId.indexOf('_') + 1) + '"]');
                    input.val(contentString);
                }

                if (editUnitButtonId === 'button_edit_units') {

                    setInputNoComplicationsAndNotCollectedFormatValues();
                }

                $("#content-detail").find('form').trigger('checkform.areYouSure');

			} else if ($(this).find('form')[0].id === 'table_data_views_display_restrictions_form') {

				var contentString = '';
				var editDisplayRestrictionButtonId = $(this).find('[name="button_id"]').val();
				var editDisplayRestrictionButton = $("#content-detail").find('#' + editDisplayRestrictionButtonId);
				var tr = $("#content-detail").find('#' + editDisplayRestrictionButtonId).parents('tr');
				var parent_id = tr[0].getAttribute('data-tt-parent-id');

				$('#table_data_view_properties').find('.tt-display-restriction' + editDisplayRestrictionButtonId.replace('button_edit_display_restriction_rules', '')).remove();

				jQuery.each($('#table_data_views_display_restrictions').dataTable().fnGetNodes(), function (i, modal_val) {
					var modal_data = $('#table_data_views_display_restrictions').dataTable().fnGetData(i);

					if (i > 0) {
						contentString = contentString + '|';
					}

					var display_text = '';
					if (!utils.isUndefined(modal_data[2]) && modal_data[2] !== '') {
						display_text = trans('tripletrax.from_date', {'from_date': utils.dateToLocaleString(modal_data[2])});
                    }
					if (!utils.isUndefined(modal_data[3]) && modal_data[3] !== '') {
					    if (display_text.length > 0) {
					        display_text += ' ';
                        }
						display_text += trans('tripletrax.till_date', {'till_date': utils.dateToLocaleString(modal_data[3])});
					}
					if (!utils.isUndefined(modal_data[5]) && modal_data[5] !== '') {
						if (display_text.length > 0) {
							display_text += ' ';
						}
						display_text += '(' + trans('tripletrax.data_views_column') + ' ' + modal_data[5] + ')';
					}

					var html = '<tr class="tt-display-restriction' + editDisplayRestrictionButtonId.replace('button_edit_display_restriction_rules', '') + '" data-tt-id="display_restrictions_' + modal_data[0] + '" data-tt-parent-id="' + parent_id + '" ' + 'data-name="' + modal_data[1] + '">';
					html += '<td colspan="3" style="width:100%">- ' + modal_data[1] + ": " + display_text + '</i>';
					html += '</td>';
					html += '</tr>';

					$("#table_data_view_properties").treetable("loadBranch", $("#table_data_view_properties").treetable("node", tr[0].getAttribute('data-tt-id')), html);

					contentString += modal_data[0] + '#' + modal_data[1] + '#' + modal_data[2] + '#' + modal_data[3] + '#' + modal_data[4] + '#' + modal_data[5] + '#' + modal_data[6];
				});

				if (editDisplayRestrictionButton.length) {
					var dialogId = $(editDisplayRestrictionButton).attr('href');
					var input = $("#content-detail").find('[name="' + editDisplayRestrictionButtonId.substring(editDisplayRestrictionButtonId.indexOf('_') + 1) + '"]');
					input.val(contentString);
				}

				$("#content-detail").find('form').trigger('checkform.areYouSure');

            } else if ($(this).find('form')[0].id === 'table_data_views_calculation_form') {

                var calculationButtonId = $(this).find('[name="button_id"]').val();
                var calculationButton = $("#content-detail").find('#' + calculationButtonId);
                var matchFieldList = {};

                if (calculationButton.length) {
                    var dialogId = $(calculationButton).attr('href');
                    var input = $("#content-detail").find('[name="' + calculationButtonId.substring(calculationButtonId.indexOf('_') + 1) + '"]');

                    var contentString = 'false';
                    if ($(dialogId).find('[name="calculation_only_when_all_fields_are_filled"]').is(':checked')){
                        contentString = 'true';
                    }
                    jQuery.each($(dialogId).find('.tt-calculation-row:not(.hide)'), function (i, val) {
                        contentString += '|' + $(this).data().usedField + ':' + $(this).find('.tt-select2').select2('val');
                    });
                    jQuery.each($(dialogId).find('.tt-calculation-dynamic-row:not(.hide)'), function (i, val) {
                        contentString += '|' + $(this).find('.tt-select2').select2('val');
                    });
                    if ($('.tt-calculation-row-match-field:not(.hide)').length) {
						jQuery.each($(dialogId).find('.tt-calculation-row-match-field:not(.hide)'), function (i, val) {
							contentString += '|match_field:' + $(this).find('.tt-select2').select2('val') + '|';
						});
						jQuery.each($(dialogId).find('.tt-calculation-dynamic-match-list-row:not(.hide)'), function (i, val) {
							matchFieldList[$(this).find('[name="score_value"]').val()] = $(this).find('[name="match_list_value"]').val();
						});

						contentString += JSON.stringify(matchFieldList);
					}

                    input.val(contentString);

                    var inputCorrect = $("#content-detail").find('[name="' + calculationButtonId.substring(calculationButtonId.indexOf('_') + 1) + '_correct"]');
                    utils.updateGlobals('showValidationErrorMessageBox', false);
                    if (!$(dialogId).find('.tt-validation-form').valid()) {
                        inputCorrect.val('fails');
                    } else {
                        inputCorrect.val('');
                    }
                    utils.updateGlobals('showValidationErrorMessageBox', true);

                    // Validierung für die Felder der Berechnung erneut durchführen
                    var nameAppendix = calculationButtonId.replace('button_edit_calculation', '');
                    validator.triggerValidation($("#content-detail").find('[name="calculation' + nameAppendix + '"]')[0], true, true);
                }

            } else if ($(this).find('form')[0].id === 'table_data_views_help_form') {

                var helpButtonId = $(this).find('[name="button_id"]').val();
                var helpButton = $("#content-detail").find('#' + helpButtonId);

                if (helpButton.length) {
                    var dialogId = $(helpButton).attr('href');
                    var textarea = $("#content-detail").find('[name="' + helpButtonId.substring(helpButtonId.indexOf('_') + 1) + '"]').parents('tr').find('textarea[name^="help"]');

                    textarea.val($(dialogId).find('textarea[name="help"]').val());
                }

            } else if ($(this).find('form')[0].id === "table_patient_agreement_create_form") {

                $('#table_patient_agreement_create_dialog').find('.tripletrax-modal-title').text(trans('tripletrax.add_agreement'));

            } else if ($(this).find('form')[0].id === 'table_role_rights_overview_form') {

                // Tabelle wieder in Detail-Ansicht kopieren und Größe anpassen
                var fieldSetModalDialog = $('#fieldset_table_role_rights').detach();
                fieldSetModalDialog.appendTo('#fieldset_role_rights');
                $('#fieldset_table_role_rights')[0].style.height = '263px';

            } else if ($(this).find('form')[0].id === 'password_change_form') {

                $(this).find('form .note-error').remove();

			} else if ($(this).find('form')[0].id === 'table_aggregation_create_form') {

                $(this).find('form .tt-aggregation-rule-dynamic-row:not(.hide)').remove();
                $(this).find('form .tt-aggregation-edit-control-values').addClass('hide');
                $(this).find('form .tt-aggregation-edit-field-conversions').addClass('hide');

            } else if ($(this).find('form')[0].id === 'table_patient_examination_create_form') {

                views.resetControl($(this).find('[name="exam_date"]'), true);
                $(this).find('.tt-save-examination').removeClass('disabled');

			} else {

                if ($(this).find('.dd').length) {
                    $(this).find('.dd-list').find('.tt-button-nestable').addClass('hide');
                    $(this).find('.dd-list').find('.dd3-content').removeClass('dd-content-active');

                    $(this).find('.tt-save-value-nestable').addClass('disabled');
                    $(this).find('.tt-delete-value-nestable').addClass('disabled');

                    var editControlTypeButtonId = $(this).find('[name="button_id"]').val();
                    var editControlTypeButton = $("#content-detail").find('#' + editControlTypeButtonId);

                    if (editControlTypeButton.length) {
                        var isMultiple = /^combo_multiselect/.test($('[name="control_type"]').val());
                        var dialogId = $(editControlTypeButton).attr('href');
                        var input = $("#content-detail").find('[name="' + editControlTypeButtonId.substring(editControlTypeButtonId.indexOf('_') + 1) + '"]');
                        var noComplications = $("#content-detail").find('[data-name="no_complications_value"]').find('td')[1];
                        var currentSelectionNoComplications = $(noComplications).find('.tt-select2').select2('val');
                        var notCollected = $("#content-detail").find('[data-name="not_collected_value"]').find('td')[1];
                        var currentSelectionNotCollected = $(notCollected).find('.tt-select2').select2('val');

                        var data = [];
                        var content = [];
                        var foundSelectionNoComplications = false;
                        var foundSelectionNotCollected = false;
                        if (isMultiple) {
                            foundSelectionNoComplications = true;
                            foundSelectionNotCollected = true;
                        }
                        var defaultSelectionNotCollected = '';
                        jQuery.each($(dialogId).find('.dd').nestable('serializeContent'), function (i, val) {
                            content.push(val);

                            if (editControlTypeButtonId === 'button_edit_control_type') {
                                if (!val.isDeleted) {
                                    data.push({ id: val.valueInDatabase, text: val.value, match: val.match, inactive: val.inactive });
                                    if (!isMultiple) {
                                        if (currentSelectionNoComplications == val.valueInDatabase) {
                                            foundSelectionNoComplications = true;
                                        }
                                        if (currentSelectionNotCollected == val.valueInDatabase) {
                                            foundSelectionNotCollected = true;
                                        }
                                    }
                                    if (val.match === 'not_collected') {
                                        defaultSelectionNotCollected = val.valueInDatabase;
                                    }
                                }
                            }
                        });

                        input.val(JSON.stringify(content));

                        if (editControlTypeButtonId === 'button_edit_control_type') {

                            var additionalClass = ' tt-view-combo';
                            if (isMultiple) {
                                additionalClass = ' tt-combo-multiselect';
                            }

                            validator.reinitializeSelect2($(noComplications), 'tt-select2 tt-select2-data-view-property select2-container' + additionalClass, '', data, isMultiple);
                            if (foundSelectionNoComplications) {
                                $(noComplications).find('.tt-select2').val(currentSelectionNoComplications).trigger('change.select2');
                            }

                            validator.reinitializeSelect2($(notCollected), 'tt-select2 tt-select2-data-view-property select2-container' + additionalClass, '', data, isMultiple);
                            if (foundSelectionNotCollected) {
                                $(notCollected).find('.tt-select2').val(currentSelectionNotCollected).trigger('change.select2');
                            } else if (defaultSelectionNotCollected !== '') {
                                $(notCollected).find('.tt-select2').val(defaultSelectionNotCollected).trigger('change.select2');
                            }
                        }

                        // Validierung für die Ausprägungen erneut durchführen
                        var nameAppendix = editControlTypeButtonId.replace('button_edit_control_type', '');
                        validator.triggerValidation($("#content-detail").find('[name="control_type' + nameAppendix + '"]')[0], true, true);
                    }
                }
            }

            // Form zurücksetzen
            integrities.resetForm(this);
        }
    });

    // Dialog anzeigen
    $('body').on('show.bs.modal', '.tt-content-dialog', function (e) {

        if ($(this)[0].id === "table_patient_agreement_create_dialog") {

            // Die Liste der Datenerhebungsarten neu befüllen
            if ($(this).find('.tt-selected-id').val() === '') {

                // Bei Neuanlage nur Datenerhebungsarten zur Auswahl bereitstellen, welche keine vorausgesetzten Datenerhebungsarten haben oder deren vorausgesetzte Datenerhebungsarten bereits zugeordnet sind
                var data = [];

                var existingModels = validator.getExistingPatientAgreements();

                var modelHierarchyArray = [];
                var alreadyAddedModels = [];
                $.each($.parseJSON($('#agreements_with_register_patient_right').val()), function (h, agreement) {

                    if (utils.stringToDate(agreement.valid_from) <= utils.stringToDate('today') && (utils.isUndefined(agreement.valid_till) || utils.stringToDate(agreement.valid_till) >= utils.stringToDate('today'))) {

                        var agreementModels = agreement.data_collection_types.split('|');
                        $.each(agreementModels, function (k, agreementModel) {

                            $.each($.parseJSON($('#models_with_register_patient_right').val()), function (i, model) {
                                var dependingModelExisting = validator.checkPatientAgreementExistingRecursive(model, $.parseJSON($('#models_with_register_patient_right').val()), existingModels, modelHierarchyArray);

                                if (dependingModelExisting) {

                                    // Datenerhebungsarten ermitteln, in welchen ich selbst als abhängige dokumentiert bin
                                    var otherDependingModels = '';
                                    $.each($.parseJSON($('#all_models').val()), function (j, dependingModel) {
                                        if (dependingModel.depending_models === '' || dependingModel.depending_models === '-1') {
                                            return true;
                                        }

                                        var dependingModels = dependingModel.depending_models.split('|');
                                        $.each(dependingModels, function (j, depModel) {
                                            if (depModel == model.id) {
                                                if (otherDependingModels !== '') {
                                                    otherDependingModels += '|';
                                                }
                                                otherDependingModels += dependingModel.id;
                                            }
                                        });
                                    });

                                    if (agreementModel == model.id && jQuery.inArray(agreement.id, alreadyAddedModels) < 0) {
                                        data.push({id: agreement.id, text: agreement.description, depending_models: model.depending_models, other_depending_models: otherDependingModels, models: agreement.data_collection_types});
                                        alreadyAddedModels.push(agreement.id);
                                    }
                                }
                            });
                        });
                    }
                });

                var modelField = $(this).find('[name="agreement_type"]').parent();

                validator.reinitializeSelect2($(modelField), 'input-sm tt-select2', '', data, false);

                // Automatische Anlage einer neuen Einwilligung (wenn beim Patient nur die ablaufende Einwilligung besteht)
                if ($(this).find('.tt-new-valid-agreement-id').val() !== '') {
                    $('#table_patient_agreement_create_form').find('[name="agreement_type"]').val($(this).find('.tt-new-valid-agreement-id').val()).trigger('change.select2');
                }

            }

        } else if ($(this)[0].id === "table_patient_examination_create_dialog") {

            // Die Uhrzeit je nach Einstellung anzeigen oder nicht
            if ($(this).find('.tt-selected-id').val() === '' || $(this).find('.tt-selected-id').val() === '0') {
                if ($(this).find('[name="show_examination_time"]').val() === 'true') {
                    $(this).find('.tt-show-examination-time-group').addClass('hide');
                    $(this).find('.tt-examination-time').removeClass('hide');
                } else {
                    $(this).find('.tt-show-examination-time-group').removeClass('hide');
                    $(this).find('.tt-examination-time').addClass('hide');
                }
            } else {
                if ($(this).find('[name="exam_time"]').val() !== '0:00' || $(this).find('[name="show_examination_time"]').val() === 'true') {
                    $(this).find('.tt-show-examination-time-group').addClass('hide');
                    $(this).find('.tt-examination-time').removeClass('hide');
                } else {
                    $(this).find('.tt-show-examination-time-group').removeClass('hide');
                    $(this).find('.tt-examination-time').addClass('hide');
                }
            }

			var master = utils.getMaster();
			var birthDate = '';
			if (master.find('[data-match-field="birth_date"]').length) {
				birthDate = utils.dateToString(master.find('[data-match-field="birth_date"]').data('picker').getDate());
			} else {
				var aPos = $('#table_patientlist').dataTable().fnGetPosition($('#table_patientlist').find('.selected-row')[0]);
				var aData = $('#table_patientlist').dataTable().fnGetData(aPos);
				birthDate = aData['birth_date'];
            }
			$(this).find('.tt-birth-date').val(birthDate);
        } else if ($(this)[0].id === "table_completeness_send_mail") {
			var filterSettings = {};
			//True wenn über die Selektion die Einrichtungen ausgewählt werden.
            var table = $('#table_completeness').DataTable();
			var data = [];
			var allData = table.data().toArray();
			table.rows().eq(0).each(function (index) {
                if ($(table.row(index).node()).hasClass('selected-row')) {
					data.push(table.row(index).data());
				}
			});

            if (data.length) {
				$(this).parents('#content-modal').find('[name="completeness_table"]').val(JSON.stringify(data));
				filterSettings["selected-row"] = true;
			} else {
				// Wenn nichts selektiert wurde, wird die komplette Tabelle mitgeschickt
				$(this).parents('#content-modal').find('[name="completeness_table"]').val(JSON.stringify(allData));
				filterSettings["selected-row"] = false;
            }
			filterSettings["data_collection_type_id"] = $('#data_collection_type_id_select').select2('val');
			filterSettings["from_date"] = utils.dateToString($('#from_date').data('picker').getDate());
			filterSettings["till_date"] = utils.dateToString($('#till_date').data('picker').getDate());
			filterSettings["data_type"] = $('[name="data_type"]').val();

			$(this).parents('#content-modal').find('[name="completeness_filter_setting"]').val(JSON.stringify(filterSettings));

        } else if ($(this)[0].id === "table_patient_administration_history_show_detail") {

            // Die Liste der Details der Zusammenführung neu befüllen
			var dataTable = $('#table_patient_administration_history').dataTable();
			var tr = dataTable.$('tr.selected-row');
			var aPos = dataTable.fnGetPosition(tr[0]);
			var aData = dataTable.fnGetData(aPos);

			$("#table_merge_patients_assumed_data").dataTable().fnClearTable();
			$("#table_merge_patients_assumed_data_hidden").dataTable().fnClearTable();
			$("#table_merge_patients_not_assumed_data").dataTable().fnClearTable();
			$("#table_merge_patients_not_assumed_data_hidden").dataTable().fnClearTable();

			if (aData["data"] !== '') {

			    var data = $.parseJSON(aData["data"]);

			    // Daten, welche bei der Zusammenführung übernommen wurden
				if (data.length >= 1) {
					// Tabelle zur Anzeige
					$.each(data[0], function (i, protocol) {
						$("#table_merge_patients_assumed_data").dataTable().fnAddData([
						    '',
							protocol[0],
							protocol[1],
							protocol[2]]
						);
					});
                    // Tabelle zum Drucken
					$.each(data[0], function (i, protocol) {
						$("#table_merge_patients_assumed_data_hidden").dataTable().fnAddData([
							'',
							protocol[0],
							protocol[1],
							protocol[2]]
						);
					});
				}

				// Daten, welche bei der Zusammenführung nicht übernommen wurden
				if (data.length >= 2) {
				    // Tabelle zur Anzeige
					$.each(data[1], function (i, protocol) {
						$("#table_merge_patients_not_assumed_data").dataTable().fnAddData([
							'',
							protocol[0],
							protocol[1],
							protocol[2]]
						);
					});
                    // Tabelle zum Drucken
					$.each(data[1], function (i, protocol) {
						$("#table_merge_patients_not_assumed_data_hidden").dataTable().fnAddData([
							'',
							protocol[0],
							protocol[1],
							protocol[2]]
						);
					});
                }
			}
		} else if ($(this)[0].id === "table_aggregation_control_values_dialog") {

			var parentForm = $(e.relatedTarget).parents('form');
			$(this).find('[name="aggregation_control_values_parent_form"]').val(parentForm[0].id);

			// Die Tabelle mit den Ausprägungen neu befüllen
			var data = [];
			var controlValues = {};

            if (!utils.isUndefined(parentForm) && parentForm.find($('[name="aggregation_control_values"]')).length && parentForm.find($('[name="aggregation_control_values"]')).val() !== '') {
				controlValues = JSON.parse(parentForm.find($('[name="aggregation_control_values"]')).val());
            }

			if (parentForm.find($('.tt-aggregation-data-view-source-field')).length && !utils.isUndefined(parentForm.find($('.tt-aggregation-data-view-source-field')).select2('val')) && parentForm.find($('.tt-aggregation-data-view-source-field')).select2('val') !== '') {

				// Unschön programmiert, da die Select2 einmal über JQuery und einmal über PHP befüllt wird und diese nicht gleich befüllt werden können!
				var controlTypeValuesString = $(parentForm.find($('.tt-aggregation-data-view-source-field')).select2('data')[0].element).data().controlValues;
				if (utils.isUndefined(controlTypeValuesString)) {
					controlTypeValuesString = $(parentForm.find($('.tt-aggregation-data-view-source-field')).select2('data')[0].element).data().data.controlValues;
				}
				if (!utils.isUndefined(controlTypeValuesString)) {
					var controlTypeValues = controlTypeValuesString.split('|');

					jQuery.each(controlTypeValues, function (i, val) {

						var controlTypeValue = val.split('#');

						if (controlTypeValue.length === 2) {
							data.push({id: controlTypeValue[0], text: controlTypeValue[1]});
						}
					});
				}
			}

			// Tabelle befüllen
			$("#table_aggregation_definition_control_values").dataTable().fnClearTable();
			jQuery.each(data, function (i, val) {
				$("#table_aggregation_definition_control_values").dataTable().fnAddData([
					'',
					val["id"] + ' (' + val["text"] + ')',
					'<label class="input tt-right-label-write"><input type="text" name="aggregation_control_value_' + val["id"] + '" value="' + ((val["id"] in controlValues && !utils.isUndefined(controlValues[val["id"]])) ? controlValues[val["id"]] : "") + '" class="input-sm tt-right-input-write tt-aggregation-control-value"></label>']
				);
            });
        } else if ($(this)[0].id === "table_aggregation_period_field_conversion_dialog") {

            var parentForm = $(e.relatedTarget).parents('form');
            $(this).find('[name="aggregation_period_field_conversions_parent_form"]').val(parentForm[0].id);

            // Die Tabelle mit den Feld-Konvertierungen neu befüllen
            var sourceData = [];
            var targetData = [];
            var fieldConversions = {};

            if (!utils.isUndefined(parentForm) && parentForm.find($('[name="aggregation_period_field_conversions"]')).length && parentForm.find($('[name="aggregation_period_field_conversions"]')).val() !== '') {
                fieldConversions = JSON.parse(parentForm.find($('[name="aggregation_period_field_conversions"]')).val());
            }

            var sourceTableFieldsString = '';
            var targetTableFieldsString = '';
            var showPeriodFormAndPeriodTillColumns = false;
            if (parentForm.find($('.tt-aggregation-data-view-source-field')).length && !utils.isUndefined(parentForm.find($('.tt-aggregation-data-view-source-field')).select2('val')) && parentForm.find($('.tt-aggregation-data-view-source-field')).select2('val') !== ''
                && parentForm.find($('.tt-aggregation-data-view-target-field')).length && !utils.isUndefined(parentForm.find($('.tt-aggregation-data-view-target-field')).select2('val')) && parentForm.find($('.tt-aggregation-data-view-target-field')).select2('val') !== '') {

                // Unschön programmiert, da die Select2 einmal über JQuery und einmal über PHP befüllt wird und diese nicht gleich befüllt werden können!
                sourceTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-source-field')).select2('data')[0].element).data().assignedFields;
                if (utils.isUndefined(sourceTableFieldsString)) {
                    sourceTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-source-field')).select2('data')[0].element).data().data.assignedFields;
                }

                targetTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-target-field')).select2('data')[0].element).data().assignedFields;
                if (utils.isUndefined(targetTableFieldsString)) {
                    targetTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-target-field')).select2('data')[0].element).data().data.assignedFields;
                }

                showPeriodFormAndPeriodTillColumns = true;

            } else if (parentForm.find($('.tt-aggregation-data-view-source-period-table')).length && !utils.isUndefined(parentForm.find($('.tt-aggregation-data-view-source-period-table')).select2('val')) && parentForm.find($('.tt-aggregation-data-view-source-period-table')).select2('val') !== ''
                && parentForm.find($('.tt-aggregation-data-view-target-period-table')).length && !utils.isUndefined(parentForm.find($('.tt-aggregation-data-view-target-period-table')).select2('val')) && parentForm.find($('.tt-aggregation-data-view-target-period-table')).select2('val') !== '') {

                // Unschön programmiert, da die Select2 einmal über JQuery und einmal über PHP befüllt wird und diese nicht gleich befüllt werden können!
                sourceTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-source-period-table')).select2('data')[0].element).data().assignedFields;
                if (utils.isUndefined(sourceTableFieldsString)) {
                    sourceTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-source-period-table')).select2('data')[0].element).data().data.assignedFields;
                }

                targetTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-target-period-table')).select2('data')[0].element).data().assignedFields;
                if (utils.isUndefined(targetTableFieldsString)) {
                    targetTableFieldsString = $(parentForm.find($('.tt-aggregation-data-view-target-period-table')).select2('data')[0].element).data().data.assignedFields;
                }

            }

            if (!utils.isUndefined(sourceTableFieldsString)) {
                var sourceTableFields = sourceTableFieldsString.split('|');

                jQuery.each(sourceTableFields, function (i, val) {

                    var sourceField = val.split('#');

                    if (sourceField.length === 3) {
                        sourceData.push({id: sourceField[0] + '|' + sourceField[1], text: sourceField[2] + ' (' + sourceField[1] + ')'});
                    }
                });
            }

            if (!utils.isUndefined(targetTableFieldsString)) {
                var targetTableFields = targetTableFieldsString.split('|');

                jQuery.each(targetTableFields, function (i, val) {

                    var targetField = val.split('#');

                    if (targetField.length === 3) {
                        targetData.push({id: targetField[0] + '|' + targetField[1], text: targetField[2] + ' (' + targetField[1] + ')'});
                    }
                });
            }

            // Tabelle Spalten für Zeitraum VON und Zeitraum BIS aus-/einblenden
            if (showPeriodFormAndPeriodTillColumns) {
                $("#table_aggregation_definition_period_field_conversions").DataTable().column(3).visible(true);
                $("#table_aggregation_definition_period_field_conversions").DataTable().column(4).visible(true);
            } else {
                $("#table_aggregation_definition_period_field_conversions").DataTable().column(3).visible(false);
                $("#table_aggregation_definition_period_field_conversions").DataTable().column(4).visible(false);
            }

            // Tabelle befüllen
            $("#table_aggregation_definition_period_field_conversions").dataTable().fnClearTable();
            jQuery.each(sourceData, function (i, val) {

                var foundFieldConversion = null;
                var foundFieldConversionId = 0;
                jQuery.each(fieldConversions, function (j, fieldConversion) {
                    if (val.id === fieldConversion[0]) {
                        foundFieldConversion = fieldConversion;
                        foundFieldConversionId = j;
                        return false;
                    }
                });

                if (!utils.isUndefined(foundFieldConversion)) {
                    // Options befüllen (nötig um auch die Select2 auf den weiteren Tabellen-Seiten korrekt zu befüllen)
                    var optionString = '';
                    jQuery.each(targetData, function (i, val) {
                        if (val.id === foundFieldConversion[1]) {
                            optionString += '<option selected value="' + val.id + '">' + val.text + '</option>';
                        } else {
                            optionString += '<option value="' + val.id + '">' + val.text + '</option>';
                        }
                    });

                    $("#table_aggregation_definition_period_field_conversions").dataTable().fnAddData([
                        foundFieldConversionId,
                        val["text"],
                        '<label class="input tt-right-label-write"><select style="width:100%" class="input-sm tt-select2 tt-aggregation-period-field-conversion" name="aggregation_period_field_conversion_' + i.toString() + '"><option></option>' + optionString + '</select></label>',
                        '<label class="checkbox"><input name="aggregation_period_field_conversion_period_from_' + i.toString() + '" type="checkbox" class="tt-right-checkbox-write tt-validation-checkbox tt-aggregation-period-field-conversion-checkbox-from" ' + (foundFieldConversion[2] === 1 ? 'checked' : '') + '><i></i></label>',
                        '<label class="checkbox"><input name="aggregation_period_field_conversion_period_till_' + i.toString() + '" type="checkbox" class="tt-right-checkbox-write tt-validation-checkbox tt-aggregation-period-field-conversion-checkbox-till" ' + (foundFieldConversion[3] === 1 ? 'checked' : '') + '><i></i></label>',
                        val.id,
                        foundFieldConversion[1],
                        foundFieldConversion[2],
                        foundFieldConversion[3]]
                    );
                } else {
                    // Options befüllen (nötig um auch die Select2 auf den weiteren Tabellen-Seiten korrekt zu befüllen)
                    var optionString = '';
                    jQuery.each(targetData, function (i, val) {
                        optionString += '<option value="' + val.id + '">' + val.text + '</option>';
                    });

                    $("#table_aggregation_definition_period_field_conversions").dataTable().fnAddData([
                        '-' + (i + 1).toString(),
                        val["text"],
                        '<label class="input tt-right-label-write"><select style="width:100%" class="input-sm tt-select2 tt-aggregation-period-field-conversion" name="aggregation_period_field_conversion_' + i.toString() + '"><option></option>' + optionString + '</select></label>',
                        '<label class="checkbox"><input name="aggregation_period_field_conversion_period_from_' + i.toString() + '" type="checkbox" class="tt-right-checkbox-write tt-validation-checkbox tt-aggregation-period-field-conversion-checkbox-from"><i></i></label>',
                        '<label class="checkbox"><input name="aggregation_period_field_conversion_period_till_' + i.toString() + '" type="checkbox" class="tt-right-checkbox-write tt-validation-checkbox tt-aggregation-period-field-conversion-checkbox-till"><i></i></label>',
                        val.id,
                        '',
                        0,
                        0]
                    );
                }
            });

            initialize.initializeSelect2($("#table_aggregation_definition_period_field_conversions").find('.tt-select2:not(.select2-container)'));

        } else if ($(this)[0].id === "table_aggregation_conflict_dialog") {

            var form = $(this);
			form.find('.tt-please-wait-aggregation-check-conflicts').removeClass('hide');
			form.find('.tt-aggregation-conflicts').addClass('hide');
			form.find('.tt-aggregation-no-conflicts').addClass('hide');

            var sourceModelId = '';
            var sourceModelName = '';
            var targetModelId = '';
            var targetModelName = '';
			var parentForm = $(e.relatedTarget).parents('.tt-content-datatable').find('form');

			if (parentForm.find('[name="source_model"]').select2('data').length > 0 && parentForm.find('[name="source_model"]').select2('data')[0].id !== '') {
				sourceModelId = parentForm.find('[name="source_model"]').select2('data')[0].id;
				sourceModelName = parentForm.find('[name="source_model"]').select2('data')[0].text;
			}
			if (parentForm.find('[name="target_model"]').select2('data').length > 0 && parentForm.find('[name="target_model"]').select2('data')[0].id !== '') {
				targetModelId = parentForm.find('[name="target_model"]').select2('data')[0].id;
				targetModelName = parentForm.find('[name="target_model"]').select2('data')[0].text;
			}

			form.find('.tt-aggregation-source-model-column').text(sourceModelName);
			form.find('.tt-aggregation-target-model-column').text(targetModelName);

			var url = $('#table_aggregation_definition_conflicts')[0].getAttribute('data-table-url') + '/' + sourceModelId + '/' + targetModelId;

			ajax.ajaxCallDeferred(url, 'GET', null, false).done(function (data) {
				form.find('.tt-please-wait-aggregation-check-conflicts').addClass('hide');

				if (!utils.isUndefined(data) && data.length === 1) {
					form.find('.tt-aggregation-conflicts').removeClass('hide');
					$('#table_aggregation_definition_conflicts').dataTable().fnClearTable();

					jQuery.each(data[0], function (key, value) {
						jQuery.each(value, function (i, table_data) {
							if (key === "warnings") {
								$("#table_aggregation_definition_conflicts").dataTable().fnAddData([
									'',
									'<i class="fad fa-lg fa-fw fa-exclamation-triangle txt-color-yellow"></i>',
									table_data[0],
									table_data[1],
									table_data[2],
									table_data[3],
									table_data[4]]
								);
							} else if (key === "errors") {
								$("#table_aggregation_definition_conflicts").dataTable().fnAddData([
									'',
									'<i class="fad fa-lg fa-fw fa-exclamation-triangle txt-color-red"></i>',
									table_data[0],
									table_data[1],
									table_data[2],
									table_data[3],
									table_data[4]]
								);
							}
						});
					});
				} else {
					form.find('.tt-aggregation-no-conflicts').removeClass('hide');
				}
			});
        } else if ($(this)[0].id === "table_data_views_display_restrictions_create_dialog") {

			// Die Spalten-Wiederholungen nur anzeigen, wenn die Anzahl der Wiederholungen bei Spalten und Spalten mit Radiobuttons > 1 ist
			var parentDialog = $(e.relatedTarget).parents('.modal-content');
			var repetition = '';
			if (parentDialog.find('[name="repetition"]').length) {
				repetition = parentDialog.find('[name="repetition"]').val();
			}

			if (repetition > 1) {
				$(this).find('.tt-display-restriction-repetition-column-row').removeClass('hide');
			} else {
				$(this).find('.tt-display-restriction-repetition-column-row').addClass('hide');
			}

		}
    });

    // Dialog angezeigt - Fokus auf erstes Input Feld setzen
    $('body').on('shown.bs.modal', '.tt-content-dialog', function (e) {

        $(this).find('.tt-save,.tt-save-sub-form').removeClass('disabled');
        if ($(this).find('input:text,span.select2-selection').length) {
            $(this).find('input:text,span.select2-selection')[0].focus();
        }
    });

    // Medizinischer Ansprechpartner Auswahl
    $('body').on('change', '.tt-select-contact-medical-userid', function (e) {
        if ($(this).val() === "") {
            $(this).parents('.tt-content-detail').find('.tt-input-contact-medical-username').val('');
            $(this).parents('.tt-content-detail').find('.tt-input-contact-medical-phone').val('');
            $(this).parents('.tt-content-detail').find('.tt-input-contact-medical-email').val('');
        } else {
            var element = $(this);

            ajax.ajaxCall("admin/facility/contact/" + element.val(), 'GET', element.val(), false, function (data) {
                if (data !== null) {
                    element.parents('.tt-content-detail').find('.tt-input-contact-medical-username').val(data['firstname'] + ' ' + data['name']);
                    element.parents('.tt-content-detail').find('.tt-input-contact-medical-phone').val(data['phone']);
                    element.parents('.tt-content-detail').find('.tt-input-contact-medical-email').val(data['email']);
                }
            });
        }
    });

    // Technischer Ansprechpartner Auswahl
    $('body').on('change', '.tt-select-contact-technical-userid', function (e) {
        if ($(this).val() === "") {
            $(this).parents('.tt-content-detail').find('.tt-input-contact-technical-username').val('');
            $(this).parents('.tt-content-detail').find('.tt-input-contact-technical-phone').val('');
            $(this).parents('.tt-content-detail').find('.tt-input-contact-technical-email').val('');
        } else {
            var element = $(this);

            ajax.ajaxCall("admin/facility/contact/" + element.val(), 'GET', element.val(), false, function (data) {
                if (data !== null) {
                    element.parents('.tt-content-detail').find('.tt-input-contact-technical-username').val(data['firstname'] + ' ' + data['name']);
                    element.parents('.tt-content-detail').find('.tt-input-contact-technical-phone').val(data['phone']);
                    element.parents('.tt-content-detail').find('.tt-input-contact-technical-email').val(data['email']);
                }
            });
        }
    });

    // Verlaufsansichten bearbeiten (Dialog öffnen)
    $('body').on('click', '#open_table_data_collection_type_course_views_study_edit_dialog', function (e) {
        var id = $(this).parents('.tt-content').find('.tt-selected-view-id').val();

        $('#table_data_collection_type_course_views_study_edit_form').find('.tt-select2').prop('disabled', 'disabled');
        $('#table_data_collection_type_course_views_study_edit_form').find('.tt-select2').val(id);

        jQuery.each($('#dd_course_views').nestable('serialize'), function (i, val) {

            if (String(val.viewId) === id) {
                jQuery.each(val.children, function (i, child) {
                    $('.tt-checkbox-course-view-' + child.viewId, $('#table_data_collection_type_course_views_study_edit_form').find('.tt-datatable-dialog').dataTable().fnGetNodes()).prop('checked', true);
                });
            }
        });
    });

    // Ändern des Typs der Datenerhebungsarten
    $('body').on('change', '.tt-data-collection-types-type', function (e) {
        e.preventDefault();

        $.SmartMessageBox({
            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_data_collection_types_type'),
            content: Lang.get('tripletrax.change_data_collection_types_type_desc'),
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
                    $("#content-detail").find('.tt-datatable-changes').val("changed");
                    $("#content-detail").find('form').trigger('checkform.areYouSure');
                }

                // TODO: wenn Fragebogen ausgewählt wird / nicht ausgewählt wird
                if ($('#radio_collection_type_study')[0].checked) {
                    $('body').find('.tt-content-course-views-register').hide();

                    for (var i = 0; i < $('#table_data_collection_type_course_views_register').dataTable()[0].rows.length; i++) {
                        $('#table_data_collection_type_course_views_register').dataTable().fnDeleteRow(0);
                    }
                    $('body').find('.tt-content-course-views-study').show();
                } else if ($('#radio_collection_type_register')[0].checked) {
                    $('body').find('.tt-content-course-views-study').hide();
                    $('body').find('.tt-content-course-views-register').show();
                    $('#dd_course_views').find('.dd-list').find('.dd-item').remove();
                }
            } else {
                if ($('#radio_collection_type_study')[0].checked) {
                    $('#radio_collection_type_register')[0].checked = true;
                } else if ($('#radio_collection_type_register')[0].checked) {
                    $('#radio_collection_type_study')[0].checked = true;
                }
            }
        });
    });

    // Input - Auswahl Wert
    $('body').on('click', '.tt-select-value', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('active')) {
            return;
        }

        // Dezimalstellen setzen
        if (!utils.isUndefined($(this).parents('.input').find('input').data().displayDecimals)) {
            if (!utils.isUndefined($(this).data().displayDecimals)) {
                $(this).parents('.input').find('input').data('displayDecimals', $(this).data().displayDecimals);
            } else {
                $(this).parents('.input').find('input').data('displayDecimals', '');
            }
        }

        utils.setInputDropDownValue(this, true);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }
        $(this).trigger('changeFormat');
    });

    // Input / DatePanel - Auswahl 'Nicht erhoben'
    $('body').on('click', '.tt-select-not-collected', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('active')) {
            return;
        }

        utils.setInputNotCollectedValue(this);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }

        $(this).parents('form').addClass('dirty');
        $(this).trigger('changeFormat');
    });

    // Input / DatePanel - Auswahl 'Unbekannt'
    $('body').on('click', '.tt-select-unknown', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('active')) {
            return;
        }

        utils.setInputUnknownValue(this);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }

        $(this).parents('form').addClass('dirty');
        $(this).trigger('changeFormat');
    });

    // Input / DatePanel - Auswahl 'Nicht messbar'
    $('body').on('click', '.tt-select-not-measurable', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('active')) {
            return;
        }

        utils.setInputNotMeasurableValue(this);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }

        $(this).parents('form').addClass('dirty');
        $(this).trigger('changeFormat');
    });

    // Input / DatePanel - Auswahl 'Andauernd'
    $('body').on('click', '.tt-select-continuing', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('active')) {
            return;
        }

        utils.setInputContinuingValue(this);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }

        $(this).parents('form').addClass('dirty');
        $(this).trigger('changeFormat');
    });

    // Input / DatePanel - Auswahl 'Unbegrenzt'
    $('body').on('click', '.tt-select-unlimited', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('active')) {
            return;
        }

        utils.setInputUnlimitedValue(this);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }

        $(this).parents('form').addClass('dirty');
        $(this).trigger('changeFormat');
    });

    // DatePanel - Auswahl Datum 'dd.mm.yyyy' oder 'mm.yyyy' oder 'yyyy'
    $('body').on('click', '.tt-select-date-full, .tt-select-date-month-year, .tt-select-date-year', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('active')) {
            return;
        }

        utils.setDatePickerDropDownValue(this, true);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }

        $(this).parents('form').addClass('dirty');
        $(this).trigger('changeFormat');
    });

    // Dialog - Neue Laboreinheit-Dialog anzeigen (Standardeinheit anzeigen)
    $('body').on('click', '#add_new_unit', function (e) {
        e.preventDefault();

        if ($(this).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetNodes().length === 0) {

            $('#table_data_views_units_create_dialog').find('#new_conversion_factor').val('1');
            $('#table_data_views_units_create_dialog').find('#new_conversion_factor').prop('disabled', 'disabled');
            $('#table_data_views_units_create_dialog').find('#new_conversion_formula').prop('disabled', 'disabled');
            $('#table_data_views_units_create_dialog').find('#conversion_factor_title')[0].textContent = Lang.get('tripletrax.conversion_factor');
        } else {

            var default_unit = '';
            jQuery.each($(this).parents('.modal-content').find('.tt-datatable-dialog').dataTable().fnGetNodes(), function (i, val) {
                if (val.children[0].children[0].children[0].checked) {
                    default_unit = val.children[1].textContent;
                    return false;
                }
            });

            $('#table_data_views_units_create_dialog').find('#new_conversion_factor').prop('disabled', '');
            $('#table_data_views_units_create_dialog').find('#new_conversion_formula').prop('disabled', '');
            $('#table_data_views_units_create_dialog').find('#conversion_factor_title')[0].textContent = Lang.get('tripletrax.conversion_factor') + ' (' + Lang.get('tripletrax.default_unit') + ': ' + default_unit + ')';
        }
    });

    // Ändern des Control-Typs der Zusatzfelder - bereits angelegte Integritäten löschen
    $('body').on('select2:selecting', '[name="control_type_additionalfield_1"], [name="control_type_additionalfield_2"]', function (e) {

        var element = $(this);
        var selected_value = element.select2('val');
        var name_appendix = element[0].name.replace('control_type', '');

        if (element.parents('form').find('[name="edit_integrity_rules' + name_appendix + '"]').val() !== '') {

            $.SmartMessageBox({
            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_control_type_of_additional_field'),
            content: Lang.get('tripletrax.change_control_type_of_additional_field_desc'),
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
            }, function (ButtonPressed) {
                if (ButtonPressed === Lang.get('tripletrax.yes')) {

                    // Integritäten löschen
                    $('#table_data_view_properties').find('[name="edit_integrity_rules' + name_appendix + '"]').val('');
                    $('#table_data_view_properties').find('.tt-integrity' + name_appendix).remove();

                } else {

                    // Controltyp zurücksetzen
                    element.val(selected_value).trigger('change.select2');
                }
            });
        }
    });

    // Import - Feld für anderen Separator in- bzw. aktiv setzen
    $('body').on('change', '.tt-import-separators', function (e) {

        if ($(this).parents('form').find('[name="separator"][value="other"]')[0].checked) {
            $(this).parents('form').find('[name="other_separator"]').prop('disabled', '');
            $(this).parents('form').find('[name="other_separator"]').parent().removeClass('state-disabled');
        } else {
            $(this).parents('form').find('[name="other_separator"]').val('');
            $(this).parents('form').find('[name="other_separator"]').prop('disabled', 'disabled');
            $(this).parents('form').find('[name="other_separator"]').parent().addClass('state-disabled');
        }
    });

    // Import - Bestätigung für die unplausiblen Werte in- bzw. aktiv setzen
    $('body').on('change', '.tt-import-implausible-values', function (e) {

        if ($(this)[0].checked) {
            $(this).parents('form').find('.tt-confirm-import-values').prop('disabled', false);
        } else {
            $(this).parents('form').find('.tt-confirm-import-values').prop('checked', false);
            $(this).parents('form').find('.tt-confirm-import-values').prop('disabled', true);
        }
    });

    // Import-Datei auswählen (Open-Folder-Dialog anzeigen)
    $('body').on('click', '.tt-select-import-file', function (e) {
        e.preventDefault();

        $('#hidden_import_file_name')[0].click();
    });

    // Import-Datei auswählen (Übernahme des Dateinamens in das Input-Feld & De- / Aktivierung der Feldtrenner)
    $('body').on('change', '#hidden_import_file_name', function (e) {

        $('#import_file_name').val($('#hidden_import_file_name')[0].files[0].name);

        if ($('#hidden_import_file_name')[0].files[0].name.substr(-3) === "csv") {
            $('.tt-import-separators').prop('disabled', false);
        } else {
            $('.tt-import-separators').prop('disabled', true);
            $('.tt-import-separators').prop('checked', false);
            $(this).parents('form').find('[name="other_separator"]').val('');
            $(this).parents('form').find('[name="other_separator"]').prop('disabled', 'disabled');
            $(this).parents('form').find('[name="other_separator"]').parent().addClass('state-disabled');
        }
    });

    // Import-Bericht speichern
    $('body').on('click', '.tt-save-report,.tt-save-previous-report', function (e) {
        e.preventDefault();

        var timestamp = $('[name="import_time_stamp"]').val();
        if ($(this).hasClass('tt-save-previous-report')) {
            timestamp = $('[name="previous_import_time_stamp"]').val();
        } else if ($(this).hasClass('tt-save-aggregation-report')) {
			timestamp = $('[name="aggregation_time_stamp"]').val();
		}
        ajax.ajaxCall($(this).data().buttonUrl + "/" + timestamp, "GET", null, false, function (data) {

            if (data === 'not_existing') {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_import_report'),
                    content: Lang.get('tripletrax.not_existing_import_report_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                });
            } else {
                window.open($('.tt-save-report').data().buttonUrl + '/download/' + data, '_blank');

                // Bericht auf PUBLIC wieder löschen
                ajax.ajaxCall($('.tt-save-report').data().buttonUrl + "/delete/" + timestamp, "POST", null, false, function (data) {});
            }
        });
    });

    // Export - alle Zeilen (bei Tabelle Einrichtungen nicht aber den Patienten) auswählen
    $('body').on('change', '.tt-export-all-items', function (e) {

        if ($(this)[0].checked) {
            var table_name = $(this)[0].name.replace('do_export_all_', '');
            $.each($('#' + table_name).find('tbody tr'), function (i, tr) {
                $.each($(tr).find('.tt-checkbox-datatable'), function (i, val) {
                    if (val.children[0].name === "do_export_patient") {
                        $('#' + table_name).find('#do_export_patient')[0].checked = false;
                        $('#' + table_name).find('#patient_pseudonym').val('');
                        $('#' + table_name).find('#patient_pseudonym').attr('disabled', 'disabled');
                        $('#' + table_name).find('#patient_pseudonym').parent().addClass('state-disabled');
                    } else {
                        if (!val.children[0].disabled) {
                            val.children[0].checked = true;
                        }
                    }
                });
            });
        } else {
            var table_name = $(this)[0].name.replace('do_export_all_', '');
            $.each($('#' + table_name).find('tbody tr'), function (i, tr) {
                $.each($(tr).find('.tt-checkbox-datatable'), function (i, val) {
                    val.children[0].checked = false;
                });
            });
        }
    });

    // Export - Bei Auswahl des Patienten alle Einrichtungen abhaken
    $('body').on('change', '#do_export_patient', function (e) {

        var table_name = $(this).parents('table')[0].id;
        if ($(this)[0].checked) {
            $('#' + table_name).find('#patient_pseudonym').removeAttr('disabled');
            $('#' + table_name).find('#patient_pseudonym').parent().removeClass('state-disabled');

            $('#' + table_name).find('[name="do_export_all_' + table_name + '"]')[0].checked = false;

            $.each($('#' + table_name).find('tbody tr'), function (i, tr) {
                $.each($(tr).find('.tt-checkbox-datatable'), function (i, val) {
                    if (val.children[0].name !== "do_export_patient") {
                        val.children[0].checked = false;
                    }
                });
            });
        } else {
            $('#' + table_name).find('#do_export_patient')[0].checked = false;
            $('#' + table_name).find('#patient_pseudonym').val('');
            $('#' + table_name).find('#patient_pseudonym').attr('disabled', 'disabled');
            $('#' + table_name).find('#patient_pseudonym').parent().addClass('state-disabled');
        }
    });

    // Export - Bei Auswahl einer Einrichtung den Patienten abhaken
    $('body').on('change', '.tt-export-facilities', function (e) {

        if ($(this)[0].checked) {
            var table_name = $(this).parents('table')[0].id;
            $('#' + table_name).find('#do_export_patient')[0].checked = false;
            $('#' + table_name).find('#patient_pseudonym').val('');
            $('#' + table_name).find('#patient_pseudonym').attr('disabled', 'disabled');
            $('#' + table_name).find('#patient_pseudonym').parent().addClass('state-disabled');
        }
    });

    // Export - Bei Auswahl AuditTrail, Queries oder Unplausible Integritäten exportieren 'Tabellen IDs exportieren' anhaken
    $('body').on('change', '[name="export_audit_trail"],[name="export_queries"],[name="export_implausible_integrities"]', function (e) {
        e.preventDefault();

        if ($('[name="export_audit_trail"]:checked').length > 0 || $('[name="export_queries"]:checked').length > 0 || $('[name="export_implausible_integrities"]:checked').length > 0) {
            $('[name="export_table_ids"]').prop('checked', 'checked');
            $('[name="export_single_tables"]').prop('checked', 'checked');
        }

        if ($('[name="export_audit_trail"]:checked').length <= 0) {
            $('[name="export_audit_trail_splitted_multiselect"]')[0].checked = false;
        }
    });

    // Export - Bei Auswahl 'Tabellen IDs exportieren' 'einzelne Tabellen exportieren' anhaken, bei Abwahl AuditTrail, Queries oder Unplausible Integritäten exportieren auch abwählen
    $('body').on('change', '[name="export_table_ids"]', function (e) {
        e.preventDefault();

        if ($('[name="export_table_ids"]:checked').length > 0) {
            $('[name="export_single_tables"]').prop('checked', 'checked');
        }
        else {
            $('[name="export_audit_trail"]')[0].checked = false;
            $('[name="export_audit_trail_splitted_multiselect"]')[0].checked = false;
            $('[name="export_queries"]')[0].checked = false;
            $('[name="export_implausible_integrities"]')[0].checked = false;
        }
    });

    // Export - Bei Auswahl 'leere Datensätze exportieren' 'einzelne Tabellen exportieren' anhaken
    $('body').on('change', '[name="export_empty_data"]', function (e) {
        e.preventDefault();

        if ($('[name="export_empty_data"]:checked').length > 0) {
            $('[name="export_single_tables"]').prop('checked', 'checked');
        }
    });

    // Export - Bei Auswahl 'Mehrfachauswahlen im Audit Trail aufsplitten' 'Audit Trail exportieren' anhaken
    $('body').on('change', '[name="export_audit_trail_splitted_multiselect"]', function (e) {
        e.preventDefault();

        if ($('[name="export_audit_trail_splitted_multiselect"]:checked').length > 0) {
            $('[name="export_audit_trail"]').prop('checked', 'checked');
            $('[name="export_table_ids"]').prop('checked', 'checked');
            $('[name="export_single_tables"]').prop('checked', 'checked');
        }
    });

    // Export - Bei Abwahl 'einzelne Tabellen exportieren' 'Tabellen IDs exportieren' auch abwählen
    $('body').on('change', '[name="export_single_tables"]', function (e) {
        e.preventDefault();

        if ($('[name="export_single_tables"]:checked').length <= 0) {
            $('[name="export_table_ids"]')[0].checked = false;
            $('[name="export_audit_trail"]')[0].checked = false;
            $('[name="export_audit_trail_splitted_multiselect"]')[0].checked = false;
            $('[name="export_queries"]')[0].checked = false;
            $('[name="export_implausible_integrities"]')[0].checked = false;
            $('[name="export_empty_data"]')[0].checked = false;
        }
    });

    // Export - Bei Auswahl SPSS 'IDAT exportieren' abhaken
    $('body').on('change', '[name="file_format"]', function (e) {
        e.preventDefault();

        if ($('[name="file_format"]:checked').val() === 'spss') {
            $('[name="export_idat"]')[0].checked = false;
            $('[name="export_idat"]').attr('disabled', 'disabled');
            $('[name="export_idat"]').parent().addClass('state-disabled');
            $('[name="export_type_control_type_values"][value="encoded"]').prop("checked", true);
            $('[name="export_type_control_type_values"]').attr('disabled', 'disabled');
            $('[name="export_type_control_type_values"]').parent().addClass('state-disabled');
        }
        else {
            if (!$('[name="export_idat"]').hasClass('tt-no-export-idat')) {
                $('[name="export_idat"]').parent().removeClass('state-disabled');
                $('[name="export_idat"]').removeAttr('disabled');
            }
            $('[name="export_type_control_type_values"]').removeAttr('disabled');
            $('[name="export_type_control_type_values"]').parent().removeClass('state-disabled');
        }
    });

    // Input Felder mit Dezimalstellen - Bei Änderung lokales Format anzeigen
    $('body').on('blur', '.tt-input-decimal', function(e) {
        var displayDecimals = null;
        if (!utils.isUndefined($(this).data().displayDecimals) && $(this).data().displayDecimals !== '') {
            displayDecimals = $(this).data().displayDecimals;
        }
        if ($(this).val() !== '') {
            $(this).val(utils.getLocaleNumberString($(this).val(), displayDecimals));
        }
    });

    // Patienten zusammenführen - Zielpatient setzen
    $('body').on('change', '.target-patient-group', function (e) {

        if ($(this)[0].checked) {
            if ($(this)[0].name === 'target_patient_1') {
                $('[name="target_patient_2"]')[0].checked = false;
            } else {
                $('[name="target_patient_1"]')[0].checked = false;
            }
        }
    });

    // Patienten zusammenführen - Neue Zusammenführung starten
    $('body').on('click', '.tt-start-new-merge', function (e) {
        e.preventDefault();

        ajax.ajaxCall($(this)[0].getAttribute("action"), 'GET', null, false, function (data) {
            utils.setHtmlData($("#content"), data, true);

        });
    });

    // Patienten zusammenführen - Protokoll der Konflikte/Zusammenführung drucken
    $('body').on('click', '.tt-print-merge-conflicts,.tt-print-merge-result', function (e) {
        e.preventDefault();

        var button = $(this);

        var patNrMerge = '';
        var patNrDelete = '';

        var protocolData = '&patient_to_merge=' + patNrMerge + '&patient_to_delete=' + patNrDelete + '&protocol_data=';
        var name = '';

        if (button.hasClass('tt-print-merge-conflicts')) {

            name = 'conflict_protocol';

            // Konflikte
            protocolData = '&protocol_data=' + encodeURIComponent($('#table_merge_conflicts_hidden').parent().html());

        } else if (button.hasClass('tt-print-merge-result')) {

            name = 'merge_protocol';

            // übernommene Daten
            protocolData = '&protocol_assumed_data=' + encodeURIComponent($('#table_merge_patients_assumed_data_hidden').parent().html());

            // nicht übernommene Daten
            protocolData += '&protocol_not_assumed_data=' + encodeURIComponent($('#table_merge_patients_not_assumed_data_hidden').parent().html());
        }

        ajax.ajaxCall(button.data().buttonUrl + "/" + name + "/" + $('[name="merge_patient_time_stamp"]').val(), "POST", protocolData, false, function (data) {

            window.open('documents/' + data, '_blank');

            // Bericht auf PUBLIC wieder löschen
            ajax.ajaxCall(button.data().buttonUrl + "/delete/" + name + "/" + $('[name="merge_patient_time_stamp"]').val(), "POST", null, false, function (data) {});
        });
    });

    // Patient löschen - bei Eingabe neues Pseudonym Meldung entfernen
    $('body').on('keydown', '.tt-delete-patient-finally-pseudonym', function (e) {

        $(this).parents('form').find('.tt-patient-finally-deleted').addClass('hide');
        $(this).parents('form').find('.tt-patient-finally-not-deleted').addClass('hide');
    });

    // News - Häkchen in Berechtigungs-Tabelle aktualisieren
    $('body').on('change', '.tt-checkbox-news-rights,.tt-checkbox-documents-rights', function (e) {

        var element = $(this);
        var tr = element.parents('tbody tr');
        var aPos = element.parents('.tt-datatable-detail').dataTable().fnGetPosition(tr[0]);

        jQuery.each(element.parents('.tt-datatable-detail').dataTable().fnGetNodes(), function (i, val) {
            if (i === aPos) {
                if (!element[0].children[0].checked) {
                    element.parents('.tt-datatable-detail').dataTable().fnGetData(i)[4] = '0';
                } else {
                    element.parents('.tt-datatable-detail').dataTable().fnGetData(i)[4] = '1';
                }
            }
        });

        element.parents('.tt-datatable-detail').dataTable().fnStandingRedraw();
    });

    // News - Tabelle alle anhaken Button
    $('body').on('click', '.tt-datatable-news-check-all,.tt-datatable-documents-check-all', function (e) {
        e.preventDefault();

        if ($(this).parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
            $(this).parents('.tt-content-detail').find('.tt-datatable-changes').val("changed");
            $("#content-detail").find('form').trigger('checkform.areYouSure');
        }

        var dataTable = $(this).parents('.tt-content-datatable').find('.tt-datatable-detail').dataTable();

        jQuery.each(dataTable.fnGetData(), function (i, val) {
            dataTable.fnGetNodes(i).children[0].innerHTML = '<label class="checkbox tt-checkbox-datatable"><input type="checkbox" class="tt-row-selector" checked><i></i></label>';
            val[4] = '1';
        });

        dataTable.fnStandingRedraw();
    });

    // News - Grafik auswählen (Open-Folder-Dialog anzeigen)
    $('body').on('click', '.tt-select-news-image', function (e) {
        e.preventDefault();

        $('.note-image-input')[0].click();
    });

    // Projekte / Studien - Bei Auswahl von "Keine" bei den abhängigen Projekte / Studien bzw. automatisch mit einzuschreibenden Projekten / Studien alle anderen bereits ausgewählten löschen
    $('body').on('select2:select', '.tt-depending-models', function (e) {
		if (!utils.GLOBALS.programmaticClick) {
			utils.updateGlobals('programmaticClick', true);
			if (!utils.isUndefined(e.params.data.id) && e.params.data.id === '-1') {
				$(this).val([e.params.data.id]).trigger('change.select2');
			} else {
				var select_array = [];
				jQuery.each($(this).select2('data'), function (i, val) {
					if (val.id !== '-1') {
						select_array.push(val.id);
					}
				});
				$(this).val(select_array).trigger('change.select2');
			}
			utils.updateGlobals('programmaticClick', false);
		}
    });

    // Projekte / Studien - Bei Auswahl eines abhängigen Projekts / Studie bestehende Patientendaten überprüfen
    $('body').on('select2:selecting', '.tt-depending-models', function (e) {

        var element = $(this);
        var currentModel = element.parents('form').find('.tt-selected-id').val();
        var currentModelName = element.parents('form').find('[name="model"]').val();
        var selectedDependingModels = element.select2('val');
        var newDependingModel = e.params.args.data;

        if (currentModel !== '') {
            ajax.ajaxCall("admin/datacollectiontype/checkdepmodel/" + currentModel + "/depmodel/" + newDependingModel.id, "GET", null, false, function(data) {

                if (data === 'existing') {
                    $.SmartMessageBox({
                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.add_depending_model_title', { "model": newDependingModel.text }),
                        content: Lang.get('tripletrax.add_depending_model_desc', { "model": currentModelName }),
                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                    }, function (ButtonPressed) {
                        // abhängige Projekte / Studien zurücksetzen
                        element.val(selectedDependingModels).trigger('change.select2');
                        validator.triggerValidation(element[0], true);
                    });
                }
            });
        }
    });

    // Projekte / Studien - Checkbox für farbliche Vollständigkeit kann nur gesetzt werden, wenn alle Vollständigkeitsregeln 'immer' oder 'bei jedem Termin' angegeben haben
    $('body').on('change', '.tt-colored-completeness', function (e) {
        e.preventDefault();

        var element = $(this);

        if (element[0].checked) {

            var integrityData = '';
            jQuery.each($('#table_data_collection_type_integrities').dataTable().fnGetData(), function (i, val) {

                if (i > 0) {
                    integrityData = integrityData + "|";
                }

                integrityData += val[0] + '#' + val[1] + '#' + val[2] + '#' + val[4] + '#' + val[5] + '#' + val[6] + '#' + val[7]
                    + '#' + val[8] + '#' + val[9] + '#' + val[10] + '#' + val[11] + '#' + val[12] + '#' + val[13] + '#' + val[14] + '#' + val[15]
                    + '#' + val[16] + '#' + val[17] + '#' + val[18] + '#' + val[19] + '#' + val[20] + '#' + val[21] + '#' + val[22] + '#' + val[23]
                    + '#' + val[24] + '#' + val[25] + '#' + val[26] + '#' + val[27] + '#' + val[28] + '#' + val[29] + '#' + val[30] + '#' + val[31]
                    + '#' + val[32] + '#' + val[33] + '#' + val[34] + '#' + val[35] + '#' + val[36] + '#' + val[37] + '#' + val[38] + '#' + val[39]
                    + '#' + val[40] + '#' + val[41] + '#' + val[42] + '#' + val[43] + '#' + val[44] + '#' + val[45] + '#' + val[46] + '#' + val[47]
                    + '#' + val[48] + '#' + val[49] + '#' + val[50] + '#' + val[51] + '#' + val[52] + '#' + val[53] + '#' + val[54] + '#' + val[55]
                    + '#' + val[56] + '#' + val[57] + '#' + val[58] + '#' + val[59] + '#' + val[60] + '#' + val[61] + '#' + val[62] + '#' + val[63]
                    + '#' + val[64] + '#' + val[65] + '#' + val[66] + '#' + val[67] + '#' + val[68] + '#' + val[69] + '#' + val[70] + '#' + val[71];

            });

            var ajaxData = '&' + jQuery.param({ integrities: integrityData });

            ajax.ajaxCall("admin/datacollectiontype/checkcompleteness/all", "POST", ajaxData, false, function(data) {

                if (data === 'false') {
                    $.SmartMessageBox({
                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.set_colored_completeness'),
                        content: Lang.get('tripletrax.set_colored_completeness_desc'),
                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                    }, function (ButtonPressed) {
                    });
                    event.stopPropagation();
                    // Checkbox zurücksetzen
                    element[0].checked = false;
                }
            });
        }
    });

    // Patient wiederherstellen - alle Zeilen auswählen
    $('body').on('change', '.tt-restore-all-patients', function (e) {
        var element = $(this);

        $.each($('#table_restore_patient_facilities').find('tbody tr'), function (i, tr) {
            $.each($(tr).find('.tt-checkbox-datatable'), function (i, val) {
                val.children[0].checked = element[0].checked;
            });
        });
    });

    // Patient wiederherstellen - bei Eingabe neues Pseudonym Meldung entfernen
    $('body').on('keydown', '.tt-restore-patient-pseudonym', function (e) {

        $(this).parents('form').find('.tt-patient-restored').addClass('hide');
    });

    // Daten einfrieren - bei Auswahl neues Jahr oder neues Projekt Meldung entfernen
    $('body').on('change', '.tt-freeze-data-combobox', function (e) {

        $(this).parents('form').find('.tt-data-frozen-ok,.tt-data-frozen-fail').addClass('hide');
    });

    // Felder für die Berechnungen - Validierung ausführen
    $('body').on('change', '.tt-calculation-single-field,.tt-calculation-single-match-field', function (e) {
        utils.updateGlobals('showValidationErrorMessageBox', false);
        $(this).parents('.tt-validation-form').valid();
        utils.updateGlobals('showValidationErrorMessageBox', true);
    });

    // Anderen Level für Rollenübersicht auswählen
    $('body').on('change', '.tt-roles-overview-levels', function(e) {
        e.preventDefault();

        changes.reloadTable('#table_roles_overview', $($(this).select2('data')[0].element).data().href);
        $($('#table_roles_overview').find('th')[0]).text(trans('tripletrax.' + $(this).select2('val')));
    });

    // Rollenübersicht auf- / zuklappen
    $('body').on('click', '.tt-roles-overview-expand-collapse', function(e) {
        e.preventDefault();

        if ($(this).data().action === 'expand-all') {
            $('#table_roles_overview').treetable('expandAll');
        } else {
            $('#table_roles_overview').treetable('collapseAll');
        }
    });

    // Dokumente - Datei oder URL ein-/ausblenden
    $('body').on('change', '.tt-document-resource', function(e) {
        e.preventDefault();

        if ($(this).is(':checked') && $(this).val() === 'url') {
            $('.tt-document-file').addClass('hide');
            $('#file_upload').val('');
            $('#document_filename').val('');
            $('.tt-document-url').removeClass('hide');
        } else if ($(this).is(':checked') && $(this).val() === 'file') {
            $('.tt-document-file').removeClass('hide');
            $('.tt-document-url').addClass('hide');
            $('#documents_url').val('');
        }

        // Regeln der Validierung neu setzen
        $(this).parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));
    });

    // Dokumente - URL in neuem Fenster anzeigen
    $('body').on('click', '.tt-documents-show-url', function(e) {
        e.preventDefault();

        window.open($(this).attr('href'), '_blank');
    });

    // AuditTrail - Admin-Angabe zurücksetzen
    $('body').on('change', '.tt-audit-trail-documentation', function (e) {
        $('[name="audit_trail_tables_admin"]').val(null).trigger('change.select2');
    });

    // AuditTrail - Doku-Angaben zurücksetzen
    $('body').on('change', '.tt-audit-trail-admin', function (e) {
        $('[name="audit_trail_facility"]').val(null).trigger('change.select2');
        $('[name="audit_trail_data_view_field"]').val(null).trigger('change.select2');
        $('[name="audit_trail_patient"]').val(null).trigger('change.select2');
        $('[name="exam_date"]').val('');
        $('[name="exam_time"]').val('0:00');
    });

    // Einrichtungen/Benutzer/Rollen/Data Dictionary - Export in CSV/Excel Datei
    $('body').on('click', '.tt-export-csv-list', function (e) {
        e.preventDefault();

        var element = $(this);
        var timestamp = $.now();

        // Export Data Dictionary dauert länger
        $('.tt-please-wait-export-data-dictionary').removeClass('hide');

        var exportAction = element[0].getAttribute('action') + '/' + timestamp;

        if ($(this).hasClass('tt-export-role-overview')) {
            exportAction = exportAction + '/levels' + $($(this).parents('.tt-content').find('.tt-roles-overview-levels').select2('data')[0].element).data().href.substring($($(this).parents('.tt-content').find('.tt-roles-overview-levels').select2('data')[0].element).data().href.lastIndexOf('/'));
        }

        ajax.ajaxCall(exportAction, element[0].getAttribute('method'), null, false, function (data) {

            ajax.ajaxCall(element[0].getAttribute('action') + '/check/' + timestamp, "GET", null, false, function (data) {

                if (data === 'not_existing') {
                    $('.tt-please-wait-export-data-dictionary').addClass('hide');

                    $.SmartMessageBox({
                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_export_file'),
                        content: Lang.get('tripletrax.not_existing_export_file_desc'),
                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                    }, function (ButtonPressed) {
                    });
                } else {
                    // Datei herunterladen
                    window.open(element[0].getAttribute('action') + '/download/' + data, '_blank');

                    // Datei auf PUBLIC wieder löschen (Timeout hinzugefügt, da sonst die Datei zu schnell gelöscht wird)
                    setTimeout(function() {
                        ajax.ajaxCall(element[0].getAttribute('action') + '/delete/' + data, "POST", null, false, function (data) {});
                    }, 100);

                    $('.tt-please-wait-export-data-dictionary').addClass('hide');
                }
            });
        });
    });

    // Rollen - Berechtigungsübersicht anzeigen
    $('body').on('click', '.tt-role-right-overview', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Tabelle auf modalen Dialog kopieren und Größe anpassen
        var fieldSetDetailView = $('#fieldset_table_role_rights').detach();
        fieldSetDetailView.appendTo('#fieldset_role_rights_overview');
        $('#fieldset_table_role_rights')[0].style.height = '667px';

        $('#table_role_rights_overview_dialog').modal('show');
    });

    // AuditTrail - Export in CSV Datei
    $('body').on('click', '.tt-export-audit-trail-csv-list', function (e) {
        e.preventDefault();

        var text = '';
        var headers = [];
        var rows = [];

        // Spaltenüberschriften hinzufügen
        $('#table_audit_trail thead').find('th').each(function() {
            var header = '"' + $(this).text() + '"';
            headers.push(header);
        });

        text += headers.join(';') + '\r\n';

        // Daten hinzufügen
        jQuery.each($('#table_audit_trail').dataTable()._('tr', {"order": "current", "filter": "applied"}), function (i, row) {
            var data = [];
            data.push('"' + row['type'] + '"');
            data.push('"' + row['pseudonym'] + '"');
            data.push('"' + (row['examinationdate'] === '0000-00-00 00:00:00' ? '' : utils.dateToLocaleTimeString(row['examinationdate'], false)) + '"');
            data.push('"' + row['description'] + '"');
            data.push('"' + row['database_table'] + '"');
            data.push('"' + row['column'] + '"');
            data.push('"' + (utils.isUndefined(row['old_value']) ? '' : row['old_value']) + '"');
            data.push('"' + (utils.isUndefined(row['new_value']) ? '' : row['new_value']) + '"');
            data.push('"' + (utils.isUndefined(row['origin_flag']) ? '' : row['origin_flag']) + '"');
            data.push('"' + utils.dateToLocaleTimeString(row['updated_at'], false) + '"');
            data.push('"' + (utils.isUndefined(row['facility']) ? '' : row['facility']) + '"');
            data.push('"' + (utils.isUndefined(row['user']) ? '' : row['user']) + '"');

            rows.push(data.join(';'));
        });

        text += rows.join('\r\n');

        if (text !== '') {
            text = '\ufeff' + text;
            var blob = new Blob([text], {type: "text/plain;charset=utf-8"});
            saveAs(blob, trans('tripletrax.audit_trail_result_export_list') + ".csv");
        }
    });

    // Benachrichtigungen aus- einblenden
    $('body').on('click', '#notifications', function(e) {
        e.preventDefault();

        if (!$(this).next('.ajax-dropdown').is(':visible')) {
            $(this).next('.ajax-dropdown').fadeIn(150);
            $(this).addClass('active');

            if (utils.isUndefined($(this).data().initiallyLoaded)) {
                $(this).next('.ajax-dropdown').find('.tt-load-notifications').click();
                $(this).data().initiallyLoaded = true;
            }
        } else {
            $(this).next('.ajax-dropdown').fadeOut(150);
            $(this).removeClass('active');
        }
    });

    // Liste der Benachrichtigungen neu laden
    $('body').on('click', '.tt-load-notifications', function(e) {
        e.preventDefault();

        var element = $(this).parents('.ajax-dropdown').find('.ajax-notifications');
        showNotifications(element.data().href, element);
    });

    // Suche in den Benachrichtigungen
    $('body').on('keyup', '.input-notification-search', function(e) {
        e.preventDefault();

        var code = e.keyCode || e.which;
        if (code == 13) {
            searchNotifications($(this).val());
        }
        if ($(this).parent().find('.tt-clear-notification-search').length) {
            if ($(this).val().length) {
                $(this).parent().find('.tt-clear-notification-search').removeClass('hide');
            } else {
                $(this).parent().find('.tt-clear-notification-search').addClass('hide');
            }
        }
    });

    // Benachrichtigungs-Suche zurücksetzen
    $('body').on('click', '.tt-clear-notification-search', function (e) {
        e.preventDefault();

        $(this).parents('.tt-search-notifications').find('.input-notification-search').val('');
        $(this).addClass('hide');
        searchNotifications('');
    });

    // Alle offenen und beantworteten Benachtichtigungen schließen
    $('body').on('click', '.tt-close-all-queries', function(e) {
        e.preventDefault();

        var element = $(this).parents('.ajax-dropdown').find('.ajax-notifications');
        showNotifications($(this).data().href, element);
    });

    // Grund des Datenexports - anderer Grund Freitext dis-enablen
    $('body').on('change', '[name="export_reason"]', function(e) {
        e.preventDefault();

        if ($(this).select2('val') === 'other') {
            $('[name="export_reason_other"]').removeAttr('disabled');
        } else {
            $('[name="export_reason_other"]').val('');
            $('[name="export_reason_other"]').prop('disabled', 'disabled');
        }
    });

    // Allgemeine Einstellungen - Farbliche Differenzierung der Häkchensymbole der einzelnen Projekte/Studien aktivieren
    $('body').on('click', '.tt-activate-colored-completeness', function(e) {
        $.SmartMessageBox({
            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.activate_colored_completeness'),
            content: Lang.get('tripletrax.activate_colored_completeness_desc'),
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                ajax.ajaxCall("admin/setting/activate", "POST", null, false, null);
            }
        });
    });

    // Berechnungen - Scores: neues dynamisches Feld hinzufügen
    $('body').on('click', '.tt-add-calculation-field', function(e) {
        e.preventDefault();

        var dialogId = '#' + $(this).parents('form')[0].id;
        addCalculationRow(dialogId, $(dialogId).find('.tt-calculation-row:not(.hide),.tt-calculation-dynamic-row:not(.hide),.tt-calculation-dynamic-match-list-row:not(.hide)').length, '', ($(dialogId).find('[name="is_additional_field"]').val() == 'true'), '');
    });

    // Berechnungen - Scores: dynamisches Feld entfernen
    $('body').on('click', '.tt-remove-calculation-field', function(e) {
        e.preventDefault();

        if ($('.tt-calculation-row-match-field').hasClass('hide')) {
			$(this).parents('.tt-calculation-dynamic-row').remove();
        } else {
			$(this).parents('.tt-calculation-dynamic-match-list-row').remove();
		}

    });

    // Grund des Datenexports - anderer Grund Freitext dis-enablen
    $('body').on('change', '[name="export_format"]', function(e) {
        e.preventDefault();

        if ($('[name="export_format"]:checked').val() === 'selection') {
            $('.tt-selection-tabs').removeClass('hide');
        } else {
            $('.tt-selection-tabs').addClass('hide');
        }
    });

    // Exportieren der Vollständigkeit in einer CSV/Excel Datei
    $('body').on('click', '.tt-export-completeness-list,.tt-export-completeness-list-doc', function(e) {
        e.preventDefault();

        var element = $(this);
        var timestamp = $.now();

        $('.tt-please-wait-export').removeClass('hide');

        var exportAction = element[0].getAttribute('action') + '/' + timestamp;

		var allTableData = [];
        if ($(this).hasClass('tt-export-completeness-list')) {
			allTableData = $('#table_completeness').DataTable().data().toArray();
		} else {
			allTableData.push($('.tt-content-completeness .header-master-overview').text());

            $.each($('.dd-completeness-list').find('.tt-completeness-master,.tt-completeness-course'), function (i, element) {
				allTableData.push('');
				allTableData.push($(element).find('.dd-completeness-parent').text());

				$.each($(element).find('.dd-list .dd-btn-completeness'), function (k, element) {
					allTableData.push([$(element).find('.dd-handle-completeness').clone().children().remove().end().text(), $(element).find('.note').text()]);
				});
            });
        }
        // console.log(allTableData);
        var file_extension = $('[name="export"]:checked').val();
        ajax.ajaxCall(exportAction, element[0].getAttribute('method'), {table_data: JSON.stringify(allTableData), file_extension: file_extension}, false, function (data) {

            ajax.ajaxCall(element[0].getAttribute('action') + '/check/' + timestamp +'/file_extension/'+ file_extension, "GET", null, false, function (data) {

                if (data === 'not_existing') {
                    $('.tt-please-wait-export').addClass('hide');

                    $.SmartMessageBox({
                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_export_file'),
                        content: Lang.get('tripletrax.not_existing_export_file_desc'),
                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                    }, function (ButtonPressed) {
                    });
                } else {
                    // Datei herunterladen
                    window.open(element[0].getAttribute('action') + '/download/' + data, '_blank');

                    // Datei auf PUBLIC wieder löschen (Timeout hinzugefügt, da sonst die Datei zu schnell gelöscht wird)
                    // TODO DAtei sollte gelöscht werden
                    setTimeout(function() {
                         ajax.ajaxCall(element[0].getAttribute('action') + '/delete/' + data, "POST", null, false, function (data) {});
                    }, 500);

                    $('.tt-please-wait-export').addClass('hide');
                }
            });
        });
    });

    // Endegrund anzeigen, falls Datum gesetzt
    $('body').on('change', '.tt-select-end-date', function(e) {
        e.preventDefault();

        var value = $(this).val();
		if (value.replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
		    $(this).parents('.tt-transfer-data').find('.tt-end-reason').removeClass('hide');
		    $(this).parents('.tt-transfer-data').find('.tt-transfer')[0].checked = false;
		    $(this).parents('.tt-transfer-data').find('.tt-transfer').attr('disabled', 'disabled');
        } else {
			$(this).parents('.tt-transfer-data').find('.tt-end-reason').addClass('hide');
			$(this).parents('.tt-transfer-data').find('.tt-end-reason-other').addClass('hide');
			$(this).parents('.tt-transfer-data').find('.tt-end-reason').find('.tt-select2').val(null).trigger('change.select2');
			$(this).parents('.tt-transfer-data').find('.tt-end-reason-other').find('input').val('');
			$(this).parents('.tt-transfer-data').find('.tt-transfer').removeAttr('disabled', 'disabled');
        }
    });

    // Endegrund - anderer anzeigen
	$('body').on('change', '.tt-end-reason-selection', function(e) {
		e.preventDefault();

		if ($($(this).select2('data')[0].element).data().showOtherEndReason === '1' || $($(this).select2('data')[0].element).data().showOtherEndReason === 1) {
			$(this).parents('.tt-transfer-data').find('.tt-end-reason-other').removeClass('hide');
		} else {
			$(this).parents('.tt-transfer-data').find('.tt-end-reason-other').addClass('hide');
			$(this).parents('.tt-transfer-data').find('.tt-end-reason-other').find('input').val('');
		}
	});

	// Aggregation (Definition) - anderes Projekt auswählen
	$('body').on('change', '.tt-aggregation-model', function(e) {
		e.preventDefault();

		// Tabelle neu laden
		var sourceModelId = 0;
		var sourceModelName = '';
		var sourceViewIds = '';
		var targetModelId = 0;
		var targetModelName = '';
		var targetViewIds = '';

		if ($(this).parents('form').find('[name="source_model"]').select2('data').length > 0 && $(this).parents('form').find('[name="source_model"]').select2('data')[0].id !== '') {
			sourceModelId = $(this).parents('form').find('[name="source_model"]').select2('data')[0].id;
			sourceModelName = $(this).parents('form').find('[name="source_model"]').select2('data')[0].text;
			sourceViewIds = $(this).parents('form').find('[name="source_model"]').find(":selected").data('viewIds');
        }
        if ($(this).parents('form').find('[name="target_model"]').select2('data').length > 0 && $(this).parents('form').find('[name="target_model"]').select2('data')[0].id !== '') {
			targetModelId = $(this).parents('form').find('[name="target_model"]').select2('data')[0].id;
			targetModelName = $(this).parents('form').find('[name="target_model"]').select2('data')[0].text;
			targetViewIds = $(this).parents('form').find('[name="target_model"]').find(":selected").data('viewIds');
        }

		validator.reloadAggregationDefinitionList(sourceModelId, targetModelId, true);

		// Button "neue Regel" de-/aktivieren
		var hasRightAddAggregation = access.getRight($('.tt-add-aggregation'), 'write');
		if (hasRightAddAggregation && sourceModelName !== '' && targetModelName !== '') {
			$('.tt-add-aggregation').removeClass('disabled');
			$('.tt-add-aggregation').removeAttr('disabled');
        } else {
			$('.tt-add-aggregation').addClass('disabled');
			$('.tt-add-aggregation').prop('disabled', 'disabled');
        }

        // Button "Konflikte anzeigen" de-/aktivieren
		if (sourceModelName !== '' && targetModelName !== '') {
			$('.tt-show-aggregation-conflict-list').removeClass('disabled');
		} else {
			$('.tt-show-aggregation-conflict-list').addClass('disabled');
		}

		// Liste der Felder im modalen Dialog neu laden
		$('#table_aggregation_create_form').find('[name="source_data_collection_type_id"]').val(sourceModelId);
		$('#table_aggregation_create_form').find('[name="target_data_collection_type_id"]').val(targetModelId);
        $('#table_aggregation_create_form').find('[name="source_data_view_field_model_view_ids"]').val(sourceViewIds);
		$('#table_aggregation_create_form').find('[name="target_data_view_field_model_view_ids"]').val(targetViewIds);

		$('#label_source_data_view_field').text(trans('tripletrax.source_data_view_field') + ' (' + sourceModelName + ')');
		$('#label_target_data_view_field').text(trans('tripletrax.target_data_view_field') + ' (' + targetModelName + ')');
        $('#label_source_data_view_period_table').text(trans('tripletrax.source_data_view_period_table') + ' (' + sourceModelName + ')');
        $('#label_target_data_view_period_table').text(trans('tripletrax.target_data_view_period_table') + ' (' + targetModelName + ')');

		integrities.setIntegrityFieldSelection('source_data_view_field', 'all_fields', 'tt-aggregation-data-view-source-field tt-aggregation-source-rule', $('#table_aggregation_create_form'));
		integrities.setIntegrityFieldSelection('target_data_view_field', 'all_fields', 'tt-aggregation-data-view-target-field', $('#table_aggregation_create_form'));
        integrities.setAggregationPeriodTableSelection('source_data_view_period_table', 'all_period_tables', 'tt-aggregation-data-view-source-period-table tt-aggregation-source-rule', $('#table_aggregation_create_form'));
        integrities.setAggregationPeriodTableSelection('target_data_view_period_table', 'all_period_tables', 'tt-aggregation-data-view-target-period-table', $('#table_aggregation_create_form'));
	});

	// Aggregation (Definition) - Einschränkung der Tabelle auf eine Kategorie (Tab)
	$('body').on('change', '.tt-aggregation-tabs-restriction', function(e) {
		e.preventDefault();

		if (!utils.isUndefined($('#table_aggregation_definition')[0].getAttribute('data-restriction-column'))) {
			var dataTable = $('#table_aggregation_definition').dataTable();
			var restrictionColumn = parseInt($('#table_aggregation_definition')[0].getAttribute('data-restriction-column'));

			var val = $(this).val();

			dataTable.api().column(restrictionColumn).search(val ? '^' + val + '$' : '', true, false).draw();
		}
	});

	// Aggregation (Definition) - neue Regel zur Einschränkung der Untersuchungen hinzufügen
	$('body').on('click', '.tt-add-aggregation-rule', function(e) {
		e.preventDefault();

		var dialogId = '#' + $(this).parents('form')[0].id;
		var order = 1;
		if ($(dialogId).find('.tt-aggregation-rule-order:last').length) {
			order = parseInt($(dialogId).find('.tt-aggregation-rule-order:last').val()) + 2;
		}
		var counter = $(dialogId).find('.tt-aggregation-rule-dynamic-row').length;
		var	newRow = $(dialogId).find('[name="view_aggregation_rule"]').val();
		$(dialogId).find('.tt-aggregation-rules').append(newRow);
		newRow = $(dialogId).find('.tt-aggregation-rules').find('.tt-aggregation-rule-dynamic-row:last');
		newRow.find('.tt-aggregation-rule-order').val(order - 1);
		newRow.find('.tt-aggregation-rule-title').text(order + '. ' + newRow.find('.tt-aggregation-rule-title').text());

		// Name für Select2, Input mit ID und Löschen-Button neu setzen
		$.each(newRow.find('.tt-select2,.btn,.tt-aggregation-rule-id').parent().find('[name]'), function (i, element) {
		    element.setAttribute('name', $(element).attr('name') + '_' + counter);
		});

		initialize.initializeElements(newRow, true, false);

		integrities.setIntegrityFieldSelection('rule_reference_date_' + counter, 'all_date_fields', 'tt-aggregation-rule-reference-date select2-container', $(dialogId));

		if ($(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val() !== 'changed') {
			$(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val('changed');
			$(this).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
		}
	});

	// Aggregation (Definition) - Regel zur Einschränkung der Untersuchungen entfernen
	$('body').on('click', '.tt-remove-aggregation-rule', function(e) {
		e.preventDefault();

		var dialogId = '#' + $(this).parents('form')[0].id;
		var counter = $(this)[0].name.substring($(this)[0].name.lastIndexOf('_') + 1);
		var aggregationRules = $(dialogId).find('.tt-aggregation-rules');

		// Name für Select2, Input mit ID und Löschen-Button neu setzen, sofern diese nach der gelöschten Zeile kommen
		$.each(aggregationRules.find('.tt-select2,.btn,.tt-aggregation-rule-id').parent().find('[name]'), function (i, element) {
		    if (parseInt(element.name.substring(element.name.lastIndexOf('_') + 1)) > parseInt(counter)) {
				element.setAttribute('name', $(element).attr('name').substring(0, element.name.lastIndexOf('_')) + '_' + (parseInt(element.name.substring(element.name.lastIndexOf('_') + 1)) - 1).toString());
			}
		});

		if ($(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val() !== 'changed') {
			$(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val('changed');
			$(this).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
		}

		$(this).parents('.tt-aggregation-rule-dynamic-row').remove();
	});

	// Aggregation (Definition) - Regel zur Einschränkung der Untersuchungen auswählen
	$('body').on('change', '.tt-aggregation-rule', function(e) {
		e.preventDefault();

		var dialogId = '#' + $(this).parents('form')[0].id;
		var selectedValue = $(this).select2('data')[0].id;
		var counter = $(this)[0].name.substring($(this)[0].name.lastIndexOf('_') + 1);

		if (selectedValue === 'newest_value' || selectedValue === 'oldest_value') {
			$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-1').addClass('hide');
			$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-1').find('.tt-select2').val(null).trigger('change.select2');
			$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-2').addClass('hide');
			$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-2').find('.tt-select2').val(null).trigger('change.select2');
        } else {
			$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-1').removeClass('hide');
			$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-1').find('.tt-select2').val(null).trigger('change.select2');
			$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-2').find('.tt-select2').val(null).trigger('change.select2');

		    if (selectedValue === 'restriction_value') {
				integrities.setIntegrityFieldSelection('rule_data_view_field_' + counter, 'all_control_type_value_fields', 'tt-aggregation-rule-data-view-field select2-container', $(dialogId));
				$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-2').removeClass('hide');
            } else {
				integrities.setIntegrityFieldSelection('rule_data_view_field_' + counter, 'all_fields', 'tt-aggregation-rule-data-view-field select2-container', $(dialogId));
				$(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule-dynamic-row-2').addClass('hide');
            }
        }

		if ($(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val() !== 'changed') {
			$(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val('changed');
			$(this).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
		}
    });

	// Aggregation (Definition) - Datenfeld der Regel zur Einschränkung der Untersuchungen auswählen
	$('body').on('change', '.tt-aggregation-rule-data-view-field', function(e) {
		e.preventDefault();

		var ruleValue = $(this).parents('.tt-aggregation-rule-dynamic-row').find('.tt-aggregation-rule').select2('val');

		if (ruleValue === 'restriction_value') {
			var data = [];

			if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {

			    // Unschön programmiert, da die Select2 einmal über JQuery und einmal über PHP befüllt wird und diese nicht gleich befüllt werden können!
			    var controlTypeValuesString = $($(this).select2('data')[0].element).data().controlValues;
			    if (utils.isUndefined(controlTypeValuesString)) {
					controlTypeValuesString = $($(this).select2('data')[0].element).data().data.controlValues;
                }
                if (!utils.isUndefined(controlTypeValuesString)) {
					var controlTypeValues = controlTypeValuesString.split('|');

					jQuery.each(controlTypeValues, function (i, val) {

						var controlTypeValue = val.split('#');

						if (controlTypeValue.length === 2) {
							data.push({id: controlTypeValue[0], text: controlTypeValue[1]});
						}
					});
				}
			}

			validator.reinitializeSelect2($(this).parents('.tt-aggregation-rule-dynamic-row').find('.rule-restriction-control-type-values'), 'tt-aggregation-rule-restriction tt-select2 select2-container', '', data, true);
		}

		if ($(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val() !== 'changed') {
			$(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val('changed');
			$(this).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
		}
	});

	// Aggregation (Definition) - Einschränkungen und Bezugsdatum der Regel zur Einschränkung der Untersuchungen auswählen
	$('body').on('change', '.tt-aggregation-rule-restriction,.tt-aggregation-rule-reference-date', function(e) {
	    e.preventDefault();

		if ($(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val() !== 'changed') {
			$(this).parents('.tt-content-detail').find('.tt-aggregation-rules-changes').val('changed');
			$(this).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
		}
    });

	// Aggregation (Definition) - Übernamhewert auswählen
    $('body').on('change', '.tt-aggregation-value', function(e) {
        e.preventDefault();

        if (!utils.isUndefined($(this).select2('val')) && ($(this).select2('val') === 'row_value' || $(this).select2('val') === 'period_value')) {
            $(this).parents('form').find('.tt-aggregation-edit-field-conversions').removeClass('hide');
        } else {
            $(this).parents('form').find('.tt-aggregation-edit-field-conversions').addClass('hide');
        }
    });

	// Aggregation (Definition) - Datenfeld des Ausgangsprojekts auswählen
    $('body').on('change', '.tt-aggregation-data-view-source-field', function(e) {
        e.preventDefault();

        // Entweder das Datenfeld oder die Zeitraumstabelle können ausgewählt werden
        $(this).parents('form').find('[name="source_data_view_period_table"]').val("").trigger('change.select2');
        $(this).parents('form').find('[name="target_data_view_period_table"]').val("").trigger('change.select2');
        $(this).parents('form').find('[name="aggregation_period_field_conversions"]').val("");

		$(this).parents('form').find('[name="aggregation_control_values"]').val("");
		if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {

		    // Unschön programmiert, da die Select2 einmal über JQuery und einmal über PHP befüllt wird und diese nicht gleich befüllt werden können!
			var controlType = $($(this).select2('data')[0].element).data().controlType;
			if (utils.isUndefined(controlType)) {
				controlType = $($(this).select2('data')[0].element).data().data.controlType;
			}

			var elementsWithRangeOfValues = ['group_with_radio', 'list_with_radio', 'combo', 'combo_multiselect', 'radio', 'combo_with_additionalfield',
				'combo_multiselect_with_additionalfield', 'radio_with_additionalfield', 'combo_with_two_additionalfields', 'combo_multiselect_with_two_additionalfields',
				'radio_with_two_additionalfields', 'column_with_radio', 'accordion_with_radio', 'accordion_as_list_with_radio'];

			if (jQuery.inArray(controlType, elementsWithRangeOfValues) >= 0) {
				$(this).parents('form').find('.tt-aggregation-edit-control-values').removeClass('hide');
			} else {
				$(this).parents('form').find('.tt-aggregation-edit-control-values').addClass('hide');
			}
		} else {
            $(this).parents('form').find('.tt-aggregation-edit-control-values').addClass('hide');
        }
    });

    // Aggregation (Definition) - Zeitraumstabelle des Ausgangsprojekts auswählen
    $('body').on('change', '.tt-aggregation-data-view-source-period-table', function(e) {
        e.preventDefault();

        // Entweder das Datenfeld oder die Zeitraumstabelle können ausgewählt werden
        $(this).parents('form').find('[name="source_data_view_field"]').val("").trigger('change.select2');
        $(this).parents('form').find('[name="target_data_view_field"]').val("").trigger('change.select2');

        $(this).parents('form').find('[name="aggregation_control_values"]').val("");
        $(this).parents('form').find('.tt-aggregation-edit-control-values').addClass('hide');

        $(this).parents('form').find('[name="aggregation_period_field_conversions"]').val("");
    });

    // Aggregation (Definition) - Neue Feld-Konvertierung auswählen
    $('body').on('change', '.tt-aggregation-period-field-conversion', function(e) {
        e.preventDefault();

        var dataTable = $('#table_aggregation_definition_period_field_conversions').dataTable();
        var tr = $(this).parents('tr');
        var aPos = dataTable.fnGetPosition(tr[0]);

        dataTable.fnGetData(aPos)[6] = $(this).select2('val');
    });

    // Aggregation (Definition) - Zeitraum VON oder Zeitraum BIS bei den Feld-Konvertierungen anhaken
    $('body').on('change', '.tt-aggregation-period-field-conversion-checkbox-from,.tt-aggregation-period-field-conversion-checkbox-till', function (e) {
        e.preventDefault();

        var dataTable = $('#table_aggregation_definition_period_field_conversions').dataTable();
        var tr = dataTable.$('tr.selected-row');
        var aPos = dataTable.fnGetPosition(tr[0]);

        if ($(this).hasClass('tt-aggregation-period-field-conversion-checkbox-from')) {
            dataTable.fnGetData(aPos)[7] = $(this)[0].checked ? 1 : 0;
        } else {
            dataTable.fnGetData(aPos)[8] = $(this)[0].checked ? 1 : 0;
        }
    });

	// Aggregation (Durchführung) - Checkbox für Warnungen/Fehler
	$('body').on('change', '.tt-checkbox-warnings', function (e) {

		var table_warnings = $('.tt-aggregation-execution-warnings-table');

		if ($('[name="show-warnings"]').is(':checked')){

			table_warnings.find('.tt-warnings').addClass('hide');

		}else
		{
			table_warnings.find('.tt-warnings').removeClass('hide');
		}

	});

	// Aggregation (Durchführung) - Vorschau nächster Patient
	$('body').on('click', '.tt-next-aggregation-preview', function(e) {

		var count = 0;
		var index = 0;
		var selectedTab = $(this).parents('.tt-content-detail').find('li.active a').attr('href').substr(1);
		var currentPatient = $(this).parents('.tt-content-detail').find('[name="preview_patient"]').val();
		var previewData = [];
		if ($(this).parents('.tt-content-detail').find('[name="preview_data"]').val() !== '') {
		    previewData = $.parseJSON($(this).parents('.tt-content-detail').find('[name="preview_data"]').val());
		}

		for (var key in previewData) {
			if (key.split('|')[0] === currentPatient) {
				break;
			}
			index++;
		}

		for (var key in previewData) {
			if (count === index + 1) {
				if (index === 4) {
					$(this).parents('.tt-content-detail').find('.tt-next-aggregation-preview').addClass('disabled');
					$(this).parents('.tt-content-detail').find('.tt-next-aggregation-preview').prop('disabled', 'disabled');
				}
				$(this).parents('.tt-content-detail').find('.tt-previous-aggregation-preview').removeClass('disabled');
				$(this).parents('.tt-content-detail').find('.tt-previous-aggregation-preview').removeAttr('disabled');
				$('.tt-patient-preview').html(views.getPatientDisplayName(key.split('|')[1], '', '', key.split('|')[2], key.split('|')[3], null, null, null));
				$(this).parents('.tt-content-detail').find('[name="preview_patient"]').val(key.split('|')[0]);
				break;
			}
			count++;
		}

		$('[href="#' + selectedTab + '"]').tab('show');
		$('#table_aggregation_preview').dataTable().api().clear().rows.add(previewData[key]).draw();
		$('#table_aggregation_preview').DataTable().search(selectedTab.replace(/"/g, '\\b'), true, true).draw();

	});

	// Aggregation (Durchführung) - Vorschau vorheriger Patient
	$('body').on('click', '.tt-previous-aggregation-preview', function(e) {

		var count = 0;
		var index = 0;
		var selectedTab = $(this).parents('.tt-content-detail').find('li.active a').attr('href').substr(1);
		var currentPatient = $(this).parents('.tt-content-detail').find('[name="preview_patient"]').val();
		var previewData = [];
		if ($(this).parents('.tt-content-detail').find('[name="preview_data"]').val() !== '') {
			previewData = $.parseJSON($(this).parents('.tt-content-detail').find('[name="preview_data"]').val());
		}

		for (var key in previewData) {
			if (key.split('|')[0] === currentPatient) {
				break;
			}
			index++;
		}

		for (var key in previewData) {
			if (count === index - 1) {
				if (index === 1) {
					$(this).parents('.tt-content-detail').find('.tt-previous-aggregation-preview').addClass('disabled');
					$(this).parents('.tt-content-detail').find('.tt-previous-aggregation-preview').prop('disabled', 'disabled');
				}
				$(this).parents('.tt-content-detail').find('.tt-next-aggregation-preview').removeClass('disabled');
				$(this).parents('.tt-content-detail').find('.tt-next-aggregation-preview').removeAttr('disabled');
				$('.tt-patient-preview').html(views.getPatientDisplayName(key.split('|')[1], '', '', key.split('|')[2], key.split('|')[3], null, null, null));
				$(this).parents('.tt-content-detail').find('[name="preview_patient"]').val(key.split('|')[0]);
				break;
			}
			count++;
		}

		$('[href="#' + selectedTab + '"]').tab('show');
		$('#table_aggregation_preview').dataTable().api().clear().rows.add(previewData[key]).draw();
		$('#table_aggregation_preview').DataTable().search(selectedTab.replace(/"/g, '\\b'), true, true).draw();

	});

	// Aggregation (Durchführung) - Einrichtungen anzeigen TODO: die Liste so befüllen, dass "Alle Einrichtungen" auswählbar sind (.tt-aggregation-execution-source-model,.tt-aggregation-execution-details)
	$('body').on('change', '.tt-aggregation-execution-source-model,.tt-aggregation-execution-details', function(e) {
		e.preventDefault();

	    var sourceModelId = 0;
		var periodValueFrom = null;
		var periodValueTill = null;
		var comboData = [];

		if ($(this).parents('form').find('[name="source_model"]').select2('data').length > 0 && $(this).parents('form').find('[name="source_model"]').select2('data')[0].id !== '') {
			sourceModelId = $(this).parents('form').find('[name="source_model"]').val();
		}

		var fromPicker = $(this).parents('form').find('[name="aggregation_execution_period_value_from"]');
		if ($(fromPicker).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
			periodValueFrom = $(fromPicker).data('picker').getDate();
		}

		var tillPicker = $(this).parents('form').find('[name="aggregation_execution_period_value_till"]');
		if ($(tillPicker).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') {
			periodValueTill = $(tillPicker).data('picker').getDate();
		}

		if (sourceModelId !== 0 && !utils.isUndefined(periodValueFrom) && !utils.isUndefined(periodValueTill)) {

			var ajaxData = '&' + jQuery.param({source_model: sourceModelId, period_from: utils.dateToString(periodValueFrom), period_till: utils.dateToString(periodValueTill)});
			ajax.ajaxCall('admin/aggregation_execution/facilities', 'GET', ajaxData, false, function (data) {

			    if (data.length > 0) {
					comboData.push({ id: 0, text: trans('tripletrax.all_facilities'), match: 'unknown' });
                }

				for (var i = 0; i < data.length; ++i) {
					comboData.push({ id: data[i][0], text: data[i][1], match: data[i][2] });
                }

				validator.reinitializeSelect2($('.tt-select-aggregation-facilities').parent(), 'tt-select2 tt-select-aggregation-facilities tt-combo-multiselect', '', comboData, true);
			});

        } else {
			validator.reinitializeSelect2($('.tt-select-aggregation-facilities').parent(), 'tt-select2 tt-select-aggregation-facilities tt-combo-multiselect', '', comboData, true);
		}

	});

	// Aggregation (Durchführung) - Vorschau: Tab auswählen
	$('body').on('click', '.tt-aggregation-preview-tab', function(e) {

		$('#table_aggregation_preview').DataTable().search($(this).attr('href').substr(1).replace(/"/g, '\\b'), true, true).draw();
	});

	// Datei für die Übersetzungen von Fragebögen Speichern oder Einlesen
    $('body').on('click', '.tt-load-translation-file', function(e) {
        e.preventDefault();

        var questionnaires = [];
		jQuery.each($('#table_data_collection_type_questionnaires').dataTable().fnGetData(), function (i, val) {
			questionnaires.push(val[2]);
		});

		var action = $(this).data().action;
		ajax.ajaxCall($(this).data().action, $(this).data().method, {'languages': $('[name="languages"]').val(), 'questionnaires': questionnaires, 'abbreviation': $('[name="abbreviation"]').val()}, false, function (data) {

			if (data === 'not_existing') {

				$.SmartMessageBox({
					title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_translation_file'),
					content: Lang.get('tripletrax.not_existing_translation_file_desc'),
					buttons: '[' + Lang.get('tripletrax.ok') + ']'
				}, function (ButtonPressed) {
				});
			} else {
				// Datei herunterladen
				window.open(action + '/download/' + data, '_blank');

				// Datei auf PUBLIC wieder löschen (Timeout hinzugefügt, da sonst die Datei zu schnell gelöscht wird)
				setTimeout(function() {
					ajax.ajaxCall(action + '/delete/' + data, "POST", null, false, function (data) {});
				}, 500);
			}
		});
    });

	// Import-Datei auswählen (Open-Folder-Dialog anzeigen)
	$('body').on('click', '.tt-save-translation-file', function (e) {
		e.preventDefault();

		$('#translation_file_name')[0].click();
	});

	// Import-Datei auswählen (Übernahme des Dateinamens in das Input-Feld & De- / Aktivierung der Feldtrenner)
	$('body').on('change', '#translation_file_name', function (e) {

	    if ($(this)[0].files.length) {
			var formData = new FormData();
			formData.append('translation_file', $(this)[0].files[0]);
			var action = $('.tt-save-translation-file').data().action;
			ajax.ajaxCallExtended($('.tt-save-translation-file').data().action, $('.tt-save-translation-file').data().method, formData, false, false, false, null, null, function (data) {
				$('#translation_file_name').val('');
			});
		}
	});

	$(window).on('load', function () {
		if ($('.tt-show-questionnaires').length) {
			initialize.initializeElements($('#content'), true, false);
			utils.setIDATData($('#content'));
			$('.tt-btn-eraser,.tt-btn-query').addClass('hide');
			validator.addQuestionnairesRules($('#content').find('form'));
		} else {
            utils.setIDATData($("#content"));

            changes.calculateLeftNavHeight();
        }
	});

	// Datei aus dem Systemereignis speichern
	$('body').on('click', '.tt-save-file', function(e) {
		e.preventDefault();

		var action = $(this).data().action + '/' + $(this).data('selectedId') + '/download';
		window.open(action, '_blank');
	});

	// Systemereignis nochmals ausführen
	$('body').on('click', '.tt-redo-event', function(e) {
		e.preventDefault();

		var action = $(this).data().action + '/' + $(this).data('selectedId') + '/redo';
		$('.tt-please-wait').removeClass('hide');
		$(this).addClass('disabled');
		$('.tt-save-file').addClass('disabled');
		ajax.ajaxCall(action, $(this).data().method, null, false, function (data) {

			$('.tt-please-wait').addClass('hide');
			$('#table_system_events').dataTable().fnStandingRedraw();

		});
	});

	// Ausdruck Fragebogen
	$('body').on('click', '.tt-print-questionnaire', function(e) {
	    e.preventDefault();

		var date = new Date();
		var activeTab = $('.tt-content-questionnaires').find('.nav-tabs li.active a')[0];
		var patientData = $('.tt-content-questionnaires').find('.header-master-overview')[0].outerHTML;
		var dateString = '<section class="tt-date"><span class="tt-date-today pull-right">' + utils.dateToLocaleString(date) + '</span></section>';
		var buttons = $(activeTab.hash).find('.tt-btn-view');
		var buttonView = [];

		jQuery.each(buttons, function (i, button) {
			if (!$(button).hasClass('hide')) {
				buttonView.push(button);
            }
		});

		$('.radio').find('[type="radio"]').attr('type', 'checkbox');
		$('.radio').removeClass('radio').addClass('checkbox');

		$('.tt-questionnaire-detail').find('.tt-btn-view').addClass('hide');
		$('.tt-content-questionnaires').find('.tt-print-questionnaire').addClass('hide');
		$('.tt-content-questionnaires').find('.tt-patient-detail').addClass('hide');

		$(activeTab.hash).find('fieldset')[0].insertAdjacentHTML('afterbegin', patientData);
		$(activeTab.hash).find('fieldset')[0].insertAdjacentHTML('afterbegin', dateString);


		html2canvas($(activeTab.hash), {
			onrendered: function(canvas) {
				var timestamp = $.now();
				canvas.style.width = '100%';
				ajax.ajaxCall('doc/patient/patient/questionnaire/print', 'POST', '&timestamp=' + timestamp + '&canvas=' + canvas.toDataURL(), false, function (data) {
					$(activeTab.hash).find('.txt-color-green').remove();
					$(activeTab.hash).find('.tt-date').remove();

					$('.checkbox').find('[type="checkbox"]').attr('type', 'radio');
					$('.checkbox').removeClass('checkbox').addClass('radio');
					$('.tt-content-questionnaires').find('.tt-print-questionnaire').removeClass('hide');
					$('.tt-content-questionnaires').find('.tt-patient-detail').removeClass('hide');

					jQuery.each(buttonView, function (i, button) {
						$(button).removeClass('hide');
					});


					ajax.ajaxCall('doc/patient/patient/questionnaire/check/' + timestamp, 'GET', null, false, function (data) {

						if (data === 'not_existing') {
							$.SmartMessageBox({
								title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.not_existing_report_file'),
								content: Lang.get('tripletrax.not_existing_report_file_desc'),
								buttons: '[' + Lang.get('tripletrax.ok') + ']'
							}, function (ButtonPressed) {
							});
						} else {
							var originalFilename = 'questionnaire_patient';

							// Datei herunterladen
							window.open('doc/patient/patient/questionnaire/download/' + data + '/' + encodeURI(originalFilename), '_blank');

							// Datei auf PUBLIC wieder löschen (Timeout hinzugefügt, da sonst die Datei zu schnell gelöscht wird)
							setTimeout(function () {
								ajax.ajaxCall('doc/patient/patient/questionnaire/delete/' + data, 'POST', null, false, function (data) {
								});
							}, 100);
						}
					});
				});
			}
		});
    });
}

function checkDoSubmit(form) {

    return $.Deferred(function (defer) {
        if (!utils.isUndefined(form)) {
            if (form.id === 'table_patient_agreement_create_form') {

                // Wenn ein Enddatum angegeben ist oder die Einwilligung auf "Widerrufen" gesetzt ist, dann Meldung bringen, dass auch die abhängigen Teilnahmen abgeändert werden
                if ($(form).find('[name="end_date"]').data('picker').getDate() !== null || $(form).find('[name="agreement"]:checked').val() === '3') {

                    var oldEndDate = $(form).find('.tt-selected-end-date').val();
                    var oldAgreement = $(form).find('.tt-selected-agreement').val();

                    var newEndDate = utils.dateToString($(form).find('[name="end_date"]').data('picker').getDate()) + ' 00:00:00';
                    var newAgreement = $(form).find('[name="agreement"]:checked').val();

                    if (oldEndDate !== newEndDate || oldAgreement !== newAgreement) {
                        var select2 = $(form).find('.tt-select2').select2('data')[0];
                        if (select2.other_depending_models !== '') {

                            checkPatientAgreements($.parseJSON($('#models_with_register_patient_right').val()), select2.models, select2.text, select2.other_depending_models, newEndDate, false).done(function (doChange) {
                                if (!doChange) {
                                    $(form).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
                                }
                                defer.resolve(doChange.toString());
                            });
                        } else {
                            defer.resolve('true');
                        }
                    } else {
                        defer.resolve('true');
                    }
                } else {
                    defer.resolve('true');
                }
            } else if (form.id === 'table_data_views_detail_form') {
                // Wenn eine Berechnung ausgewählt wurde, welche eine Einheit zurückgibt, muss diese Einheit bei den Einheiten angelegt sein.

                var unit = '';
                var foundUnit = true;
                var unitAdditionalField = '';
                var foundUnitAdditionalField = true;
                if (!utils.isUndefined($(form).find('[name="calculation"]').length && $(form).find('[name="calculation"]').select2('val')) && $(form).find('[name="calculation"]').length && $(form).find('[name="calculation"]').select2('val') !== '') {
                    var option = $(form).find('[name="calculation"]').select2('data')[0];
                    unit = $(option.element).data().unit;
                    if (unit !== '') {
                        foundUnit = false;
                        var existingUnits = $(form).find('[name="edit_units"]').val().split('|');
                        jQuery.each(existingUnits, function (i, existingUnit) {
                            if (existingUnit.split('#')[2] === unit) {
                                foundUnit = true;
                            }
                        });
                    }
                }
                if (!utils.isUndefined($(form).find('[name="calculation_additionalfield_1"]').length && $(form).find('[name="calculation_additionalfield_1"]').select2('val')) && $(form).find('[name="calculation_additionalfield_1"]').length && $(form).find('[name="calculation_additionalfield_1"]').select2('val') !== '') {
                    var option = $(form).find('[name="calculation_additionalfield_1"]').select2('data')[0];
                    unitAdditionalField = $(option.element).data().unit;
                    if (unitAdditionalField !== '') {
                        foundUnitAdditionalField = false;
                        var existingUnits = $(form).find('[name="edit_units_additionalfield_1"]').val().split('|');
                        jQuery.each(existingUnits, function (i, existingUnit) {
                            if (existingUnit.split('#')[2] === unitAdditionalField) {
                                foundUnitAdditionalField = true;
                            }
                        });
                    }
                }
                if (!foundUnit || !foundUnitAdditionalField) {
                    var missingUnits = '';
                    if (!foundUnit) {
                        missingUnits = $('[name="calculation"]').select2('data')[0].text + ' (' + unit + ')';
                    }
                    if (!foundUnitAdditionalField) {
                        if (missingUnits !== '') {
                            missingUnits += '<br>';
                        }
                        missingUnits += $('[name="calculation_additionalfield_1"]').select2('data')[0].text + ' (' + unitAdditionalField + ')';
                    }
                    $.SmartMessageBox({
                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.calculation_missing_unit'),
                        content: Lang.get('tripletrax.calculation_missing_unit_desc', {'missing_units': missingUnits}),
                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                    }, function (ButtonPressed) {
                        defer.resolve('false');
                    });

                } else {
                    // Wenn Integritäten bzw. Berechnungen geändert oder hinzugefügt wurden, Meldung anzeigen, dass ggf. Werte auf der Datenbank gelöscht oder geändert werden können
                    // -> Meldung bei Integritäten nur anzeigen, wenn es sich nicht um ein neues Feld handelt, bei Berechnungen Meldung immer anzeigen
                    var integrityChanged = false;

                    if ($('[name="edit_integrity_rules_init_value"]').length && $('[name="edit_integrity_rules"]').length && $('[name="data_view_id"]').val() !== '0') {
                        var oldValues = $('[name="edit_integrity_rules_init_value"]').val().split('|');
                        var newValues = $('[name="edit_integrity_rules"]').val().split('|');

                        if ($('[name="edit_integrity_rules"]').val() !== '') {
                            $.each(newValues, function (i, newIntegrity) {
                                if (!(newIntegrity.split('#')[3] === 'completeness' || (newIntegrity.split('#')[3] === 'dependency' && newIntegrity.split('#')[19] !== 'no'))) {
                                    if (newIntegrity.split('#')[0] === '') {
                                        integrityChanged = true;
                                        return false;
                                    } else {
                                        $.each(oldValues, function (j, oldIntegrity) {
                                            if (newIntegrity.split('#')[0] == oldIntegrity.split('#')[0]) {
                                                if (newIntegrity !== oldIntegrity) {
                                                    integrityChanged = true;
                                                    return false;
                                                }
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }

                    if (!integrityChanged && $('[name="edit_integrity_rules_additionalfield_1"]').length && $('[name="data_view_id"]').val() !== '0') {
                        var oldValuesAdditionalField1 = $('[name="edit_integrity_rules_additionalfield_1_init_value"]').val().split('|');
                        var newValuesAdditionalField1 = $('[name="edit_integrity_rules_additionalfield_1"]').val().split('|');

                        if ($('[name="edit_integrity_rules_additionalfield_1"]').val() !== '') {
                            $.each(newValuesAdditionalField1, function (i, newIntegrity) {
                                if (!(newIntegrity.split('#')[3] === 'completeness' || (newIntegrity.split('#')[3] === 'dependency' && newIntegrity.split('#')[19] !== 'no'))) {
                                    if (newIntegrity.split('#')[0] === '') {
                                        integrityChanged = true;
                                        return false;
                                    } else {
                                        $.each(oldValuesAdditionalField1, function (j, oldIntegrity) {
                                            if (newIntegrity.split('#')[0] == oldIntegrity.split('#')[0]) {
                                                if (newIntegrity !== oldIntegrity) {
                                                    integrityChanged = true;
                                                    return false;
                                                }
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }

                    if (!integrityChanged && $('[name="edit_integrity_rules_additionalfield_2"]').length && $('[name="data_view_id"]').val() !== '0') {
                        var oldValuesAdditionalField2 = $('[name="edit_integrity_rules_additionalfield_2_init_value"]').val().split('|');
                        var newValuesAdditionalField2 = $('[name="edit_integrity_rules_additionalfield_2"]').val().split('|');

                        if ($('[name="edit_integrity_rules_additionalfield_2"]').val() !== '') {
                            $.each(newValuesAdditionalField2, function (i, newIntegrity) {
                                if (!(newIntegrity.split('#')[3] === 'completeness' || (newIntegrity.split('#')[3] === 'dependency' && newIntegrity.split('#')[19] !== 'no'))) {
                                    if (newIntegrity.split('#')[0] === '') {
                                        integrityChanged = true;
                                        return false;
                                    } else {
                                        $.each(oldValuesAdditionalField2, function (j, oldIntegrity) {
                                            if (newIntegrity.split('#')[0] == oldIntegrity.split('#')[0]) {
                                                if (newIntegrity !== oldIntegrity) {
                                                    integrityChanged = true;
                                                    return false;
                                                }
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }

                    var calculationChanged = false;

                    if ($('[name="edit_calculation_init_value"]').length && $('[name="edit_calculation"]').length) {
                        var oldValue = $('[name="edit_calculation_init_value"]').val();
                        var newValue = $('[name="edit_calculation"]').val();

                        if (oldValue !== newValue && newValue !== '') {
                            calculationChanged = true;
                        }
                    }

                    if (!calculationChanged && $('[name="edit_calculation_additionalfield_1"]').length) {
                        var oldValueAdditionalField1 = $('[name="edit_calculation_additionalfield_1_init_value"]').val();
                        var newValueAdditionalField1 = $('[name="edit_calculation_additionalfield_1"]').val();

                        if (oldValueAdditionalField1 !== newValueAdditionalField1 && newValueAdditionalField1 !== '') {
                            calculationChanged = true;
                        }
                    }

                    if (integrityChanged && calculationChanged) {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_calculation_changed_title'),
                            content: Lang.get('tripletrax.integrities_calculation_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    } else if (calculationChanged) {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_calculation_changed_title'),
                            content: Lang.get('tripletrax.calculation_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    } else if (integrityChanged) {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_calculation_changed_title'),
                            content: Lang.get('tripletrax.integrities_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    } else {
                        defer.resolve('true');
                    }
                }
            } else if (form.id === 'table_collection_type_integrities_form') {
                // Bei Vergleiche zwischen 2 Input-Felder prüfen, ob diese mind. eine gemeine Einheit besitzen
                // Wenn nicht, Meldung anzeigen
                var integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;
                if (integrity_type_id === 'range' || integrity_type_id === 'dependency') {

                    var control_type = $(form).parents('.tt-content-dialog').find('[name="control_type"]').val();
                    var data_type = $(form).parents('.tt-content-dialog').find('[name="data_type"]').val();

                    if (integrity_type_id === 'range') {
                        if ((control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea')
                            && (data_type === 'integer' || data_type === 'decimal')) {

                            var select_field = $(form).find('[name="integrity_data_view_field"]').select2('val').split('|');
                            var data_view_id = select_field[0];
                            var data_view_name = select_field[1];

                            var value_from_data_view_id = '';
                            var value_from_data_view_name = '';
                            var value_from_unit_1 = '';
                            var value_from_unit_2 = '';
                            var value_till_data_view_id = '';
                            var value_till_data_view_name = '';
                            var value_till_unit_1 = '';
                            var value_till_unit_2 = '';


                            var select_value_from_field = $(form).find('[name="integrity_value_from_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                                value_from_data_view_id = select_value_from_field.id.split('|')[0];
                                value_from_data_view_name = select_value_from_field.id.split('|')[1];
                            }
                            var select_value_from_unit_1 = $(form).find('[name="integrity_value_from_field_unit_1"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_unit_1) && select_value_from_unit_1.text !== '') {
                                value_from_unit_1 = select_value_from_unit_1.id;
                            }
                            var select_value_from_unit_2 = $(form).find('[name="integrity_value_from_field_unit_2"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_unit_2) && select_value_from_unit_2.text !== '') {
                                value_from_unit_2 = select_value_from_unit_2.id;
                            }

                            var select_value_till_field = $(form).find('[name="integrity_value_till_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                                value_till_data_view_id = select_value_till_field.id.split('|')[0];
                                value_till_data_view_name = select_value_till_field.id.split('|')[1];
                            }
                            var select_value_till_unit_1 = $(form).find('[name="integrity_value_till_field_unit_1"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_unit_1) && select_value_till_unit_1.text !== '') {
                                value_till_unit_1 = select_value_till_unit_1.id;
                            }
                            var select_value_till_unit_2 = $(form).find('[name="integrity_value_till_field_unit_2"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_unit_2) && select_value_till_unit_2.text !== '') {
                                value_till_unit_2 = select_value_till_unit_2.id;
                            }

                            if ((value_from_data_view_id !== '' && (value_from_unit_1 === '' || value_from_unit_2 === '')) || (value_till_data_view_id !== '' && (value_till_unit_1 === '' || value_till_unit_2 === ''))) {
                                var ajaxData = '&' + jQuery.param({fields: data_view_id + '#' + data_view_name + '#' + value_from_data_view_id + '#' + value_from_data_view_name + '#' + value_till_data_view_id + '#' + value_till_data_view_name});

                                ajax.ajaxCallDeferred("admin/monitoring/checkunit", "GET", ajaxData, false).done(function (data) {

                                    if (data === 'false') {
                                        $.SmartMessageBox({
                                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.monitoring_restriction_not_same_unit_title'),
                                            content: Lang.get('tripletrax.monitoring_restriction_not_same_unit_desc'),
                                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                        }, function (ButtonPressed) {
                                            defer.resolve('false');
                                        });
                                    } else {
                                        checkCompletenessDeactivationDataCollectionType(form).done(function (doCompletenessDeactivation) {

                                            defer.resolve(doCompletenessDeactivation);
                                        });
                                    }
                                });
                            } else {
                                checkCompletenessDeactivationDataCollectionType(form).done(function (doCompletenessDeactivation) {

                                    defer.resolve(doCompletenessDeactivation);
                                });
                            }
                        } else {
                            checkCompletenessDeactivationDataCollectionType(form).done(function (doCompletenessDeactivation) {

                                defer.resolve(doCompletenessDeactivation);
                            });
                        }
                    } else {
                        if ((control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea')
                            && (data_type === 'integer' || data_type === 'decimal')) {

                            var select_field = $(form).find('[name="integrity_data_view_field"]').select2('val').split('|');
                            var data_view_id = select_field[0];
                            var data_view_name = select_field[1];

                            var value_from_data_view_id = '';
                            var value_from_data_view_name = '';
                            var value_till_data_view_id = '';
                            var value_till_data_view_name = '';

                            var select_value_from_field = $(form).find('[name="integrity_field_value_from_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                                value_from_data_view_id = select_value_from_field.id.split('|')[0];
                                value_from_data_view_name = select_value_from_field.id.split('|')[1];
                            }

                            var select_value_till_field = $(form).find('[name="integrity_field_value_till_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                                value_till_data_view_id = select_value_till_field.id.split('|')[0];
                                value_till_data_view_name = select_value_till_field.id.split('|')[1];
                            }

                            if (value_from_data_view_id !== '' || value_till_data_view_id !== '') {
                                var ajaxData = '&' + jQuery.param({fields: data_view_id + '#' + data_view_name + '#' + value_from_data_view_id + '#' + value_from_data_view_name + '#' + value_till_data_view_id + '#' + value_till_data_view_name});

                                ajax.ajaxCallDeferred("admin/monitoring/checkunit", "GET", ajaxData, false).done(function (data) {

                                    if (data === 'false') {
                                        $.SmartMessageBox({
                                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.monitoring_restriction_not_same_unit_title'),
                                            content: Lang.get('tripletrax.monitoring_restriction_not_same_unit_desc'),
                                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                        }, function (ButtonPressed) {
                                            defer.resolve('false');
                                        });
                                    } else {
                                        checkDependingFieldDataCollectionType(form).done(function (doCheck) {

                                            defer.resolve(doCheck);
                                        });
                                    }
                                });
                            } else {
                                checkDependingFieldDataCollectionType(form).done(function (doCheck) {

                                    defer.resolve(doCheck);
                                });
                            }
                        } else {
                            checkDependingFieldDataCollectionType(form).done(function (doCheck) {

                                defer.resolve(doCheck);
                            });
                        }
                    }
                } else {
                    checkCompletenessDeactivationDataCollectionType(form).done(function (doCompletenessDeactivation) {

                        defer.resolve(doCompletenessDeactivation);
                    });
                }

            } else if (form.id === 'table_data_views_integrities_create_form' || form.id === 'table_data_views_integrities_form') {

                // Bei Vergleiche zwischen 2 Input-Felder prüfen, ob diese mind. eine gemeine Einheit besitzen
                // Wenn nicht, Meldung anzeigen
                var integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;
                if (integrity_type_id === 'range' || integrity_type_id === 'dependency') {

                    var control_type = $(form).parents('.tt-content-dialog').find('[name="control_type"]').val();
                    var data_type = $(form).parents('.tt-content-dialog').find('[name="data_type"]').val();

                    if (integrity_type_id === 'range') {
                        if ((control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea')
                            && (data_type === 'integer' || data_type === 'decimal')) {

                            var data_view_id = $(form).parents('.tt-content-dialog').find('[name="data_view_id"]').val();
                            var data_view_name = $(form).parents('.tt-content-dialog').find('[name="data_view_name"]').val();

                            var value_from_data_view_id = '';
                            var value_from_data_view_name = '';
                            var value_from_unit_1 = '';
                            var value_from_unit_2 = '';
                            var value_till_data_view_id = '';
                            var value_till_data_view_name = '';
                            var value_till_unit_1 = '';
                            var value_till_unit_2 = '';

                            var select_value_from_field = $(form).find('[name="integrity_value_from_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                                value_from_data_view_id = select_value_from_field.id.split('|')[0];
                                value_from_data_view_name = select_value_from_field.id.split('|')[1];
                            }
                            var select_value_from_unit_1 = $(form).find('[name="integrity_value_from_field_unit_1"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_unit_1) && select_value_from_unit_1.text !== '') {
                                value_from_unit_1 = select_value_from_unit_1.id;
                            }
                            var select_value_from_unit_2 = $(form).find('[name="integrity_value_from_field_unit_2"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_unit_2) && select_value_from_unit_2.text !== '') {
                                value_from_unit_2 = select_value_from_unit_2.id;
                            }

                            var select_value_till_field = $(form).find('[name="integrity_value_till_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                                value_till_data_view_id = select_value_till_field.id.split('|')[0];
                                value_till_data_view_name = select_value_till_field.id.split('|')[1];
                            }
                            var select_value_till_unit_1 = $(form).find('[name="integrity_value_till_field_unit_1"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_unit_1) && select_value_till_unit_1.text !== '') {
                                value_till_unit_1 = select_value_till_unit_1.id;
                            }
                            var select_value_till_unit_2 = $(form).find('[name="integrity_value_till_field_unit_2"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_unit_2) && select_value_till_unit_2.text !== '') {
                                value_till_unit_2 = select_value_till_unit_2.id;
                            }

                            if ((value_from_data_view_id !== '' && (value_from_unit_1 === '' || value_from_unit_2 === '')) || (value_till_data_view_id !== '' && (value_till_unit_1 === '' || value_till_unit_2 === ''))) {
                                var ajaxData = '&' + jQuery.param({fields: data_view_id + '#' + data_view_name + '#' + value_from_data_view_id + '#' + value_from_data_view_name + '#' + value_till_data_view_id + '#' + value_till_data_view_name});

                                ajax.ajaxCallDeferred("admin/monitoring/checkunit", "GET", ajaxData, false).done(function (data) {

                                    if (data === 'false') {
                                        $.SmartMessageBox({
                                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.monitoring_restriction_not_same_unit_title'),
                                            content: Lang.get('tripletrax.monitoring_restriction_not_same_unit_desc'),
                                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                        }, function (ButtonPressed) {
                                            defer.resolve('false');
                                        });
                                    } else {
                                        checkCompletenessDeactivationDataView(form).done(function (doCompletenessDeactivation) {

                                            defer.resolve(doCompletenessDeactivation);
                                        });
                                    }
                                });
                            } else {
                                checkCompletenessDeactivationDataView(form).done(function (doCompletenessDeactivation) {

                                    defer.resolve(doCompletenessDeactivation);
                                });
                            }
                        } else {
                            checkCompletenessDeactivationDataView(form).done(function (doCompletenessDeactivation) {

                                defer.resolve(doCompletenessDeactivation);
                            });
                        }
                    } else {
                        if ((control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea')
                            && (data_type === 'integer' || data_type === 'decimal')) {

                            var data_view_id = $(form).parents('.tt-content-dialog').find('[name="data_view_id"]').val();
                            var data_view_name = $(form).parents('.tt-content-dialog').find('[name="data_view_name"]').val();

                            var value_from_data_view_id = '';
                            var value_from_data_view_name = '';
                            var value_till_data_view_id = '';
                            var value_till_data_view_name = '';

                            var select_value_from_field = $(form).find('[name="integrity_field_value_from_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                                value_from_data_view_id = select_value_from_field.id.split('|')[0];
                                value_from_data_view_name = select_value_from_field.id.split('|')[1];
                            }

                            var select_value_till_field = $(form).find('[name="integrity_field_value_till_field"]').select2('data')[0];
                            if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                                value_till_data_view_id = select_value_till_field.id.split('|')[0];
                                value_till_data_view_name = select_value_till_field.id.split('|')[1];
                            }

                            if (value_from_data_view_id !== '' || value_till_data_view_id !== '') {
                                var ajaxData = '&' + jQuery.param({fields: data_view_id + '#' + data_view_name + '#' + value_from_data_view_id + '#' + value_from_data_view_name + '#' + value_till_data_view_id + '#' + value_till_data_view_name});

                                ajax.ajaxCallDeferred("admin/monitoring/checkunit", "GET", ajaxData, false).done(function (data) {

                                    if (data === 'false') {
                                        $.SmartMessageBox({
                                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.monitoring_restriction_not_same_unit_title'),
                                            content: Lang.get('tripletrax.monitoring_restriction_not_same_unit_desc'),
                                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                        }, function (ButtonPressed) {
                                            defer.resolve('false');
                                        });
                                    } else {
                                        checkDependingFieldDataView(form).done(function (doCheck) {

                                            defer.resolve(doCheck);
                                        });
                                    }
                                });
                            } else {
                                checkDependingFieldDataView(form).done(function (doCheck) {

                                    defer.resolve(doCheck);
                                });
                            }
                        } else {
                            checkDependingFieldDataView(form).done(function (doCheck) {

                                defer.resolve(doCheck);
                            });
                        }
                    }
                } else {
                    checkCompletenessDeactivationDataView(form).done(function (doCompletenessDeactivation) {

                        defer.resolve(doCompletenessDeactivation);
                    });
                }

            } else if (form.id === 'table_monitoring_restriction_create_form' || form.id === 'table_monitoring_types_restriction_form') {
                // Bei Vergleiche zwischen 2 Input-Felder prüfen, ob diese mind. eine gemeine Einheit besitzen
                // Wenn nicht, Meldung anzeigen
                var control_type = $(form).parents('.tt-content-dialog').find('[name="control_type"]').val();
                var data_type = $(form).parents('.tt-content-dialog').find('[name="data_type"]').val();

                if ((control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea')
                    && (data_type === 'integer' || data_type === 'decimal')) {

                    var select_field = $(form).find('[name="monitoring_restriction_data_view_field"]').select2('val').split('|');
                    var data_view_id = select_field[0];
                    var data_view_name = select_field[1];

                    var value_from_data_view_id = '';
                    var value_from_data_view_name = '';
                    var value_till_data_view_id = '';
                    var value_till_data_view_name = '';

                    var select_value_from_field = $(form).find('[name="monitoring_restriction_field_value_from_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_value_from_field) && select_value_from_field.text !== '') {
                        value_from_data_view_id = select_value_from_field.id.split('|')[0];
                        value_from_data_view_name = select_value_from_field.id.split('|')[1];
                    }

                    var select_value_till_field = $(form).find('[name="monitoring_restriction_field_value_till_field"]').select2('data')[0];
                    if (!utils.isUndefined(select_value_till_field) && select_value_till_field.text !== '') {
                        value_till_data_view_id = select_value_till_field.id.split('|')[0];
                        value_till_data_view_name = select_value_till_field.id.split('|')[1];
                    }

                    if (value_from_data_view_id !== '' || value_till_data_view_id !== '') {
                        var ajaxData = '&' + jQuery.param({fields: data_view_id + '#' + data_view_name + '#' + value_from_data_view_id + '#' + value_from_data_view_name + '#' + value_till_data_view_id + '#' + value_till_data_view_name});

                        ajax.ajaxCall("admin/monitoring/checkunit", "GET", ajaxData, false, function (data) {

                            if (data === 'false') {
                                $.SmartMessageBox({
                                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.monitoring_restriction_not_same_unit_title'),
                                    content: Lang.get('tripletrax.monitoring_restriction_not_same_unit_desc'),
                                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                }, function (ButtonPressed) {
                                    defer.resolve('false');
                                });
                            } else {
                                defer.resolve('true');
                            }
                        });
                    } else {
                        defer.resolve('true');
                    }
                } else {
                    defer.resolve('true');
                }
            } else {
                defer.resolve('true');
            }
        } else {
            defer.resolve('true');
        }
    }).promise();
}

function checkCompletenessDeactivationDataCollectionType(form) {

    return $.Deferred(function (defer) {
        // Wenn sich die Vollständigkeiten ändern, dann Meldung anzeigen, falls die Häkchenliste farblich dargestellt wird
        if ($('[name="colored_completeness_activated"]').val() === '1') {

            var splitted_data_view_id = $(form).find('[name="integrity_data_view_field"]').select2('val').split('|');
            var integrity_data_view_field_name = splitted_data_view_id[1];
            var integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;

            var integrity_mandatory_field = '';
            var integrity_completeness_frequency = '';
            var integrity_dep_data_view_name = '';

            if (integrity_type_id === 'completeness') {
                integrity_mandatory_field = $(form).find('[name="completeness_mandatory_field"]')[0].checked ? '1' : '0';

                if (!utils.isUndefined($(form).find('[name="completeness_frequency"]:checked')) && $(form).find('[name="completeness_frequency"]:checked').length > 0) {
                    integrity_completeness_frequency = $(form).find('[name="completeness_frequency"]:checked').val();
                }
            } else if (integrity_type_id === 'dependency') {

                var integrity_depending_field = $(form).find('[name="integrity_depending_field"]').select2('data')[0];
                if (!utils.isUndefined(integrity_depending_field) && integrity_depending_field.text !== '') {
                    integrity_dep_data_view_name = integrity_depending_field.id.split('|')[1];
                }

                integrity_completeness_frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();
            }

            if (integrity_type_id === 'completeness' || (integrity_type_id === 'dependency' && integrity_completeness_frequency !== 'no')) {
                var ajaxData = '&' + jQuery.param({integrities: integrity_type_id + '#' + integrity_data_view_field_name + '#' + integrity_dep_data_view_name + '#' + integrity_mandatory_field + '#' + integrity_completeness_frequency});

                ajax.ajaxCall("admin/datacollectiontype/checkcompleteness/single", "POST", ajaxData, false, function (data) {

                    if (data === 'false') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_completeness_changed_title'),
                            content: Lang.get('tripletrax.integrities_completeness_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true_change');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    } else {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_completeness_changed_title'),
                            content: Lang.get('tripletrax.integrities_completeness_activation_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true_change_activation');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    }
                });
            } else {
                defer.resolve('true');
            }
        } else if ($('.tt-colored-completeness')[0].checked === true) {

            var splitted_data_view_id = $(form).find('[name="integrity_data_view_field"]').select2('val').split('|');
            var integrity_data_view_field_name = splitted_data_view_id[1];
            var integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;

            var integrity_mandatory_field = '';
            var integrity_completeness_frequency = '';
            var integrity_dep_data_view_name = '';

            if (integrity_type_id === 'completeness') {
                integrity_mandatory_field = $(form).find('[name="completeness_mandatory_field"]')[0].checked ? '1' : '0';

                if (!utils.isUndefined($(form).find('[name="completeness_frequency"]:checked')) && $(form).find('[name="completeness_frequency"]:checked').length > 0) {
                    integrity_completeness_frequency = $(form).find('[name="completeness_frequency"]:checked').val();
                }
            } else if (integrity_type_id === 'dependency') {

                var integrity_depending_field = $(form).find('[name="integrity_depending_field"]').select2('data')[0];
                if (!utils.isUndefined(integrity_depending_field) && integrity_depending_field.text !== '') {
                    integrity_dep_data_view_name = integrity_depending_field.id.split('|')[1];
                }

                integrity_completeness_frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();
            }

            if (integrity_type_id === 'completeness' || (integrity_type_id === 'dependency' && integrity_completeness_frequency !== 'no')) {
                var ajaxData = '&' + jQuery.param({integrities: integrity_type_id + '#' + integrity_data_view_field_name + '#' + integrity_dep_data_view_name + '#' + integrity_mandatory_field + '#' + integrity_completeness_frequency});

                ajax.ajaxCall("admin/datacollectiontype/checkcompleteness/single", "POST", ajaxData, false, function (data) {

                    if (data === 'false') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_completeness_changed_title'),
                            content: Lang.get('tripletrax.integrities_completeness_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true_change');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    } else {
                        defer.resolve('true');
                    }
                });
            } else {
                defer.resolve('true');
            }
        } else {
            defer.resolve('true');
        }
    }).promise();
}

function checkCompletenessDeactivationDataView(form) {

    return $.Deferred(function (defer) {
        // Wenn sich die Vollständigkeiten ändern, dann Meldung anzeigen, falls die Häkchenliste farblich dargestellt wird
        if ($(form).find('[name="integrity_data_collection_type"]').find(":selected").data("coloredCompletenessActivated") === 1) {

            var integrity_data_view_id = $(form).parents('.tt-content-dialog').find('[name="data_view_id"]').val();
            var is_in_list = ($(form).parents('.tt-content-dialog').find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val() !== '');
            var parent_tab = $(form).parents('.tt-content-dialog').find('[name="parent_tab"]').val();
            var integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;

            var integrity_mandatory_field = '';
            var integrity_completeness_frequency = '';
            var integrity_dep_data_view_id = '';

            if (integrity_type_id === 'completeness') {
                integrity_mandatory_field = $(form).find('[name="completeness_mandatory_field"]')[0].checked ? '1' : '0';

                if (!utils.isUndefined($(form).find('[name="completeness_frequency"]:checked')) && $(form).find('[name="completeness_frequency"]:checked').length > 0) {
                    integrity_completeness_frequency = $(form).find('[name="completeness_frequency"]:checked').val();
                }
            } else if (integrity_type_id === 'dependency') {

                var integrity_depending_field = $(form).find('[name="integrity_depending_field"]').select2('data')[0];
                if (!utils.isUndefined(integrity_depending_field) && integrity_depending_field.text !== '') {
                    integrity_dep_data_view_id = integrity_depending_field.id.split('|')[0];
                }

                integrity_completeness_frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();

                is_in_list = ($(form).find('[name="integrity_depending_field"]').select2('data')[0].tableType === 'period_table' || $(form).find('[name="integrity_depending_field"]').select2('data')[0].tableType === 'period_facility_table');
            }

            if (integrity_type_id === 'completeness' || (integrity_type_id === 'dependency' && integrity_completeness_frequency !== 'no')) {
                var ajaxData = '&' + jQuery.param({integrities: integrity_type_id + '#' + integrity_data_view_id + '#' + integrity_dep_data_view_id + '#' + integrity_mandatory_field + '#' + integrity_completeness_frequency + '#' + parent_tab + '#' + is_in_list});

                ajax.ajaxCall("admin/dataview/check/completeness", "POST", ajaxData, false, function (data) {

                    if (data === 'false') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_completeness_changed_title'),
                            content: Lang.get('tripletrax.data_views_integrities_completeness_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true_change');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    } else {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_completeness_changed_title'),
                            content: Lang.get('tripletrax.data_views_integrities_completeness_activation_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true_change_activation');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    }
                });
            } else {
                defer.resolve('true');
            }

        } else if ($(form).find('[name="integrity_data_collection_type"]').find(":selected").data("coloredCompleteness") === 1) {

            var integrity_data_view_id = $(form).parents('.tt-content-dialog').find('[name="data_view_id"]').val();
            var is_in_list = ($(form).parents('.tt-content-dialog').find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val() !== '');
            var parent_tab = $(form).parents('.tt-content-dialog').find('[name="parent_tab"]').val();
            var integrity_type_id = $(form).find('[name="integrity_type"]').select2('data')[0].id;

            var integrity_mandatory_field = '';
            var integrity_completeness_frequency = '';
            var integrity_dep_data_view_id = '';

            if (integrity_type_id === 'completeness') {
                integrity_mandatory_field = $(form).find('[name="completeness_mandatory_field"]')[0].checked ? '1' : '0';

                if (!utils.isUndefined($(form).find('[name="completeness_frequency"]:checked')) && $(form).find('[name="completeness_frequency"]:checked').length > 0) {
                    integrity_completeness_frequency = $(form).find('[name="completeness_frequency"]:checked').val();
                }
            } else if (integrity_type_id === 'dependency') {

                var integrity_depending_field = $(form).find('[name="integrity_depending_field"]').select2('data')[0];
                if (!utils.isUndefined(integrity_depending_field) && integrity_depending_field.text !== '') {
                    integrity_dep_data_view_id = integrity_depending_field.id.split('|')[0];
                }

                integrity_completeness_frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();

                is_in_list = ($(form).find('[name="integrity_depending_field"]').select2('data')[0].tableType === 'period_table' || $(form).find('[name="integrity_depending_field"]').select2('data')[0].tableType === 'period_facility_table');
            }

            if (integrity_type_id === 'completeness' || (integrity_type_id === 'dependency' && integrity_completeness_frequency !== 'no')) {
                var ajaxData = '&' + jQuery.param({integrities: integrity_type_id + '#' + integrity_data_view_id + '#' + integrity_dep_data_view_id + '#' + integrity_mandatory_field + '#' + integrity_completeness_frequency + '#' + parent_tab + '#' + is_in_list});

                ajax.ajaxCall("admin/dataview/check/completeness", "POST", ajaxData, false, function (data) {

                    if (data === 'false') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.integrities_completeness_changed_title'),
                            content: Lang.get('tripletrax.data_views_integrities_completeness_changed_desc'),
                            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                        }, function (ButtonPressed) {
                            if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                defer.resolve('true_change');
                            } else {
                                defer.resolve('false');
                            }
                        });
                    } else {
                        defer.resolve('true');
                    }
                });
            } else {
                defer.resolve('true');
            }
        } else {
            defer.resolve('true');
        }
    }).promise();
}

function checkDependingFieldDataCollectionType(form) {

    return $.Deferred(function (defer) {
        var dep_control_type = '';
        var dep_data_type = '';
        var frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();

        if (!utils.isUndefined($(form).find('[name="integrity_depending_field"]').select2('val')) && $(form).find('[name="integrity_depending_field"]').select2('val') !== '') {
            dep_control_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].controlType;
            dep_data_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].dataType;
        }

        if ((dep_control_type === 'input' || dep_control_type === 'input_with_additionalfield' || dep_control_type === 'textarea')
            && (dep_data_type === 'integer' || dep_data_type === 'decimal')
            && frequency === 'no') {

            var dep_select_field = $(form).find('[name="integrity_depending_field"]').select2('val').split('|');
            var dep_data_view_id = dep_select_field[0];
            var dep_data_view_name = dep_select_field[1];

            var dep_value_from_data_view_id = '';
            var dep_value_from_data_view_name = '';
            var dep_value_till_data_view_id = '';
            var dep_value_till_data_view_name = '';

            var dep_select_value_from_field = $(form).find('[name="integrity_depending_field_value_from_field"]').select2('data')[0];
            if (!utils.isUndefined(dep_select_value_from_field) && dep_select_value_from_field.text !== '') {
                dep_value_from_data_view_id = dep_select_value_from_field.id.split('|')[0];
                dep_value_from_data_view_name = dep_select_value_from_field.id.split('|')[1];
            }

            var dep_select_value_till_field = $(form).find('[name="integrity_depending_field_value_till_field"]').select2('data')[0];
            if (!utils.isUndefined(dep_select_value_till_field) && dep_select_value_till_field.text !== '') {
                dep_value_till_data_view_id = dep_select_value_till_field.id.split('|')[0];
                dep_value_till_data_view_name = dep_select_value_till_field.id.split('|')[1];
            }

            if (dep_value_from_data_view_id !== '' || dep_value_till_data_view_id !== '') {
                var ajaxData = '&' + jQuery.param({fields: dep_data_view_id + '#' + dep_data_view_name + '#' + dep_value_from_data_view_id + '#' + dep_value_from_data_view_name + '#' + dep_value_till_data_view_id + '#' + dep_value_till_data_view_name});

                ajax.ajaxCallDeferred("admin/monitoring/checkunit", "GET", ajaxData, false).done(function (data) {

                    if (data === 'false') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.monitoring_restriction_not_same_unit_title'),
                            content: Lang.get('tripletrax.monitoring_restriction_not_same_unit_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                            defer.resolve('false');
                        });
                    } else {
                        checkCompletenessDeactivationDataCollectionType(form).done(function (doCompletenessDeactivation) {

                            defer.resolve(doCompletenessDeactivation);
                        });
                    }
                });
            } else {
                checkCompletenessDeactivationDataCollectionType(form).done(function (doCompletenessDeactivation) {

                    defer.resolve(doCompletenessDeactivation);
                });
            }
        } else {
            checkCompletenessDeactivationDataCollectionType(form).done(function (doCompletenessDeactivation) {

                defer.resolve(doCompletenessDeactivation);
            });
        }
    }).promise();
}

function checkDependingFieldDataView(form) {

    return $.Deferred(function (defer) {
        var dep_control_type = '';
        var dep_data_type = '';
        var frequency = $(form).find('[name="integrity_dependency_frequency"]:checked').val();

        if (!utils.isUndefined($(form).find('[name="integrity_depending_field"]').select2('val')) && $(form).find('[name="integrity_depending_field"]').select2('val') !== '') {
            dep_control_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].controlType;
            dep_data_type = $(form).find('[name="integrity_depending_field"]').select2('data')[0].dataType;
        }

        if ((dep_control_type === 'input' || dep_control_type === 'input_with_additionalfield' || dep_control_type === 'textarea')
            && (dep_data_type === 'integer' || dep_data_type === 'decimal')
            && frequency === 'no') {

            var dep_select_field = $(form).find('[name="integrity_depending_field"]').select2('val').split('|');
            var dep_data_view_id = dep_select_field[0];
            var dep_data_view_name = dep_select_field[1];

            var dep_value_from_data_view_id = '';
            var dep_value_from_data_view_name = '';
            var dep_value_till_data_view_id = '';
            var dep_value_till_data_view_name = '';

            var dep_select_value_from_field = $(form).find('[name="integrity_depending_field_value_from_field"]').select2('data')[0];
            if (!utils.isUndefined(dep_select_value_from_field) && dep_select_value_from_field.text !== '') {
                dep_value_from_data_view_id = dep_select_value_from_field.id.split('|')[0];
                dep_value_from_data_view_name = dep_select_value_from_field.id.split('|')[1];
            }

            var dep_select_value_till_field = $(form).find('[name="integrity_depending_field_value_till_field"]').select2('data')[0];
            if (!utils.isUndefined(dep_select_value_till_field) && dep_select_value_till_field.text !== '') {
                dep_value_till_data_view_id = dep_select_value_till_field.id.split('|')[0];
                dep_value_till_data_view_name = dep_select_value_till_field.id.split('|')[1];
            }

            if (dep_value_from_data_view_id !== '' || dep_value_till_data_view_id !== '') {
                var ajaxData = '&' + jQuery.param({fields: dep_data_view_id + '#' + dep_data_view_name + '#' + dep_value_from_data_view_id + '#' + dep_value_from_data_view_name + '#' + dep_value_till_data_view_id + '#' + dep_value_till_data_view_name});

                ajax.ajaxCallDeferred("admin/monitoring/checkunit", "GET", ajaxData, false).done(function (data) {

                    if (data === 'false') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.monitoring_restriction_not_same_unit_title'),
                            content: Lang.get('tripletrax.monitoring_restriction_not_same_unit_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                            defer.resolve('false');
                        });
                    } else {
                        checkCompletenessDeactivationDataView(form).done(function (doCompletenessDeactivation) {

                            defer.resolve(doCompletenessDeactivation);
                        });
                    }
                });
            } else {
                checkCompletenessDeactivationDataView(form).done(function (doCompletenessDeactivation) {

                    defer.resolve(doCompletenessDeactivation);
                });
            }
        } else {
            checkCompletenessDeactivationDataView(form).done(function (doCompletenessDeactivation) {

                defer.resolve(doCompletenessDeactivation);
            });
        }
    }).promise();
}

function setInputNoComplicationsAndNotCollectedFormatValues() {

    var item = '';
    var active = '';
    var noComplicaitonsChecked = $("#content-detail").find('[name="no_complications"]').is(':checked');
    var noComplicationsCell = $("#content-detail").find('[data-name="no_complications_value"]').find('td')[1];
    var currentSelectionNoComplications = '';
    if (!utils.isUndefined($(noComplicationsCell).find('li.active').find('a').data())) {
        currentSelectionNoComplications = $(noComplicationsCell).find('li.active').find('a').data().formatValue;
    }
    var foundCurrentComplications = false;
    var notCollectedChecked = $("#content-detail").find('[name="not_collected"]').is(':checked');
    var notCollectedCell = $("#content-detail").find('[data-name="not_collected_value"]').find('td')[1];
    var currentSelectionNotCollected = '';
    if (!utils.isUndefined($(notCollectedCell).find('li.active').find('a').data())) {
        currentSelectionNotCollected = $(notCollectedCell).find('li.active').find('a').data().formatValue;
    }
    var foundCurrentNotCollected = false;
    var formatFields = $('[name="format_fields"]').select2('val');
    var units = [];
    if ($('[name="edit_units"]').val() !== '') {
        units = $('[name="edit_units"]').val().split('|');
    }

    $(noComplicationsCell).find('ul.dropdown-menu').empty();
    $(noComplicationsCell).find('.input-with-dropdown').find('i').remove();
    $(notCollectedCell).find('ul.dropdown-menu').empty();
    $(notCollectedCell).find('.input-with-dropdown').find('i').remove();

    jQuery.each(units, function (i, modal_val) {
        var modal_data = modal_val.split('#');
        if (modal_data[1] === 'true') {
            default_unit = modal_data[2];
        }
        if (currentSelectionNoComplications === modal_data[2]) {
            foundCurrentComplications = true;
        }
        if (currentSelectionNotCollected === modal_data[2]) {
            foundCurrentNotCollected = true;
        }
    });
    if (jQuery.inArray(currentSelectionNoComplications, formatFields) !== -1) {
        foundCurrentComplications = true;
    }
    if (jQuery.inArray(currentSelectionNotCollected, formatFields) !== -1) {
        foundCurrentNotCollected = true;
    }

    if (!foundCurrentComplications && !(currentSelectionNoComplications === 'value' && units.length === 0)) {
        $(noComplicationsCell).find('input').val('');
        if (noComplicaitonsChecked) {
            $(noComplicationsCell).find('input').removeAttr('disabled');
        }
        if (units.length === 0 && formatFields.length === 0) {
            currentSelectionNoComplications = '';
        } else if (units.length === 0 && formatFields.length > 0) {
            currentSelectionNoComplications = 'value';
        } else {
            currentSelectionNoComplications = default_unit;
        }
    }
    if (!foundCurrentNotCollected && !(currentSelectionNotCollected === 'value' && units.length === 0)) {
        $(notCollectedCell).find('input').val('');
        if (notCollectedChecked) {
            $(notCollectedCell).find('input').removeAttr('disabled');
        }
        if (units.length === 0 && formatFields.length === 0) {
            currentSelectionNotCollected = '';
        } else if (units.length === 0 && formatFields.length > 0) {
            currentSelectionNotCollected = 'value';
        } else {
            currentSelectionNotCollected = default_unit;
        }
    }

    jQuery.each(units, function (i, modal_val) {
        var modal_data = modal_val.split('#');

        // Einheiten für Wert 'Keine Komplikationen' und Wert 'Nicht Erhoben' hinzufügen
        active = (currentSelectionNoComplications === modal_data[2]) ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-value" data-format-value="' + modal_data[2] + '" href="#">' + modal_data[2] + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === modal_data[2]) ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-value" data-format-value="' + modal_data[2] + '" href="#">' + modal_data[2] + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    });

    // Falls alle Einheiten gelöscht wurden aber noch Formatangaben existieren, 'Wert' als Auswahl für Wert 'Keine Komplikationen' und Wert 'Nicht Erhoben' hinzufügen
    if (units.length === 0 && formatFields.length > 0) {
        active = (currentSelectionNoComplications === 'value') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-value" data-format-value="value" href="#">' + trans('tripletrax.value') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);

        active = (currentSelectionNotCollected === 'value') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-value" data-format-value="value" href="#">' + trans('tripletrax.value') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }

    if (units.length > 0) {
        if (currentSelectionNotCollected !== 'unknown' && currentSelectionNotCollected !== 'not_collected') {
            $(notCollectedCell).find('.input-with-dropdown').append('<i class="icon-append icon-append-unit">' + currentSelectionNotCollected + '</i>');
        } else {
            $(notCollectedCell).find('.input-with-dropdown').append('<i class="icon-append icon-append-unit">' + default_unit + '</i>');
        }
        if (currentSelectionNoComplications !== 'unknown' && currentSelectionNoComplications !== 'not_collected') {
            $(noComplicationsCell).find('.input-with-dropdown').append('<i class="icon-append icon-append-unit">' + currentSelectionNoComplications + '</i>');
        } else {
            $(noComplicationsCell).find('.input-with-dropdown').append('<i class="icon-append icon-append-unit">' + default_unit + '</i>');
        }
    }

    if (jQuery.inArray('not_collected', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'not_collected') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-not-collected" data-format-value="not_collected" href="#">' + trans('tripletrax.not_collected_value') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === 'not_collected') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-not-collected" data-format-value="not_collected" href="#">' + trans('tripletrax.not_collected_value') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }

    if (jQuery.inArray('unknown', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'unknown') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-unknown" data-format-value="unknown" href="#">' + trans('tripletrax.unknown_value') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === 'unknown') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-unknown" data-format-value="unknown" href="#">' + trans('tripletrax.unknown_value') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }

    if (units.length === 0 && formatFields.length === 0) {
        $(noComplicationsCell).find('ul').addClass('hide');
        $(notCollectedCell).find('ul').addClass('hide');

        $(noComplicationsCell).find('.label-treelist-input').removeClass('display-flex');
        $(noComplicationsCell).find('.label-treelist-input').addClass('display-block');
        $(noComplicationsCell).find('.input-with-dropdown').addClass('display-inline');
        $(notCollectedCell).find('.label-treelist-input').removeClass('display-flex');
        $(notCollectedCell).find('.label-treelist-input').addClass('display-block');
        $(notCollectedCell).find('.input-with-dropdown').addClass('display-inline');
    } else {
        $(noComplicationsCell).find('ul').removeClass('hide');
        $(notCollectedCell).find('ul').removeClass('hide');

        $(noComplicationsCell).find('.label-treelist-input').addClass('display-flex');
        $(noComplicationsCell).find('.label-treelist-input').removeClass('display-block');
        $(noComplicationsCell).find('.input-with-dropdown').removeClass('display-inline');
        $(notCollectedCell).find('.label-treelist-input').addClass('display-flex');
        $(notCollectedCell).find('.label-treelist-input').removeClass('display-block');
        $(notCollectedCell).find('.input-with-dropdown').removeClass('display-inline');
    }
}

function setDatePanelNoComplicationsAndNotCollectedFormatValues() {

    var item = '';
    var active = '';
    var noComplicaitonsChecked = $("#content-detail").find('[name="no_complications"]').is(':checked');
    var noComplicationsCell = $("#content-detail").find('[data-name="no_complications_value"]').find('td')[1];
    var currentSelectionNoComplications = '';
    if (!utils.isUndefined($(noComplicationsCell).find('li.active').find('a').data())) {
        currentSelectionNoComplications = $(noComplicationsCell).find('li.active').find('a').data().formatValue;
    }
    var foundCurrentComplications = false;
    var notCollectedChecked = $("#content-detail").find('[name="not_collected"]').is(':checked');
    var notCollectedCell = $("#content-detail").find('[data-name="not_collected_value"]').find('td')[1];
    var currentSelectionNotCollected = '';
    if (!utils.isUndefined($(notCollectedCell).find('li.active').find('a').data())) {
        currentSelectionNotCollected = $(notCollectedCell).find('li.active').find('a').data().formatValue;
    }
    var foundCurrentNotCollected = false;
    var formatFields = $('[name="format_fields"]').select2('val');

    $(noComplicationsCell).find('ul.dropdown-menu').empty();
    $(notCollectedCell).find('ul.dropdown-menu').empty();

    if (jQuery.inArray(currentSelectionNoComplications, formatFields) !== -1) {
        foundCurrentComplications = true;
    }
    if (jQuery.inArray(currentSelectionNotCollected, formatFields) !== -1) {
        foundCurrentNotCollected = true;
    }

    if (!foundCurrentComplications) {
        $(noComplicationsCell).find('input').val('');
        if (noComplicaitonsChecked) {
            $(noComplicationsCell).find('input').removeAttr('disabled');
        }
        if (jQuery.inArray('full', formatFields) !== -1) {
            currentSelectionNoComplications = 'full';
        } else if (jQuery.inArray('mm/yy', formatFields) !== -1) {
            currentSelectionNoComplications = 'mm/yy';
        } else if (jQuery.inArray('yy', formatFields) !== -1) {
            currentSelectionNoComplications = 'yy';
        } else {
            currentSelectionNoComplications = 'full';
        }
    }
    if (!foundCurrentNotCollected) {
        $(notCollectedCell).find('input').val('');
        if (notCollectedChecked) {
            $(notCollectedCell).find('input').removeAttr('disabled');
        }
        if (jQuery.inArray('full', formatFields) !== -1) {
            currentSelectionNotCollected = 'full';
        } else if (jQuery.inArray('mm/yy', formatFields) !== -1) {
            currentSelectionNotCollected = 'mm/yy';
        } else if (jQuery.inArray('yy', formatFields) !== -1) {
            currentSelectionNotCollected = 'yy';
        } else {
            currentSelectionNotCollected = 'full';
        }
    }

    // Datumsformate hinzufügen
    // Tag / Monat / Jahr
    if (jQuery.inArray('full', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'full') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-date-full" data-format-value="full" href="#">' + trans('tripletrax.date_full') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);

        active = (currentSelectionNotCollected === 'full') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-date-full" data-format-value="full" href="#">' + trans('tripletrax.date_full') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }
    // Monat / Jahr
    if (jQuery.inArray('mm/yy', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'mm/yy') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-date-month-year" data-format-value="mm/yy" href="#">' + trans('tripletrax.mm/yy') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === 'mm/yy') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-date-month-year" data-format-value="mm/yy" href="#">' + trans('tripletrax.mm/yy') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }
    // Jahr
    if (jQuery.inArray('yy', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'yy') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-date-year" data-format-value="yy" href="#">' + trans('tripletrax.yy') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === 'yy') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-date-year" data-format-value="yy" href="#">' + trans('tripletrax.yy') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }
    // Nicht erhoben
    if (jQuery.inArray('not_collected', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'not_collected') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-not-collected" data-format-value="not_collected" href="#">' + trans('tripletrax.not_collected_value') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === 'not_collected') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-not-collected" data-format-value="not_collected" href="#">' + trans('tripletrax.not_collected_value') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }
    // Unbekannt
    if (jQuery.inArray('unknown', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'unknown') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-unknown" data-format-value="unknown" href="#">' + trans('tripletrax.unknown_value') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === 'unknown') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-unknown" data-format-value="unknown" href="#">' + trans('tripletrax.unknown_value') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }
    // Andauernd
    if (jQuery.inArray('continuing', formatFields) !== -1) {
        active = (currentSelectionNoComplications === 'continuing') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-continuing" data-format-value="continuing" href="#">' + trans('tripletrax.continuing_value') + '</a>' +
            '</li>';
        $(noComplicationsCell).find('ul.dropdown-menu').append(item);
        active = (currentSelectionNotCollected === 'continuing') ? ' class="active"' : '';
        item =
            '<li' + active + '>' +
            '<a class="tt-select-continuing" data-format-value="continuing" href="#">' + trans('tripletrax.continuing_value') + '</a>' +
            '</li>';
        $(notCollectedCell).find('ul.dropdown-menu').append(item);
    }

    if (formatFields.length === 0 || (formatFields.length === 1 && (formatFields[0] === 'full' || formatFields[0] === 'mm/yy' || formatFields[0] === 'yy'))) {
        $(noComplicationsCell).find('ul').addClass('hide');
        $(notCollectedCell).find('ul').addClass('hide');

        $(noComplicationsCell).children().removeClass('input');
        $(noComplicationsCell).children().removeClass('tt-datepicker');
        $(noComplicationsCell).children().removeClass('display-flex');
        $(noComplicationsCell).children().addClass('display-block');
        $($(noComplicationsCell).children().children()[0]).removeClass('input-with-dropdown');
        $(notCollectedCell).children().removeClass('input');
        $(notCollectedCell).children().removeClass('tt-datepicker');
        $(notCollectedCell).children().removeClass('display-flex');
        $(notCollectedCell).children().addClass('display-block');
        $($(notCollectedCell).children().children()[0]).removeClass('input-with-dropdown');
    } else {
        $(noComplicationsCell).find('ul').removeClass('hide');
        $(notCollectedCell).find('ul').removeClass('hide');

        $(noComplicationsCell).children().addClass('input');
        $(noComplicationsCell).children().addClass('tt-datepicker');
        $(noComplicationsCell).children().addClass('display-flex');
        $(noComplicationsCell).children().removeClass('display-block');
        $($(noComplicationsCell).children().children()[0]).addClass('input-with-dropdown');
        $(notCollectedCell).children().addClass('input');
        $(notCollectedCell).children().addClass('tt-datepicker');
        $(notCollectedCell).children().addClass('display-flex');
        $(notCollectedCell).children().removeClass('display-block');
        $($(notCollectedCell).children().children()[0]).addClass('input-with-dropdown');
    }
}

function registerNestableEvents() {

    // Nestable Lists - Alles zusammen- bzw. auseinander klappen
    $('body').on('click', '.tt-left-button-nestable', function (e) {
        var action = $(this).data('action');
        if (action === 'expand-all') {
            $(this).parents('.tt-content-datatable,.tt-content-completeness').find('.dd').nestable('expandAll');
        }
        if (action === 'collapse-all') {
            $(this).parents('.tt-content-datatable,.tt-content-completeness').find('.dd').nestable('collapseAll');
        }
    });

    // Nestable Lists - Ausgewähltes Element anzeigen
    $('body').on('mousedown', '.dd-handle:not(.dd-handle-completeness,.dd-completeness-parent)', function (e) {
        e.preventDefault();

        if (!$(this).is('.dd-dialog-handle')) {
            var dd_id = $(this).parents('.dd-dragel').data('tt-dd-id');
            if (utils.isUndefined(dd_id)) {
                dd_id = $(this).parents('.dd')[0].id;
            }

            if ($('#' + dd_id).parents('.tt-content').find('.tt-selected-id').val() === $(this).parents('.dd-item')[0].getAttribute('data-id')) {
                // Falls gleiches Element wieder gewählt wird nichts machen.
                return;
            }

            nestable.selectNestableElement($(this), true);
        }
    });

    // Nestable Lists - Neues Element hinzufügen
    $('body').on('click', '.tt-add-nestable', function (e) {
        e.preventDefault();
        e.stopPropagation();

        nestable.selectNestableElement($(this).parents('.dd-handle'), true).done(function () {
            $('#table_data_views_create_dialog').modal('show');
        });
    });

    // Nestable Lists - Buttons anzeigen bei MouseOver
    $('body').on('mouseenter', '.dd-handle,.dd3-content,.tt-row-selected', function (e) {
        $(this).find('.tt-button-nestable').removeClass('hide');
    });

    // Nestable Lists - Buttons nicht mehr anzeigen bei MouseLeave
    $('body').on('mouseleave', '.dd-handle,.dd3-content,.tt-switch-row', function (e) {
        if (!$(this).hasClass('dd-content-active') && !$(this).hasClass('tt-switch-on')) {
            $(this).find('.tt-button-nestable').addClass('hide');
        }
    });

    // Nestable Lists - BreadCrumb Funktionalität
    $('body').on('click', '.tt-data-view-breadcrumb', function (e) {
        e.preventDefault();

        var url = $(this).find('a')[0].pathname;
        var id = url.split("/")[url.split("/").length - 1];

        var item = $(this).parents('.tt-content').find("[data-id='" + id + "']").find('.dd-handle');

        item[0].click();
    });

    // Nestable Lists - Positionen bei Verschieben speichern
    $('body').on('change', '.dd', function (e) {

        var element = $(this);
        var data = 'positions=';
        var positions_list = $(this).nestable('getPositions');
        var level = 0;
        var additionalPosition = 1;
        var elementsCountRepetitionNotVisible = 0;

        jQuery.each(positions_list, function (i, val) {

            if (i + additionalPosition !== val.position) {
                data += val.id + '-' + (i + additionalPosition) + '-' + val.newLevel + '|';

                if (val.idsRepetition !== '') {
					var idsRepetition = val.idsRepetition.toString().split('|');
					jQuery.each(idsRepetition, function (j, repetitionId) {
						data += repetitionId + '-' + (i + ((j + 1) * val.elementsCountRepetition) + additionalPosition) + '-' + val.newLevel + '|';
					});
				}
            }
            if (val.controlType == 'date_range') {
				additionalPosition += 1;
				if (i + additionalPosition !== val.positionTill) {
					data += val.idTill + '-' + (i + additionalPosition) + '-' + val.newLevel + '|';

					if (val.idsRepetitionTill !== '') {
						var idsRepetitionTill = val.idsRepetitionTill.toString().split('|');
						jQuery.each(idsRepetitionTill, function (j, repetitionTillId) {
							data += repetitionTillId + '-' + (i + ((j + 1) * val.elementsCountRepetition) + additionalPosition) + '-' + val.newLevel + '|';
						});
					}
				}
            }

			if (val.elementsCountRepetitionNotVisible > 0) {
				elementsCountRepetitionNotVisible = val.elementsCountRepetitionNotVisible;
				val.elementsCountRepetitionNotVisible = 0;
			}

            if (i < positions_list.length - 1 && val.idsRepetition !== '' && positions_list[i + 1].idsRepetition == '') {
                val.elementsCountRepetitionNotVisible = elementsCountRepetitionNotVisible;
				additionalPosition += elementsCountRepetitionNotVisible;
				elementsCountRepetitionNotVisible = 0;
            }
        });

        if (data !== 'positions=') {

            if ($(element).attr('id') === "dd_course_views") {
                jQuery.each(positions_list, function (i, val) {

                    if (i + 1 !== val.position) {
                        // Position neu setzen
                        element.find("[data-id='" + val.id + "']").data("position", i + 1);
                    }
                });

                if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
                    $("#content-detail").find('.tt-datatable-changes').val("changed");
                    $("#content-detail").find('form').trigger('checkform.areYouSure');
                }
            } else if ($(element).attr('id') === "dd_monitoring_display_fields" || $(element).attr('id') === "dd_monitoring_restrictions") {
                if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
                    $("#content-detail").find('.tt-datatable-changes').val("changed");
                    $("#content-detail").find('form').trigger('checkform.areYouSure');
                }
            } else if ($(element).attr('id') === 'dd_data_views') {
                data += '&data_view_id=' + element.find('.dd-content-active').parent().data().viewId;
                ajax.ajaxCall($(this).data().positionsUrl, 'POST', data, false, function (data) {
                    // Position und Level neu setzen
					additionalPosition = 1;
					elementsCountRepetitionNotVisible = 0;
                    jQuery.each(positions_list, function (i, val) {
                        if (i + additionalPosition !== val.position) {
                            element.find("[data-id='" + val.id + "']").data("position", i + additionalPosition).data("level", val.newLevel);

                            if (element.find('.dd-content-active').parent().data().id === val.id) {
                                $('#content-detail').find('[name="position"]').val(i + additionalPosition);
                                $('#content-detail').find('[name="level"]').val(val.newLevel);
                                $('#content-detail').find('[name="parent_id"]').val($(element.find('.dd-content-active').parents('ol')[0]).parent().data().id);
                            }
                        }
						if (val.controlType == 'date_range') {
							additionalPosition += 1;
							if (i + additionalPosition !== val.positionTill) {
								element.find("[data-id='" + val.id + "']").data("positionTill", i + additionalPosition);
							}
						}
						if (val.elementsCountRepetitionNotVisible > 0) {
							elementsCountRepetitionNotVisible = val.elementsCountRepetitionNotVisible;
							element.find("[data-id='" + val.id + "']").data("elementsCountRepetitionNotVisible", 0);
						}
						if (i < positions_list.length - 1 && val.idsRepetition !== '' && positions_list[i + 1].idsRepetition == '') {
							element.find("[data-id='" + val.id + "']").data("elementsCountRepetitionNotVisible", elementsCountRepetitionNotVisible);
							additionalPosition += elementsCountRepetitionNotVisible;
							elementsCountRepetitionNotVisible = 0;
						}
                    });

                    // Meldung für die Warnungen ein- bzw. ausblenden
                    if (data[0] === '') {
                        $('.tt-data-views-warning').addClass('hide');
                    } else {
                        $('.tt-data-views-warning').removeClass('hide');
                        $('.alert-warning').find('.data-view-warning').html(data[0]);
                    }

                    // Meldung anzeigen, falls ein Entspricht-Feld gelöscht wurde und Entspricht-Felder neu setzen
                    if (data[1]) {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_data_view_position_title'),
                            content: Lang.get('tripletrax.change_data_view_position_desc', { "data_view_name": "<span class='txt-color-orangeDark'><strong>" + $(element.find('.dd-content-active')).text() + "</strong></span>"}),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        });

                        if ($('#content-detail').find('[name="match"]').length && data[2][0] === '') {
                            $('#content-detail').find('[name="match"]').val(null).trigger('change.select2');
                        }
                        if ($('#content-detail').find('[name="match_additionalfield_1"]').length && data[2][1] === '') {
                            $('#content-detail').find('[name="match_additionalfield_1"]').val(null).trigger('change.select2');
                        }
                        if ($('#content-detail').find('[name="match_additionalfield_2"]').length && data[2][2] === '') {
                            $('#content-detail').find('[name="match_additionalfield_2"]').val(null).trigger('change.select2');
                        }
                    }
                });
            }
        }
    });

    // Nestable Lists - Neues Datenfeld - Neues Datenfeld auf leer setzen, wenn bestehendes Datenfeld gewählt wird
    $('body').on('change', '.tt-existing-element', function (e) {

        var element = $(this);
        var id = element.select2('data')[0].id;
        var position = $('[name="position"]').val(); // Position des Parent-Elements
        var match = $(element.select2('data')[0].element).data().match;
        var matchAdditionalField1 = $(element.select2('data')[0].element).data().matchAdditionalfield1;
        var matchAdditionalField2 = $(element.select2('data')[0].element).data().matchAdditionalfield2;

        if (match !== '' || matchAdditionalField1 !== '' || matchAdditionalField2 !== '') {

            // Leere Match-Felder auf DUMMY setzen, da sonst Fehler bei AJAX-Aufruf
            if (match === '') {
                match = 'DUMMY';
            }
            if (matchAdditionalField1 === '') {
                matchAdditionalField1 = 'DUMMY';
            }
            if (matchAdditionalField2 === '') {
                matchAdditionalField2 = 'DUMMY';
            }

            ajax.ajaxCallDeferred("admin/dataview/check/id/" + id + "/match/" + match + "/position/" + position + "/current_view/1", 'GET', null, false).done(function(data) {
                if (data === 'false') {
                    $.SmartMessageBox({
                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.assign_existing_data_view_title'),
                        content: Lang.get('tripletrax.assign_existing_data_view_desc'),
                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                    });
                    element.val(null).trigger('change.select2');
                } else {
                    ajax.ajaxCallDeferred("admin/dataview/check/id/" + id + "/match/" + matchAdditionalField1 + "/position/" + position + "/current_view/1", 'GET', null, false).done(function(data) {
                        if (data === 'false') {
                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.assign_existing_data_view_title'),
                                content: Lang.get('tripletrax.assign_existing_data_view_desc'),
                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                            });
                            element.val(null).trigger('change.select2');
                        } else {
                            ajax.ajaxCallDeferred("admin/dataview/check/id/" + id + "/match/" + matchAdditionalField2 + "/position/" + position + "/current_view/1", 'GET', null, false).done(function(data) {
                                if (data === 'false') {
                                    $.SmartMessageBox({
                                        title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.assign_existing_data_view_title'),
                                        content: Lang.get('tripletrax.assign_existing_data_view_desc'),
                                        buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                    });
                                    element.val(null).trigger('change.select2');
                                } else {
                                    element.parents('.tt-content-dialog').find('.tt-new-element').val('');
                                }
                            });
                        }
                    });
                }
            });
        } else {
            element.parents('.tt-content-dialog').find('.tt-new-element').val('');
        }
    });

    // Nestable Lists - Neues Datenfeld -  bestehendes Datenfeld auf 'Keine Auswahl' setzen, wenn neues Datenfeld ausgefüllt wird
    $('body').on('keyup', '.tt-new-element', function (e) {
        $(this).parents('.tt-content-dialog').find('.tt-existing-element').val(null).trigger('change.select2');
    });

    // Nestable Lists - Festlegung Ausprägungen RadioButton / ComboBox / zusätzliche Datenfelder
    $('body').on('click', '.tt-edit-data-view-property', function (e) {
        e.preventDefault();

        var inputValue = $(this).find('input').val();
        var matchControlTypeValues = '';
        var additionalfield = '';
        if (/_additionalfield_1$/.test(this.id)) {
            additionalfield = '_additionalfield_1';
        } else if (/_additionalfield_2$/.test(this.id)) {
            additionalfield = '_additionalfield_2';
        }
        if ($('[name="match' + additionalfield + '"]').length && $('[name="match' + additionalfield + '"]').select2('val') !== '' && !utils.isUndefined($('[name="match' + additionalfield + '"]').select2('data'))) {
            matchControlTypeValues = $($('[name="match' + additionalfield + '"]').select2('data')[0].element).data().controlTypeValues;
        }
        var element = this;

        if (/^button_edit_units/.test(this.id)) {

            var nameAppendix = this.id.replace('button_edit_units', '');
            if ($(this).parents('form').find('[name="match' + nameAppendix + '"]').val() && utils.isIDATField($(this).parents('form').find('[name="match' + nameAppendix + '"]').val())) {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.edit_units_title'),
                    content: Lang.get('tripletrax.edit_units_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                });
                event.stopPropagation();
                return;
            }

            // Modalen Dialog neu erstellen, wenn dieser noch nicht vorhanden ist (wird beim ersten Klick auf den Button neu erstellt)
            setModalDialog($(this), 'table_data_views_units_dialog', 'content-detail-modal-labunits').done(function (dialogCreated) {
                $('#table_data_views_units').DataTable().rows().remove();
                $('#table_data_views_units').dataTable().fnStandingRedraw();

                var html = '';
                if (!utils.isUndefined(inputValue) && inputValue !== '') {
                    var lab_units = inputValue.split('|');

                    jQuery.each(lab_units, function (i, val) {

                        var lab_unit_values = val.split('#');

                        if (lab_unit_values.length === 7) {

                            var default_unit_string = '';
                            if (lab_unit_values[1] === 'true') {
                                default_unit_string = 'checked';
                            }

                            $("#table_data_views_units").dataTable().fnAddData([
                                lab_unit_values[0],
                                '<label class="checkbox" style="width:20px"><input name="default_unit" type="checkbox" ' + default_unit_string + ' class="tt-checkbox-units"><i></i></label>',
                                lab_unit_values[2],
                                lab_unit_values[3],
                                lab_unit_values[4],
								lab_unit_values[5],
								lab_unit_values[6]]
                            );
                        }
                    });
                }

                var dialogId = $(element).attr('href');
                $(dialogId).find('[name="button_id"]').val(element.id);

                // Titel setzen
                var control_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type' + element.id.replace('button_edit_units', '') + '"]').val();
                var description = $(element).parents('.tt-content').find('[name="desc' + element.id.replace('button_edit_units', '') + '"]').val();
                if (element.id === 'button_edit_units_additionalfield_1' && $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type"]').val() === 'input_with_additionalfield') {
                    control_type = 'calculated_additionalfield';
                    description = $(element).parents('.tt-content').find('[name="name' + element.id.replace('button_edit_units', '') + '"]').val();
                }
                $(dialogId).find('.modal-title').text(Lang.get('tripletrax.data_views_' + control_type) + ' - ' + description);
                if (dialogCreated) {
                    $(element).click();
                }
            });

        } else if (/^button_edit_integrity_rules/.test(this.id) || /^button_edit_assume_previous_data/.test(this.id)) {

            var dialog = 'table_data_views_integrities_dialog';
            var contentDetail = 'content-detail-modal-integrities';
            var table = '#table_data_views_integrities';
            var button = 'button_edit_integrity_rules';
            var title = Lang.get('tripletrax.integrities');

            if (/^button_edit_assume_previous_data/.test(this.id)) {
                dialog = 'table_data_views_restrictions_dialog';
                contentDetail = 'content-detail-modal-restrictions';
                table = '#table_data_views_restrictions';
                button = 'button_edit_assume_previous_data';
                title = Lang.get('tripletrax.restrictions');
            }

            // Modalen Dialog neu erstellen, wenn dieser noch nicht vorhanden ist (wird beim ersten Klick auf den Button neu erstellt)
            setModalDialog($(this), dialog, contentDetail).done(function (dialogCreated) {

                // Tabelle mit bereits angelegten Regeln befüllen
                $(table).DataTable().rows().remove();
                $(table).dataTable().fnStandingRedraw();

                if (!utils.isUndefined(inputValue) && inputValue !== '') {
                    var input_integrities = inputValue.split('|');

                    jQuery.each(input_integrities, function (i, val) {

                        var integrity_values = val.split('#');

                        if (integrity_values.length === 71) {

                            var type_description = Lang.get('tripletrax.custom_rule');
                            if (integrity_values[3] !== '') {
                                type_description = Lang.get('tripletrax.' + integrity_values[3]);
                            }

                            $(table).dataTable().fnAddData([
                                    integrity_values[0],
                                    integrity_values[1],
                                    integrity_values[2],
                                    type_description,
                                    integrity_values[3],
                                    integrity_values[4],
                                    integrity_values[5],
                                    integrity_values[6],
                                    integrity_values[7],
                                    integrity_values[8],
                                    integrity_values[9],
                                    integrity_values[10],
                                    integrity_values[11],
                                    integrity_values[12],
                                    integrity_values[13],
                                    integrity_values[14],
                                    integrity_values[15],
                                    integrity_values[16],
                                    integrity_values[17],
                                    integrity_values[18],
                                    integrity_values[19],
                                    integrity_values[20],
                                    integrity_values[21],
                                    integrity_values[22],
                                    integrity_values[23],
                                    integrity_values[24],
                                    integrity_values[25],
                                    integrity_values[26],
                                    integrity_values[27],
                                    integrity_values[28],
                                    integrity_values[29],
                                    integrity_values[30],
                                    integrity_values[31],
                                    integrity_values[32],
                                    integrity_values[33],
                                    integrity_values[34],
                                    integrity_values[35],
                                    integrity_values[36],
                                    integrity_values[37],
                                    integrity_values[38],
                                    integrity_values[39],
                                    integrity_values[40],
                                    integrity_values[41],
                                    integrity_values[42],
                                    integrity_values[43],
                                    integrity_values[44],
                                    integrity_values[45],
                                    integrity_values[46],
                                    integrity_values[47],
                                    integrity_values[48],
                                    integrity_values[49],
                                    integrity_values[50],
                                    integrity_values[51],
                                    integrity_values[52],
                                    integrity_values[53],
                                    integrity_values[54],
                                    integrity_values[55],
                                    integrity_values[56],
                                    integrity_values[57],
                                    integrity_values[58],
                                    integrity_values[59],
                                    integrity_values[60],
                                    integrity_values[61],
                                    integrity_values[62],
                                    integrity_values[63],
								    integrity_values[64],
								    integrity_values[65],
                                    integrity_values[66],
                                    integrity_values[67],
                                    integrity_values[68],
                                    integrity_values[69],
                                    integrity_values[70]]
                            );
                        }
                    });
                }

                // Auswahllisten befüllen

                var additionalFieldName = element.id.replace(button, '');

                var units = '';
                var control_type_values = '';
                var control_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type"]').val();
				if ($(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type' + additionalFieldName + '"]').length) {
					control_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type' + additionalFieldName + '"]').val();
				}
                var data_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="data_type"]').val();
				if ($(element).parents('.tt-content').find('.tt-select2-data-view-property[name="data_type' + additionalFieldName + '"]').length) {
					data_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="data_type' + additionalFieldName + '"]').val();
				}
                var units_input = $('#button_edit_units' + additionalFieldName).find('input').val();
                var format_fields = $('[name="format_fields' + additionalFieldName + '"]').select2('val');
                var table_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="table_type' + additionalFieldName + '"]').val();
                var match_field = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="match"]').val();
                if ($(element).parents('.tt-content').find('.tt-select2-data-view-property[name="match' + additionalFieldName + '"]').length) {
					match_field = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="match' + additionalFieldName + '"]').val();
                }

                var editControlTypeButton = $("#content-detail").find('#button_edit_control_type' + additionalFieldName);
                if (editControlTypeButton.length) {
                    var control_type_values_input = $.parseJSON($("#content-detail").find('[name="edit_control_type' + additionalFieldName + '"]').val());
                    jQuery.each(control_type_values_input, function (i, val) {
                        if (control_type_values !== '') {
                            control_type_values += '|';
                        }
                        control_type_values += val.valueInDatabase + '#' + val.value;
                    });
                }

                if (!utils.isUndefined(units_input)) {
                    units_input = units_input.split('|');
                    jQuery.each(units_input, function (i, val) {

                        if (units !== '') {
                            units += '|';
                        }

                        var splitted_unit = val.split('#');
                        if (splitted_unit.length === 7) {
                            units += splitted_unit[2] + '#' + (splitted_unit[1] === 'true' ? '1' : '0');
                        }
                    });
                }

                integrities.loadIntegrityComboboxValues(control_type, data_type, table_type, control_type_values, units, additionalFieldName !== '', format_fields, match_field, button === 'button_edit_assume_previous_data');

                var dialogId = $(element).attr('href');
                var parentTab = $(element).parents('.tt-content').find('[name="parent_tab"]').val();
                var dataViewId = $(element).parents('.tt-content').find('[name="data_view_id"]').val();
                var dataViewName = $(element).parents('.tt-content').find('[name="name' + additionalFieldName + '"]').val();
                var parentDataViewIdIfItemIsInAccordionOrList = $(element).parents('.tt-content').find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val();
                var tableName = $(element).parents('.tt-content').find('[name="table"]').val();
                var tableType = $(element).parents('.tt-content').find('[name="table_type"]').val();
                data_type = '';
                if (control_type === 'input' || control_type === 'input_with_additionalfield') {
                    data_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="data_type' + additionalFieldName + '"]').val();
                }
                $(dialogId).find('[name="button_id"]').val(element.id);
                $(dialogId).find('[name="parent_tab"]').val(parentTab);
                $(dialogId).find('[name="data_view_id"]').val(dataViewId);
                $(dialogId).find('[name="data_view_name"]').val(dataViewName);
                $(dialogId).find('[name="control_type"]').val(control_type);
                $(dialogId).find('[name="data_type"]').val(data_type);
                $(dialogId).find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val(parentDataViewIdIfItemIsInAccordionOrList);
                $(dialogId).find('[name="table_type"]').val(tableType);
                $(dialogId).find('[name="table"]').val(tableName);

                // Titel setzen
                var description = $(element).parents('.tt-content').find('[name="desc' + additionalFieldName + '"]').val();
                if (description === '' && control_type === '') {
                    $(dialogId).find('.modal-title').text(title);
                } else if (control_type === '') {
                    $(dialogId).find('.modal-title').text(description);
                } else {
                    $(dialogId).find('.modal-title').text(Lang.get('tripletrax.data_views_' + control_type) + ' - ' + description);
                }
                if (dialogCreated) {
                    $(element).click();
                }
            });

		} else if (/^button_edit_display_restriction_rules/.test(this.id)) {

			var dialog = 'table_data_views_display_restrictions_dialog';
			var contentDetail = 'content-detail-modal-display-restrictions';
			var table = '#table_data_views_display_restrictions';
			var button = 'button_edit_display_restriction_rules';
			var title = Lang.get('tripletrax.display_restrictions');

			// Modalen Dialog neu erstellen, wenn dieser noch nicht vorhanden ist (wird beim ersten Klick auf den Button neu erstellt)
			setModalDialog($(this), dialog, contentDetail).done(function (dialogCreated) {

				// Tabelle mit bereits angelegten Regeln befüllen
				$(table).DataTable().rows().remove();
				$(table).dataTable().fnStandingRedraw();

				if (!utils.isUndefined(inputValue) && inputValue !== '') {
					var input_display_restrictions = inputValue.split('|');

					jQuery.each(input_display_restrictions, function (i, val) {

						var display_restrictions = val.split('#');

						if (display_restrictions.length === 7) {

							$("#table_data_views_display_restrictions").dataTable().fnAddData([
								display_restrictions[0],
								display_restrictions[1],
								display_restrictions[2],
								display_restrictions[3],
								display_restrictions[4],
                                display_restrictions[5],
								display_restrictions[6]]
							);
						}
					});
				}

				var additionalFieldName = element.id.replace(button, '');

				var dialogId = $(element).attr('href');
				var parentTab = $(element).parents('.tt-content').find('[name="parent_tab"]').val();
				var dataViewId = $(element).parents('.tt-content').find('[name="data_view_id"]').val();
				var dataViewName = $(element).parents('.tt-content').find('[name="name' + additionalFieldName + '"]').val();
				var parentDataViewIdIfItemIsInAccordionOrList = $(element).parents('.tt-content').find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val();
				var tableName = $(element).parents('.tt-content').find('[name="table"]').val();
				var repetitionColumn = $(element).parents('.tt-content').find('[name="repetition"]').length ? $(element).parents('.tt-content').find('[name="repetition"]').val() : 0;
				var tableType = $(element).parents('.tt-content').find('[name="table_type"]').val();
				var control_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type"]').val();
				if ($(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type' + additionalFieldName + '"]').length) {
					control_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type' + additionalFieldName + '"]').val();
				}
				var data_type = '';
				if (control_type === 'input' || control_type === 'input_with_additionalfield') {
					data_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="data_type' + additionalFieldName + '"]').val();
				}
				$(dialogId).find('[name="button_id"]').val(element.id);
				$(dialogId).find('[name="parent_tab"]').val(parentTab);
				$(dialogId).find('[name="data_view_id"]').val(dataViewId);
				$(dialogId).find('[name="data_view_name"]').val(dataViewName);
				$(dialogId).find('[name="control_type"]').val(control_type);
				$(dialogId).find('[name="data_type"]').val(data_type);
				$(dialogId).find('[name="parent_data_view_id_if_item_is_in_accordion_or_list"]').val(parentDataViewIdIfItemIsInAccordionOrList);
				$(dialogId).find('[name="table_type"]').val(tableType);
				$(dialogId).find('[name="table"]').val(tableName);
				$(dialogId).find('[name="repetition"]').val(repetitionColumn);

				// Zeile mit Wiederholungs-Spalte nur bei Spalten mit Wiederholungen anzeigen
				if (repetitionColumn > 1) {
					$(dialogId).find('.tt-display-restriction-repetition-column-row').removeClass('hide');
				} else {
					$(dialogId).find('.tt-display-restriction-repetition-column-row').addClass('hide');
				}

				// Combobox mit Anzahl der Wiederholungen befüllen
				var data = [];
				if (repetitionColumn > 1) {
					for (var i = 1; i <= repetitionColumn; i++) {
						data.push({ id: i, text: i });
					}
				}
				validator.reinitializeSelect2($('.tt-display-restriction-repetition-column'), 'tt-select2 select2-container', '', data, false, false);

				// Titel setzen
				var description = $(element).parents('.tt-content').find('[name="desc' + additionalFieldName + '"]').val();
				if (control_type === 'date_range') {
					description = $(element).parents('.tt-content').find('[name="desc_from"]').val() + ' - ' + $(element).parents('.tt-content').find('[name="desc_till"]').val();
                }
				if (description === '' && control_type === '') {
					$(dialogId).find('.modal-title').text(title);
				} else if (control_type === '') {
					$(dialogId).find('.modal-title').text(description);
				} else {
					$(dialogId).find('.modal-title').text(Lang.get('tripletrax.data_views_' + control_type) + ' - ' + description);
				}

				if (dialogCreated) {
					$(element).click();
				}
			});

        } else if (/^button_edit_calculation/.test(this.id)) {

            // Modalen Dialog neu erstellen, wenn dieser noch nicht vorhanden ist (wird beim ersten Klick auf den Button neu erstellt)
            setModalDialog($(this), 'table_data_views_calculation_dialog', 'content-detail-modal-calculations').done(function (dialogCreated) {
                var dialogId = $(element).attr('href');
                $(dialogId).find('[name="button_id"]').val(element.id);
                $(dialogId).find('[name="calculation_field"]').val($(element).parents('form').find('[name="calculation' + element.id.replace('button_edit_calculation', '') + '"]').select2('data')[0].text);

                var option = $(element).parents('tr').find('.tt-select2-data-view-property').select2('data')[0];

                $(dialogId).find('.tt-calculation-row:not(.hide),.tt-calculation-dynamic-row:not(.hide),.tt-calculation-dynamic-match-list-row:not(.hide)').remove();

                var usedFieldsSelection = [];
                var matchFieldValues = [];
                if (!utils.isUndefined(inputValue) && inputValue !== '') {
                    usedFieldsSelection = inputValue.split('|');
                    if ($(option.element).data().usedFields === 'match_field' && usedFieldsSelection[1].split(':', 1) == 'match_field') {
                        usedFieldsSelection[usedFieldsSelection.length - 1] = JSON.parse(usedFieldsSelection[usedFieldsSelection.length - 1]);
                    }
                }
                if (usedFieldsSelection.length > 0 && usedFieldsSelection[0] === 'true') {
                    $(dialogId).find('[name="calculation_only_when_all_fields_are_filled"]').attr('checked', 'checked');
                }
                $(dialogId).find('[name="is_additional_field"]').val(element.id.indexOf('additionalfield') > 0);

                if ($(option.element).data().usedFields == '') {
                    $('.tt-calculation-button-row').removeClass('hide');
                    $('.tt-calculation-all-fields').removeClass('hide');
                    $('.tt-calculation-row-match-field').addClass('hide');

					if (usedFieldsSelection.length) {
                        jQuery.each(usedFieldsSelection, function (i, val) {
                            if (i > 0) {
                                addCalculationRow(dialogId, i - 1, '', element.id.indexOf('additionalfield') > 0, val);
                            }
                        });
                    } else {
                        addCalculationRow(dialogId, 0, '', element.id.indexOf('additionalfield') > 0, '');
                    }
                } else if ($(option.element).data().usedFields == 'match_field' && inputValue !== '') {
					$('.tt-calculation-all-fields').addClass('hide');
					$('.tt-calculation-row-match-field').removeClass('hide');
					$('.tt-calculation-button-row').removeClass('hide');
                    if (usedFieldsSelection[1].split(':', 1) == 'match_field') {
						if (usedFieldsSelection.length) {
							jQuery.each(usedFieldsSelection, function (i, val) {
								if (i > 0 ) {
									if (i === usedFieldsSelection.length - 1) {
										jQuery.each(val, function (j, matchFieldValue) {
											addCalculationRow(dialogId, j, '', element.id.indexOf('additionalfield') > 0, matchFieldValue);

										});
									} else if (!$('.tt-calculation-row-match-field').find('.tt-select2').val()) {
										var fieldValue = val.split(':');
										$('.tt-calculation-row-match-field').find('select:not(.tt-select2)').addClass('tt-select2');
										$('.tt-calculation-row-match-field').find('.tt-select2').val(fieldValue[1]).trigger('change.select2');
									}
								}
							});
						}
                    } else {
						var usedFields = $(option.element).data().usedFields.split('|');

						jQuery.each(usedFields, function (i, val) {
							addCalculationRow(dialogId, i, val, element.id.indexOf('additionalfield') > 0, usedFieldsSelection);
						});
                    }
                } else {
                    $('.tt-calculation-button-row').addClass('hide');
                    $('.tt-calculation-all-fields').addClass('hide');
					if (option.id == 'match_list') {
						$('.tt-calculation-row-match-field').removeClass('hide');
						$('.tt-calculation-button-row').removeClass('hide');
					} else {
						$('.tt-calculation-row-match-field').addClass('hide');
					}
                    var usedFields = $(option.element).data().usedFields.split('|');

                    jQuery.each(usedFields, function (i, val) {
                        addCalculationRow(dialogId, i, val, element.id.indexOf('additionalfield') > 0, usedFieldsSelection);
                    });
                }
                utils.updateGlobals('showValidationErrorMessageBox', false);
                $(dialogId).find('.tt-validation-form').valid();
                utils.updateGlobals('showValidationErrorMessageBox', true);

                if (dialogCreated) {
                    $(element).click();
                }
            });

        } else if (/^button_edit_help/.test(this.id)) {

            // Modalen Dialog neu erstellen, wenn dieser noch nicht vorhanden ist (wird beim ersten Klick auf den Button neu erstellt)
            setModalDialog($(this), 'table_data_views_help_dialog', 'content-detail-modal-help').done(function (dialogCreated) {
                var dialogId = $(element).attr('href');
                $(dialogId).find('[name="button_id"]').val(element.id);

                // Titel setzen
                var control_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type' + element.id.replace('button_edit_help', '') + '"]').val();
                var description = $(element).parents('.tt-content').find('[name="desc' + element.id.replace('button_edit_help', '') + '"]').val();
                if (description === '' && control_type === '') {
                    $(dialogId).find('.modal-title').text(Lang.get('tripletrax.help_text'));
                } else if (control_type === '') {
                    $(dialogId).find('.modal-title').text(description);
                } else {
                    $(dialogId).find('.modal-title').text(Lang.get('tripletrax.data_views_' + control_type) + ' - ' + description);
                }

                $(dialogId).find('[name="help"]').val($(element).parents('tr').find('textarea').val());
                if (dialogCreated) {
                    $(element).click();
                }
            });

        } else if (/^button_edit_control_type/.test(this.id)) {

            // Modalen Dialog neu erstellen, wenn dieser noch nicht vorhanden ist (wird beim ersten Klick auf den Button neu erstellt)
            setModalDialog($(this), 'table_data_views_control_type_dialog', 'content-detail-modal-control-types').done(function (dialogCreated) {
                var html = '';
                var existingValues = '';
                var existingDatabaseValues = '';
                var existingAggregationValues = '';
                if (!utils.isUndefined(inputValue) && inputValue !== '') {
                    var controlTypes = $.parseJSON(inputValue);
                    var currentControlType = $(element).parents('tr').find('.tt-select2-data-view-property').select2('val');

                    jQuery.each(controlTypes, function (i, controlType) {

                        //$(val).find('.dd3-content-label').after('<span class="label label-info dd3-content-label-match">' + match.text + '</span>');
                        // var controlTypeValues = val.split('#');

                        var hideString = '';
                        var deletedString = 'false';
                        if (!utils.isUndefined(controlType.isDeleted) && controlType.isDeleted) {
                            hideString = ' hide';
                            deletedString = 'true';
                        }
                        var scoreValue = '';
                        if (!utils.isUndefined(controlType.scoreValue)) {
                            scoreValue = controlType.scoreValue;
                        }
						var aggregationValue = '';
						if (!utils.isUndefined(controlType.aggregationValue)) {
							aggregationValue = controlType.aggregationValue;
						}
                        html += '<li class="dd-item dd3-item' + hideString + '">';
                        html += '   <div class="dd-handle dd-dialog-handle dd3-handle">';
                        html += '   </div>';
                        html += '   <div class="dd3-content dd-dialog-content" data-id="' + controlType.id + '" data-value="' + controlType.value + '" data-value-in-database="' + controlType.valueInDatabase + '" data-activation-additionalfield="' + controlType.activationAdditionalfield + '" data-is-deleted="' + deletedString + '" data-match="' + controlType.match + '" data-inactive="' + controlType.inactive + '" data-score-value="' + scoreValue + '" data-cave-text="' + utils.htmlSpecialChars(controlType.caveText) + '" data-cave-text-formatting="' + controlType.caveTextFormatting + '" data-cave-text-color="' + controlType.caveTextColor + '" data-aggregation-value="' + aggregationValue + '">';
                        if (controlType.inactive) {
                            html += '       <label class="dd3-content-label dd3-content-label-inactive">' + controlType.value + ' (' + controlType.valueInDatabase + ')' + '</label>';
                        } else {
                            html += '       <label class="dd3-content-label">' + controlType.value + ' (' + controlType.valueInDatabase + ')' + '</label>';
                        }
                        if (controlType.match !== '' && controlType.match !== null) {
                            html += '       <span class="label label-info dd3-content-label-match">' + Lang.get('tripletrax.' + controlType.match) + '</span>';
                        }
                        if (currentControlType !== 'radio' && currentControlType != 'combo' && currentControlType != 'combo_multiselect') {

                            var avtivationString = ' tt-button-nestable hide';
                            var checkedString = '';
                            if (controlType.activationAdditionalfield == 'on') {
                                avtivationString = '';
                                checkedString = ' checked="checked"';
                            }
                            html += '           <span class="tt-switch-nestable pull-right no-padding' + avtivationString + '">';
                            html += '               <label>' + trans('tripletrax.activate') + '</label>';
                            html += '               <span class="onoffswitch">';
                            html += '                   <input type="checkbox" name="start_interval_' + controlType.id + '" id="start_interval_' + controlType.id + '" class="onoffswitch-checkbox"' + checkedString + '>';
                            html += '                   <label class="onoffswitch-label" for="start_interval_' + controlType.id + '">';
                            html += '                       <span class="onoffswitch-inner" data-swchon-text="' + trans('tripletrax.yes') + '" data-swchoff-text="' + trans('tripletrax.no') + '"></span> ';
                            html += '                       <span class="onoffswitch-switch"></span>';
                            html += '                   </label> ';
                            html += '               </span>';
                            html += '           </span>';
                        }
                        html += '   </div>';
                        html += '</li>';

                        // bestehende Wert setzen
                        if (i > 0) {
                            existingValues += '|';
                            existingDatabaseValues += '|';
                            existingAggregationValues += '|';
                        }

                        existingValues += controlType.value;
                        existingDatabaseValues += controlType.valueInDatabase;
                        existingAggregationValues += controlType.aggregationValue;
                    });
                }

                var dialogId = $(element).attr('href');
                var control_type = $(element).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type' + element.id.replace('button_edit_control_type', '') + '"]').val();
                if (control_type === 'combo_multiselect') {
                    $(dialogId).find('.tt-cave-section').addClass('hide');
                } else {
                    $(dialogId).find('.tt-cave-section').removeClass('hide');
                }

                $(dialogId).find('[name="button_id"]').val(element.id);
                $(dialogId).find('[name="control_type"]').val(control_type);

                // Titel setzen
                var description = $(element).parents('.tt-content').find('[name="desc' + element.id.replace('button_edit_control_type', '') + '"]').val();
                $(dialogId).find('.modal-title').text(Lang.get('tripletrax.data_views_' + control_type) + ' - ' + description);

                // bestehende Werte setzen
                $(dialogId).find('[name="list_values"]').val(existingValues);
                $(dialogId).find('[name="list_values_in_database"]').val(existingDatabaseValues);
				$(dialogId).find('[name="list_aggregation_values"]').val(existingAggregationValues);

                // Entspricht Auswahl setzen
                var matchField = $(element).parents('.tt-content').find('[name="match' + element.id.replace('button_edit_control_type', '') + '"]').select2('val');

                var data = [];
                data.push({id: 'unknown', text: Lang.get('tripletrax.unknown_value')});
                data.push({id: 'not_collected', text: Lang.get('tripletrax.not_collected_value')});
                data.push({id: 'positive', text: Lang.get('tripletrax.positive')});
                data.push({id: 'negative', text: Lang.get('tripletrax.negative')});

                if (matchControlTypeValues !== '') {
                    var matchControlTypeValuesArray = matchControlTypeValues.split('|');
                    $.each(matchControlTypeValuesArray, function (i, val) {
                        data.push({id: val, text: Lang.get('tripletrax.' + val)});
                    });
                }

                jQuery.each($('[name="control_type_value_match"]'), function (i, val) {
                    $(val).parent().parent().removeClass('hide');

                    var selectContainer = $(val).parent();

                    validator.reinitializeSelect2($(selectContainer), 'input-sm tt-select2 select2-container', '', data, false);
                });

                var item = $(dialogId).find('.dd-list');
                item.empty();
                if (html !== '') {
                    $(html).hide().appendTo(item).fadeIn();
                }
                if (dialogCreated) {
                    $(element).click();
                }
            });
        } else {

            var dialogId = $(this).attr('href');
            $(dialogId).find('[name="button_id"]').val(this.id);
        }
    });

    // Nestable Lists - Startansicht setzen (Datenerhebungsarten)
    $('body').on('click', '.tt-set-start', function (e) {
        var id = $(this).parents('.tt-content').find('.tt-selected-id').val();

        $('.dd').find('.tt-start-view').remove();

        var start_view_string = '<div class="air air-top-right padding-7 padding-top-5 tt-start-view">';
        start_view_string += '<div class="btn-toolbar pull-right">';
        start_view_string += '<div class="btn-group">';
        start_view_string += '<a class="btn btn-xs btn-warning" rel="tooltip" data-placement="right" data-original-title="' + Lang.get('tripletrax.start_view') + '">';
        start_view_string += '<i class="fad fa-map-marker-alt"></i>';
        start_view_string += '</a>';
        start_view_string += '</div>';
        start_view_string += '</div>';
        start_view_string += '</div>';

        $('.dd').find("[data-id='" + id + "']").find('.tt-handle-first-level').append(start_view_string);

        if ($("#content-detail").find('.tt-datatable-changes').val() !== 'changed') {
            $("#content-detail").find('.tt-datatable-changes').val("changed");
            $("#content-detail").find('form').trigger('checkform.areYouSure');
        }
    });

    // Nestable Lists - Bei Datentyp und Spaltentyp Validierungsregeln anpassen. Bei TEXT Länge ausblenden
    $('body').on('select2:selecting', '.tt-select2-data-view-property[name="column_type"],.tt-select2-data-view-property[name="column_type_additionalfield_1"],.tt-select2-data-view-property[name="column_type_additionalfield_2"],.tt-select2-data-view-property[name="data_type"],.tt-select2-data-view-property[name="data_type_additionalfield_1"],.tt-select2-data-view-property[name="data_type_additionalfield_2"]', function (e) {

        // Bestehen bereits Daten, kann der Datentyp nicht geändert werden
        var element = $(this);
        var selectedValue = element.select2('val');
        var nameAppendix = element[0].name.replace('column_type', '').replace('data_type', '');

        var tableName = '';
        if ($(this).parents('form').find('[name="table"]').length) {
            tableName = $(this).parents('form').find('[name="table"]').val();
        }

        if (tableName === '' || selectedValue === '' || !element.parents('form').find('[name="data_view_id"]').length || element.parents('form').find('[name="data_view_id"]').val() === '0') {
            tableName = 'DUMMY';
        }

        var data = '&column=' + element.parents('form').find('[name="column' + nameAppendix + '"]').val();

        ajax.ajaxCall("admin/dataview/check/table/" + tableName, "GET", data, false, function (data) {

            if (data === 'existing') {
                var title = '';
                var desc = '';
                if (/data_type/.test(element[0].name)) {
                    title = Lang.get('tripletrax.change_data_type_existing_data_title');
                    desc = Lang.get('tripletrax.change_data_type_existing_data_desc');
                } else if (/column_type/.test(element[0].name)) {
                    title = Lang.get('tripletrax.change_column_type_existing_data_title');
                    desc = Lang.get('tripletrax.change_column_type_existing_data_desc');
                }

                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + title,
                    content: desc,
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                    // Typ der Spalte zurücksetzen
                    element.val(selectedValue).trigger('change.select2');
                    validator.triggerValidation(element[0], true, true);
                });
            } else {
                // Regeln der Validierung neu setzen
                element.parents('form').validate().settings.rules = validator.getRules(element.parents('form'));

                if (element.val() !== "DATE" && element.val() !== "DATETIME") {
                    // Länge ausblenden bei TEXT
                    if (element.has('[name="column_type"]')) {
                        if (element.val() === 'TEXT') {
                            element.parents('tr').next().addClass('hide');
                        } else {
                            element.parents('tr').next().removeClass('hide');
                        }
                    }
                    // Bei Datentyp Text kann auch 0 bei der Länge angegeben werden (Hinweis anzeigen)
                    if (element.has('[name="data_type"]')) {
                        if (element.val() === 'text') {
                            element.parents('tr').next().find('.note').removeClass('hide');
                        } else {
                            element.parents('tr').next().find('.note').addClass('hide');
                        }
                    }
                }
            }
        });
    });

    // Nestable Lists - Bei Auswahl Controltyp Entspricht-Feld überprüfen
    $('body').on('select2:selecting', '.tt-select2-data-view-property[name="control_type"],.tt-select2-data-view-property[name="control_type_additionalfield_1"],.tt-select2-data-view-property[name="control_type_additionalfield_2"]', function (e) {

        var element = $(this);
        var newValue = e.params.args.data.id;
        var selectedValue = element.select2('val');
        var nameAppendix = element[0].name.replace('control_type', '');
        var matchValue = '';
        var matchText = '';
        if (!utils.isUndefined(element.parents('form').find('[name="match' + nameAppendix + '"]').select2('data'))) {
            matchValue = element.parents('form').find('[name="match' + nameAppendix + '"]').select2('data')[0].id;
            matchText = element.parents('form').find('[name="match' + nameAppendix + '"]').select2('data')[0].text;
        }

        if (utils.isIDATInputField(matchValue) && newValue !== 'input') {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_control_type_match_field_title'),
                content: Lang.get('tripletrax.change_control_type_match_field_desc', {'matchName': matchText}),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
                // Match-Feld zurücksetzen
                element.val(selectedValue).trigger('change');
                validator.triggerValidation(element[0], true, true);
            });
        } else if (utils.isIDATRadioComboField(matchValue) && newValue !== 'radio' && newValue !== 'combo') {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_control_type_match_field_title'),
                content: Lang.get('tripletrax.change_control_type_match_field_desc', {'matchName': matchText}),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
                // Match-Feld zurücksetzen
                element.val(selectedValue).trigger('change');
                validator.triggerValidation(element[0], true, true);
            });
        } else if (utils.isIDATDatePanelField(matchValue) && newValue !== 'date_panel') {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_control_type_match_field_title'),
                content: Lang.get('tripletrax.change_control_type_match_field_desc', {'matchName': matchText}),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
                // Match-Feld zurücksetzen
                element.val(selectedValue).trigger('change');
                validator.triggerValidation(element[0], true, true);
            });
        }
    });

    // Nestable Lists - Bei Auswahl Controltyp bei den Zusatzfeldern abhängige Zeilen ein- bzw. ausblenden
    $('body').on('change', '.tt-select2-data-view-property[name="control_type_additionalfield_1"],.tt-select2-data-view-property[name="control_type_additionalfield_2"]', function (e) {

        // Zeile Darstellung bei Radiobuttons
        var displayName = 'display_additionalfield_1';
        if (this.name === 'control_type_additionalfield_2') {
            displayName = 'display_additionalfield_2';
        }
        if ($(this).val() === 'radio') {
            $(this).parents('.tt-content').find('tr[data-name="' + displayName + '"]').removeClass('hide');
        } else {
            $(this).parents('.tt-content').find('tr[data-name="' + displayName + '"]').addClass('hide');
        }

        // Zeile Button Untersuchungsdatum bei DatePanels
        var assumeExaminationDateName = 'assume_examination_date_button_additionalfield_1';
        if (this.name === 'control_type_additionalfield_2') {
            assumeExaminationDateName = 'assume_examination_date_button_additionalfield_2';
        }
        if ($(this).val() === 'date_panel' || $(this).val() === 'date_range') {
            $(this).parents('.tt-content').find('tr[data-name="' + assumeExaminationDateName + '"]').removeClass('hide');
        } else {
            $(this).parents('.tt-content').find('tr[data-name="' + assumeExaminationDateName + '"]').addClass('hide');
        }

        // Zeile maximale Breite bei Input, DatePanels und Comboboxen
        var maxWidthName = 'max_width_additionalfield_1';
        if (this.name === 'control_type_additionalfield_2') {
            maxWidthName = 'max_width_additionalfield_2';
        }
        if ($(this).val() === 'input' || $(this).val() === 'date_panel' || $(this).val() === 'date_range' || $(this).val() === 'combo' || $(this).val() === 'combo_multiselect') {
            $(this).parents('.tt-content').find('tr[data-name="' + maxWidthName + '"]').removeClass('hide');
        } else {
            $(this).parents('.tt-content').find('tr[data-name="' + maxWidthName + '"]').addClass('hide');
        }

        // Zeile Formatangabe bei Input und DatePanel
        var formatFieldsName = 'format_fields_additionalfield_1';
        var matchFieldsName = 'match_additionalfield_1';
        if (this.name === 'control_type_additionalfield_2') {
            formatFieldsName = 'format_fields_additionalfield_2';
            matchFieldsName = 'match_additionalfield_2';
        }
        if ($(this).val() === 'input' || $(this).val() === 'date_panel' || $(this).val() === 'date_range') {
            var containerElement = $($(this).parents('.tt-content').find('tr[data-name="' + formatFieldsName + '"]').find('td')[1]).children();

            var matchField = '';
            if ($(this).parents('form').find('[name="' + matchFieldsName + '"]').val() !== '') {
                matchField = $(this).parents('form').find('[name="' + matchFieldsName + '"]').select2('data')[0].id;
            }

            var data = [];
            if (!utils.isIDATField(matchField)) {
                data.push({id: 'unknown', text: Lang.get('tripletrax.unknown_value')});
                data.push({id: 'not_collected', text: Lang.get('tripletrax.not_collected_value')});
            }
            if ($(this).val() === 'date_panel' || $(this).val() === 'date_range') {
                if (!utils.isIDATField(matchField)) {
                    data.push({id: 'continuing', text: Lang.get('tripletrax.continuing_value')});
                }
                data.push({ id: 'full', text: Lang.get('tripletrax.full') });
                data.push({ id: 'mm/yy', text: Lang.get('tripletrax.mm/yy') });
                data.push({ id: 'yy', text: Lang.get('tripletrax.yy') });
            } else {
                if (!utils.isIDATField(matchField)) {
                    data.push({id: 'not_measurable', text: Lang.get('tripletrax.not_measurable_value')});
                }
            }

            validator.reinitializeSelect2($(containerElement), 'tt-select2 tt-select2-data-view-property select2-container', '', data, true);

            $(this).parents('.tt-content').find('tr[data-name="' + formatFieldsName + '"]').removeClass('hide');
        } else {
            $(this).parents('.tt-content').find('tr[data-name="' + formatFieldsName + '"]').addClass('hide');
        }

        // Button für die Ausprägungen bei Radiobuttons und Comboboxen
        if ($(this).val() === 'radio' || $(this).val() === 'combo' || $(this).val() === 'combo_multiselect') {
            $(this).parents('tr').find('.tt-edit-data-view-property').removeClass('hide');
        } else {
            $(this).parents('tr').find('.tt-edit-data-view-property').addClass('hide');
        }

        // Regeln der Validierung neu setzen
        $(this).parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));

        // Laboreinheiten bei Input-Feldern
        var select_element = $(this).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type"]');
        var select_additional_field1 = $(this).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type_additionalfield_1"]');
        var select_additional_field2 = $(this).parents('.tt-content').find('.tt-select2-data-view-property[name="control_type_additionalfield_2"]');

        // Zusatzfeld 1
        if (!utils.isUndefined(select_additional_field1) && $(select_additional_field1).val() === 'input') {
            $(this).parents('.tt-content').find('tr[data-name="data_type_additionalfield_1"]').removeClass('hide');
            $(this).parents('.tt-content').find('.tt-unit-title_additionalfield_1').removeClass('hide');
        } else {
            $(this).parents('.tt-content').find('tr[data-name="data_type_additionalfield_1"]').addClass('hide');
            $(this).parents('.tt-content').find('.tt-unit_additionalfield_1').remove();
            $(this).parents('.tt-content').find('.tt-unit-title_additionalfield_1').addClass('hide');

            if ($("#content-detail").find('#button_edit_units_additionalfield_1').length) {
                var input = $("#content-detail").find('[name="edit_units_additionalfield_1"]');
                input.val('');
            }
        }

        // Zusatzfeld 2
        if (!utils.isUndefined(select_additional_field2) && $(select_additional_field2).val() === 'input') {
            $(this).parents('.tt-content').find('tr[data-name="data_type_additionalfield_2"]').removeClass('hide');
            $(this).parents('.tt-content').find('.tt-unit-title_additionalfield_2').removeClass('hide');
        } else {
            $(this).parents('.tt-content').find('tr[data-name="data_type_additionalfield_2"]').addClass('hide');
            $(this).parents('.tt-content').find('.tt-unit_additionalfield_2').remove();
            $(this).parents('.tt-content').find('.tt-unit-title_additionalfield_2').addClass('hide');

            if ($("#content-detail").find('#button_edit_units_additionalfield_2').length) {
                var input = $("#content-detail").find('[name="edit_units_additionalfield_2"]');
                input.val('');
            }
        }

        // Obergruppe nur bei eigenem Input-Typ oder eines der beiden Zusatzfelder ist Input
        if ((utils.isUndefined(select_additional_field1) || $(select_additional_field1).val() !== 'input')
            && (utils.isUndefined(select_additional_field2) || $(select_additional_field2).val() !== 'input')
            && (utils.isUndefined(select_element) || $(select_element).val() !== 'input')) {

            jQuery.each($('#table_data_view_properties').find('.tt-tree-header-row'), function (k, val) {
                if (/^laboratory/.test(val.getAttribute('data-tt-id'))) {
                    $(val).addClass('hide');
                    return false;
                }
            });
        } else {
            jQuery.each($('#table_data_view_properties').find('.tt-tree-header-row'), function (k, val) {
                if (/^laboratory/.test(val.getAttribute('data-tt-id'))) {
                    $(val).removeClass('hide');
                    return false;
                }
            });
        }

        // Datenbank Spaltentyp - Auswahl setzen
        var columnTypeName = 'column_type_additionalfield_1';
        var columnLengthName = 'column_length_additionalfield_1';
        if (this.name === 'control_type_additionalfield_2') {
            columnTypeName = 'column_type_additionalfield_2';
            columnLengthName = 'column_length_additionalfield_2';
        }
        var columnType = $($("#content-detail").find('[data-name="' + columnTypeName + '"]').find('td')[1]).find('div')[0];
        var currentSelection = $(columnType).find('.tt-select2').select2('val');

        var data = [];
        if ($(this).val() === 'radio' || $(this).val() === 'combo' || $(this).val() === 'combo_multiselect') {
            data.push({ id: 'VARCHAR', text: 'VARCHAR' });
            data.push({ id: 'INT', text: 'INT' });
            data.push({ id: 'DECIMAL', text: 'DECIMAL' });

            if (currentSelection !== 'VARCHAR' && currentSelection !== 'INT' && currentSelection !== 'DECIMAL') {
                currentSelection = '';
            }

            $("#content-detail").find('[data-name="' + columnLengthName + '"]').removeClass('hide');
        } else if ($(this).val() === 'input') {
            data.push({ id: 'VARCHAR', text: 'VARCHAR' });
            data.push({ id: 'INT', text: 'INT' });
            data.push({ id: 'DECIMAL', text: 'DECIMAL' });
            data.push({ id: 'TEXT', text: 'TEXT' });

            if (currentSelection !== 'VARCHAR' && currentSelection !== 'INT' && currentSelection !== 'DECIMAL' && currentSelection !== 'TEXT') {
                currentSelection = '';
            }

            $("#content-detail").find('[data-name="' + columnLengthName + '"]').removeClass('hide');
        } else if ($(this).val() === 'date_panel' || $(this).val() === 'date_range') {
            data.push({ id: 'DATE', text: 'DATE' });
            data.push({ id: 'DATETIME', text: 'DATETIME' });

            if (currentSelection !== 'DATE' && currentSelection !== 'DATETIME') {
                currentSelection = '';
            }

            $("#content-detail").find('[name="' + columnLengthName + '"]').val('');
            $("#content-detail").find('[data-name="' + columnLengthName + '"]').addClass('hide');
        }

        validator.reinitializeSelect2($(columnType), 'input-sm tt-select2 tt-select2-data-view-property select2-container', '', data, false);

        $(columnType).find('.tt-select2').val(currentSelection).trigger('change.select2');
    });

    // Nestable Lists - Bei Auswahl Berechnung Button aktiv / inaktiv setzen und bereits ausgewählte Werte zurücksetzen
    $('body').on('change', '.tt-select2-data-view-property[name="calculation"],.tt-select2-data-view-property[name="calculation_additionalfield_1"]', function (e) {
        // Button für die Felder der Berechnung
        if ($(this).val() === '') {
            $(this).parents('tr').find('.tt-edit-data-view-property').prop('disabled', 'disabled');
            $(this).parents('tbody').find('[name="calculation_editable' + $(this)[0].name.replace('calculation', '') + '"]')[0].checked = false;
            $(this).parents('tbody').find('[name="calculation_editable' + $(this)[0].name.replace('calculation', '') + '"]').prop('disabled', 'disabled');
            $(this).parents('tbody').find('[name="calculation_editable' + $(this)[0].name.replace('calculation', '') + '"]').parent().addClass('state-disabled');
            $(this).parents('tr').find('.tt-edit-data-view-property').find('input:not([name="edit_' + $(this)[0].name + '_init_value"])').val('');
        } else {
            $(this).parents('tr').find('.tt-edit-data-view-property').removeAttr('disabled');
			$(this).parents('tbody').find('[name="calculation_editable' + $(this)[0].name.replace('calculation', '') + '"]').removeAttr('disabled');
			$(this).parents('tbody').find('[name="calculation_editable' + $(this)[0].name.replace('calculation', '') + '"]').parent().removeClass('state-disabled');
            $(this).parents('tr').find('.tt-edit-data-view-property').find('[name="edit_' + $(this)[0].name + '_correct"]').val('fails');
        }

        $(this).parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));
    });

    // Nestable Lists - Bei Auswahl Übernahme von Vordaten Button aktiv / inaktiv setzen
    $('body').on('change', '.tt-checkbox-property[name="assume_previous_data"]', function (e) {
        // Button für die Einschränkungen
        if ($(this).is(':checked')) {
            $(this).parents('tr').find('.tt-edit-data-view-property').removeAttr('disabled');
        } else {
            $(this).parents('tr').find('.tt-edit-data-view-property').prop('disabled', 'disabled');
            $('#table_data_view_properties').find('.tt-restriction').remove();
            $('[name="edit_assume_previous_data"]').val('');
        }
    });

    // Nestable Lists - Zugehöriges Feld 'Wert keine Komplikationen' dis- / enabled setzen bzw. Button 'Keine Komplikationen' oder Button 'Keine Komplikationen aktives Feld' nur eins davon setzen
    $('body').on('change', '[type=checkbox].tt-checkbox-property', function (e) {
        // Zugehöriges Feld 'Wert keine Komplikationen' dis- / enabled setzen
        var attrName = '';
        if ($(this).attr('name') === 'no_complications') {
            attrName = 'no_complications_value';
        } else if ($(this).attr('name') === 'not_collected') {
            attrName = 'not_collected_value';
        }
        if (attrName !== '') {
            if ($(this)[0].checked) {
                if ($(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').attr('type') === 'checkbox') {
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').removeAttr('state-disabled');
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').parents('.treelist-checkbox').removeClass('state-disabled');
                } else {
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').removeAttr('disabled');
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').parents('td').find('button').removeAttr('disabled');
                }
            } else {
                if ($(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').attr('type') === 'checkbox') {
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').removeAttr('checked');
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').prop('state-disabled');
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').parents('.treelist-checkbox').addClass('state-disabled');
                } else {
                    if ($(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').hasClass('tt-select2', 'select2-hidden-accessible')) {
                        $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').val(null).trigger('change.select2');
                    } else {
                        $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').val('');
                    }
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').prop('disabled', 'disabled');
                    $(this).parents('.tt-tree-datatable').find('[name="' + attrName + '"]').parents('td').find('button').prop('disabled', 'disabled');
                }
            }
        }

        // Button 'Keine Komplikationen' und Button 'Restliche Felder auf nicht pathologisch / negativ setzen bei einem bestehenden positiven Eintrag' - nur einer davon kann aktiv sein
        if ($(this)[0].checked) {
            if ($(this).attr('name') === 'no_complications_button') {
                $(this).parents('.tt-tree-datatable').find('[name="no_complications_one_active_button"]').removeAttr('checked');
            } else if ($(this).attr('name') === 'no_complications_one_active_button') {
                $(this).parents('.tt-tree-datatable').find('[name="no_complications_button"]').removeAttr('checked');
            }
        }
    });

    // Nestable Lists - Bei Änderung Formatangaben Auswahl für Wert 'nicht erhoben' und Wert 'Keine Komplikationen' setzen
    $('body').on('change', '[name="format_fields"]', function (e) {

        if ($('[name="control_type"]').select2('val') === 'input' || $('[name="control_type"]').select2('val') === 'input_with_additionalfield') {
            setInputNoComplicationsAndNotCollectedFormatValues();
        } else if ($('[name="control_type"]').select2('val') === 'date_panel' || $('[name="control_type"]').select2('val') === 'date_range') {
            setDatePanelNoComplicationsAndNotCollectedFormatValues();
        }
    });

    // Nestable Lists - Bei Änderung 'Bezug zur Untersuchung' Auswahl für Wert 'Tabellentyp' setzen
    $('body').on('change', '[name="related_to_examination"]', function (e) {

        if ($('[name="control_type"]').select2('val') === 'list_with_radio' || $('[name="control_type"]').select2('val') === 'accordion_as_list_with_radio') {

            var tableType = $("#content-detail").find('[data-name="table_type"]').find('td')[1];

            var data = [];
            if ($(this).is(':checked')) {
                data.push({ id: 'course_table', text: trans('tripletrax.course_table') });
                data.push({ id: 'course_facility_table', text: trans('tripletrax.course_facility_table') });
            } else {
                data.push({ id: 'master_table', text: trans('tripletrax.master_table') });
                data.push({ id: 'master_facility_table', text: trans('tripletrax.master_facility_table') });
            }

            validator.reinitializeSelect2($(tableType), 'tt-select2 tt-select2-data-view-property select2-container', '', data, false);
        }
    });

    // Nestable Lists - Bei Änderung Tabellenname Überprüfung auf existierende Daten
    $('body').on('change', '[name="table"]', function (e) {

        // Bestehen bereits Daten, kann der Tabellenname nicht geändert werden
        var element = $(this);
        var selectedValue = element.prop("defaultValue");

        var tableName = selectedValue;
        if (utils.isUndefined(selectedValue) || selectedValue === '' || !element.parents('form').find('[name="data_view_id"]').length || element.parents('form').find('[name="data_view_id"]').val() === '0') {
            tableName = 'DUMMY';
        }

        var data = '';
        if ($('#content-detail').find('[name="is_period_item"]').val() !== '1') {
            // bei zeitraumbezogene Daten muss die komplette Tabelle berücksichtigt werden
            if (element.parents('form').find('[name="column"]').length && element.parents('form').find('[name="column"]').prop("defaultValue") !== '') {
                data += '&column=' + element.parents('form').find('[name="column"]').prop("defaultValue");
            }
            if (element.parents('form').find('[name="column_additionalfield_1"]').length && element.parents('form').find('[name="column_additionalfield_1"]').prop("defaultValue") !== '') {
                data += '&column_additionalfield_1=' + element.parents('form').find('[name="column_additionalfield_1"]').prop("defaultValue");
            }
            if (element.parents('form').find('[name="column_additionalfield_2"]').length && element.parents('form').find('[name="column_additionalfield_2"]').prop("defaultValue") !== '') {
                data += '&column_additionalfield_2=' + element.parents('form').find('[name="column_additionalfield_2"]').prop("defaultValue");
            }
        }

        ajax.ajaxCall("admin/dataview/check/table/" + tableName, "GET", data, false, function(data) {

            if (data === 'existing') {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_table_title'),
                    content: Lang.get('tripletrax.change_table_existing_data_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                    // Tabellenname zurücksetzen
                    element.val(selectedValue);
                    validator.triggerValidation(element[0], true, true);
                    validator.triggerValidation(element.parents('form').find('[name="column"]')[0], true, true);
                    validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_1"]')[0], true, true);
                    validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_2"]')[0], true, true);
                    validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
                });
            } else {

                // Für zeitraumbezogene Items muss zusätzlich geprüft werden, ob der Tabellenname für alle Felder gleich ist
                if ($('#content-detail').find('[name="is_period_item"]').val() === '1' && element.val() !== '') {
                    ajax.ajaxCall("admin/dataview/check/parentid/" + $('#content-detail').find('[name="parent_id"]').val() + "/table/" + element.val(), "GET", data, false, function(data) {
                        if (data !== '') {
                            if (!element.parents('form').find('[name="data_view_id"]').length || element.parents('form').find('[name="data_view_id"]').val() === '0') {
                                // bei neue Items muss der Name gleich den anderen sein
                                $.SmartMessageBox({
                                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_table_title'),
                                    content: Lang.get('tripletrax.change_table_same_in_list_new_item_desc', {'tableName': data}),
                                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                }, function (ButtonPressed) {
                                    // Tabellenname zurücksetzen
                                    element.val(selectedValue);
                                    validator.triggerValidation(element[0], true, true);
                                    validator.triggerValidation(element.parents('form').find('[name="column"]')[0], true, true);
                                    validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_1"]')[0], true, true);
                                    validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_2"]')[0], true, true);
                                    validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
                                });
                            } else {
                                $.SmartMessageBox({
                                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_table_title'),
                                    content: Lang.get('tripletrax.change_table_same_in_list_desc', {'tableName': data}),
                                    buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                                }, function (ButtonPressed) {
                                    if (ButtonPressed === Lang.get('tripletrax.yes')) {
                                        validator.triggerValidation(element.parents('form').find('[name="column"]')[0], true, true);
                                        validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_1"]')[0], true, true);
                                        validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_2"]')[0], true, true);
                                        validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
                                    } else {
                                        // Tabellenname zurücksetzen
                                        element.val(selectedValue);
                                        validator.triggerValidation(element[0], true, true);
                                        validator.triggerValidation(element.parents('form').find('[name="column"]')[0], true, true);
                                        validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_1"]')[0], true, true);
                                        validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_2"]')[0], true, true);
                                        validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
                                    }
                                });
                            }
                        } else {
                            validator.triggerValidation(element.parents('form').find('[name="column"]')[0], true, true);
                            validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_1"]')[0], true, true);
                            validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_2"]')[0], true, true);
                            validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
                        }
                    });
                }
                else {
                    validator.triggerValidation(element.parents('form').find('[name="column"]')[0], true, true);
                    validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_1"]')[0], true, true);
                    validator.triggerValidation(element.parents('form').find('[name="column_additionalfield_2"]')[0], true, true);
                    validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
                }
            }
        });
    });

    // Nestable Lists - Bei Änderung des Tabellentyps Tabellenname ebenfalls überprüfen
    $('body').on('change', '[name="table_type"]', function (e) {
        validator.triggerValidation($(this).parents('form').find('[name="table"]')[0], true, true);
    });

    // Nestable Lists - Bei Abhaken der Primärschlüssel Prüfung auf bestehende Daten
    $('body').on('change', '[name="is_primary_key"],[name="is_primary_key_additionalfield_1"],[name="is_primary_key_additionalfield_2"]', function (e) {

        // Bestehen bereits Daten, kann der Primärschlüssel nicht gelöscht werden
        var element = $(this);
        var isChecked = $(this).is(':checked');

        if (!isChecked) {
            var tableName = '';
            if (element.parents('form').find('[name="table"]').length) {
                tableName = element.parents('form').find('[name="table"]').val();
            }

            if (tableName !== '' && element.parents('form').find('[name="data_view_id"]').length && element.parents('form').find('[name="data_view_id"]').val() !== '0') {
                ajax.ajaxCall("admin/dataview/check/table/" + tableName, "GET", null, false, function (data) {

                    if (data === 'existing') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_primary_key_existing_data_title'),
                            content: Lang.get('tripletrax.change_primary_key_existing_data_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                            // Primärschlüssel zurücksetzen
                            element.prop('checked', !isChecked);
                            validator.triggerValidation(element[0], true, true);
                        });
                    }
                });
            }
        }
    });

    // Nestable Lists - Bei Änderung der Spaltenlänge Überprüfung auf bestehende Daten
    $('body').on('change', '[name="column_length"],[name="column_length_additionalfield_1"],[name="column_length_additionalfield_2"]', function (e) {

        // Bestehen bereits Daten, kann die Länge der Spalte nur vergrößert werden
        var element = $(this);
        var selectedValue = element.prop("defaultValue");
        var nameAppendix = element[0].name.replace('column_length', '');
        var newValue = element.val();

        var tableName = '';
        if (element.parents('form').find('[name="table"]').length) {
            tableName = element.parents('form').find('[name="table"]').val();
        }

        if (utils.isUndefined(selectedValue) || selectedValue === '' || !element.parents('form').find('[name="data_view_id"]').length || element.parents('form').find('[name="data_view_id"]').val() === '0') {
            return;
        }

        var data = '&column=' + element.parents('form').find('[name="column' + nameAppendix + '"]').val();

        ajax.ajaxCall("admin/dataview/check/table/" + tableName, "GET", data, false, function (data) {

            if (data === 'existing' && (newValue === '' || utils.stringToNumber(newValue) < parseFloat(selectedValue))) {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_column_length_existing_data_title'),
                    content: Lang.get('tripletrax.change_column_length_existing_data_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                    // Länge der Spalte zurücksetzen
                    element.val(utils.numberToString(parseFloat(selectedValue)));
                    validator.triggerValidation(element[0], true, true);
                });
            }
        });
    });

	// Nestable Lists - Bei Änderung der Wiederholungen bei Spalten Überprüfung auf bestehende Daten
	$('body').on('change', '[name="repetition"]', function (e) {

		// Bestehen bereits Daten, kann die Anzahl der Wiederholungen nur verkleinert werden, wenn keine Daten existieren
        // Vergrößert kann die Anzahl der Wiederholungen immer
		var element = $(this);
		var selectedValue = element.prop("defaultValue");
		var newValue = element.val();

		if (utils.isUndefined(selectedValue) || selectedValue === '' || !element.parents('form').find('[name="data_view_id"]').length || element.parents('form').find('[name="data_view_id"]').val() === '0') {
			return;
		}

		var data = '&data_view_id=' + element.parents('form').find('[name="data_view_id"]').val();

		ajax.ajaxCall("admin/dataview/check/repetition/" + selectedValue + "/new_repetition/" + newValue, "GET", data, false, function (data) {

			if (data === 'existing' && (newValue === '' || utils.stringToNumber(newValue) < parseFloat(selectedValue))) {
				$.SmartMessageBox({
					title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_column_length_existing_data_title'),
					content: Lang.get('tripletrax.change_column_length_existing_data_desc', {'repetition': newValue, 'max_repetition': 4}),
					buttons: '[' + Lang.get('tripletrax.ok') + ']'
				}, function (ButtonPressed) {
					// Anzahl der Wiederholungen zurücksetzen
					element.val(utils.numberToString(parseFloat(selectedValue)));
					validator.triggerValidation(element[0], true, true);
				});
			}
		});
	});

    // Nestable Lists - Bei Änderung des Entspricht-Feldes - Überprüfung auf Korrektheit, Aus- und Einblenden der Datenbankangaben, bzw. Löschen der Einheiten, Integritäten und Formatangaben
    $('body').on('select2:selecting', '[name="match"],[name="match_additionalfield_1"],[name="match_additionalfield_2"]', function (e) {

        if (utils.isUndefined(e.params.args.data)) {
            return;
        }

        var element = $(this);
        var selectedValue = element.select2('val');
        var newValue = e.params.args.data.id;
        var nameAppendix = element[0].name.replace('match', '');
        var controlType = element.parents('form').find('[name="control_type' + nameAppendix + '"]').val();
        var formatFieldsValue = element.parents('form').find('[name="format_fields' + nameAppendix + '"]').select2('val');
        var calculationValue = element.parents('form').find('[name="calculation' + nameAppendix + '"]').select2('val');

        if (controlType === '') {
            return;
        }

        if (utils.isIDATInputField(newValue) && controlType !== 'input') {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_match_field_title'),
                content: Lang.get('tripletrax.change_match_field_desc', {'matchName': e.params.args.data.text, 'controlType': Lang.get('tripletrax.data_views_input')}),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
                // Match-Feld zurücksetzen
                element.val(selectedValue).trigger('change');
                validator.triggerValidation(element[0], true, true);
            });
            return;
        } else if (utils.isIDATRadioComboField(newValue) && controlType !== 'radio' && controlType !== 'combo') {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_match_field_title'),
                content: Lang.get('tripletrax.change_match_field_desc', {'matchName': e.params.args.data.text, 'controlType': Lang.get('tripletrax.data_views_combo') + ' ' + Lang.get('tripletrax.or') + ' ' + Lang.get('tripletrax.data_views_radio')}),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
                // Match-Feld zurücksetzen
                element.val(selectedValue).trigger('change');
                validator.triggerValidation(element[0], true, true);
            });
            return;
        } else if (utils.isIDATDatePanelField(newValue) && controlType !== 'date_panel') {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_match_field_title'),
                content: Lang.get('tripletrax.change_match_field_desc', {'matchName': e.params.args.data.text, 'controlType': Lang.get('tripletrax.data_views_date_panel')}),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
                // Match-Feld zurücksetzen
                element.val(selectedValue).trigger('change');
                validator.triggerValidation(element[0], true, true);
            });
            return;
        }

        if (utils.isIDATField(newValue)) {
            if ((!utils.isUndefined(element.parents('form').find('[name="edit_units' + nameAppendix + '"]').val()) && element.parents('form').find('[name="edit_units' + nameAppendix + '"]').val() !== '')
                || formatFieldsValue.length > 0
                || (!utils.isUndefined(element.parents('form').find('[name="edit_integrity_rules' + nameAppendix + '"]').val()) && element.parents('form').find('[name="edit_integrity_rules' + nameAppendix + '"]').val() !== '' && utils.isIDATFieldInDatabase(newValue))
                || calculationValue.length > 0) {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.change_match_field_question_title'),
                    content: Lang.get('tripletrax.change_match_field_question_desc'),
                    buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                }, function (ButtonPressed) {
                    if (ButtonPressed === Lang.get('tripletrax.yes')) {
                        // Einheiten löschen
                        $('#table_data_view_properties').find('[name="edit_units' + nameAppendix + '"]').val('');
                        $('#table_data_view_properties').find('.tt-unit' + nameAppendix).remove();
                        if (utils.isIDATFieldInDatabase(newValue)) {
                            // Integritäten (außer Vollständigkeiten) löschen - für alle Felder, welche nur in IDAT gespeichert werden
                            var remainingRules = '';
                            jQuery.each($('#table_data_view_properties').find('[name="edit_integrity_rules' + nameAppendix + '"]').val().split('|'), function (i, val) {
                                if (val.split('#')[3] === 'completeness') {
                                    if (remainingRules !== '') {
                                        remainingRules += '|';
                                    }
                                    remainingRules += val;
                                }
                            });
                            $('#table_data_view_properties').find('[name="edit_integrity_rules' + nameAppendix + '"]').val(remainingRules);
                            var regExp = new RegExp('(' + Lang.get('tripletrax.completeness') + ')');
                            jQuery.each($('#table_data_view_properties').find('.tt-integrity' + nameAppendix), function (i, val) {
                                if (!regExp.test(val.innerText)) {
                                    val.remove();
                                }
                            });
                        }
                        // Formatangaben neu setzen
                        if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'date_panel' || controlType === 'date_range') {
                            var containerElement = $(element.parents('.tt-content').find('tr[data-name="format_fields' + nameAppendix + '"]').find('td')[1]).children();

                            var data = [];
                            if (!utils.isIDATField(newValue)) {
                                data.push({id: 'unknown', text: Lang.get('tripletrax.unknown_value')});
                                data.push({id: 'not_collected', text: Lang.get('tripletrax.not_collected_value')});
                            }
                            if (controlType === 'date_panel' || controlType === 'date_range') {
                                if (!utils.isIDATField(newValue)) {
                                    data.push({id: 'continuing', text: Lang.get('tripletrax.continuing_value')});
                                }
                                data.push({id: 'full', text: Lang.get('tripletrax.full')});
                                data.push({id: 'mm/yy', text: Lang.get('tripletrax.mm/yy')});
                                data.push({id: 'yy', text: Lang.get('tripletrax.yy')});
                            } else {
                                if (!utils.isIDATField(newValue)) {
                                    data.push({id: 'not_measurable', text: Lang.get('tripletrax.not_measurable_value')});
                                }
                            }

                            validator.reinitializeSelect2($(containerElement), 'tt-select2 tt-select2-data-view-property select2-container', '', data, true);
                        }
                        element.parents('form').find('[name="format_fields' + nameAppendix + '"]').val(formatFieldsValue).trigger('change.select2');

                        // Datenbankangaben und Berechnung aus- bzw. einblenden
                        if ((utils.isIDATField(newValue) && !utils.isIDATField(selectedValue))
                            || (!utils.isIDATField(newValue) && utils.isIDATField(selectedValue))
                            || (utils.isMatchFieldInDatabase(newValue) && !utils.isMatchFieldInDatabase(selectedValue))
                            || (!utils.isMatchFieldInDatabase(newValue) && utils.isMatchFieldInDatabase(selectedValue))) {

                            if (utils.isIDATField(newValue) || utils.isMatchFieldInDatabase(newValue)) {
                                // Datenbankangaben
                                element.parents('form').find('[data-tt-id^="database_"]').addClass('hide');
                                element.parents('form').find('[data-name="table"]').addClass('hide');
                                element.parents('form').find('[name="table"]').val('');
                                element.parents('form').find('[data-name="table_type"]').addClass('hide');
                                element.parents('form').find('[name="table_type"]').val(null).trigger('change.select2');
                                element.parents('form').find('[data-name="column' + nameAppendix + '"]').addClass('hide');
                                element.parents('form').find('[name="column' + nameAppendix + '"]').val('');
                                element.parents('form').find('[data-name="column_type' + nameAppendix + '"]').addClass('hide');
                                element.parents('form').find('[name="column_type' + nameAppendix + '"]').val(null).trigger('change.select2');
                                element.parents('form').find('[data-name="column_length' + nameAppendix + '"]').addClass('hide');
                                element.parents('form').find('[name="column_length' + nameAppendix + '"]').val('');
                                // Berechnung
                                element.parents('form').find('[data-name="calculation' + nameAppendix + '"]').addClass('hide');
                                element.parents('form').find('[name="calculation' + nameAppendix + '"]').val(null).trigger('change.select2');
                            } else {
                                // Datenbankangaben
                                element.parents('form').find('[data-tt-id^="database_"]').removeClass('hide');
                                element.parents('form').find('[data-name="table"]').removeClass('hide');
                                element.parents('form').find('[data-name="table_type"]').removeClass('hide');
                                element.parents('form').find('[data-name="column' + nameAppendix + '"]').removeClass('hide');
                                element.parents('form').find('[data-name="column_type' + nameAppendix + '"]').removeClass('hide');
                                element.parents('form').find('[data-name="column_length' + nameAppendix + '"]').removeClass('hide');
                                element.parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));
                                validator.triggerValidation(element.parents('form').find('[name="table"]')[0], true, true);
                                validator.triggerValidation(element.parents('form').find('name="table_type"]')[0], true, true);
                                validator.triggerValidation(element.parents('form').find('[name="column' + nameAppendix + '"]')[0], true, true);
                                validator.triggerValidation(element.parents('form').find('[name="column_type' + nameAppendix + '"]')[0], true, true);
                                validator.triggerValidation(element.parents('form').find('[name="column_length' + nameAppendix + '"]')[0], true, true);
                                // Berechnung
                                element.parents('form').find('[data-name="calculation' + nameAppendix + '"]').removeClass('hide');
                            }

                            element.parents('form').validate().settings.rules = validator.getRules(element.parents('form'));
                        }
                    } else {
                        // Match-Feld zurücksetzen
                        element.val(selectedValue).trigger('change');
                        validator.triggerValidation(element[0], true, true);
                    }
                });
            } else {
                // Formatangaben neu setzen
                if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'date_panel' || controlType === 'date_range') {
                    var containerElement = $(element.parents('.tt-content').find('tr[data-name="format_fields' + nameAppendix + '"]').find('td')[1]).children();

                    var data = [];
                    if (!utils.isIDATField(newValue)) {
                        data.push({id: 'unknown', text: Lang.get('tripletrax.unknown_value')});
                        data.push({id: 'not_collected', text: Lang.get('tripletrax.not_collected_value')});
                    }
                    if (controlType === 'date_panel' || controlType === 'date_range') {
                        if (!utils.isIDATField(newValue)) {
                            data.push({id: 'continuing', text: Lang.get('tripletrax.continuing_value')});
                        }
                        data.push({id: 'full', text: Lang.get('tripletrax.full')});
                        data.push({id: 'mm/yy', text: Lang.get('tripletrax.mm/yy')});
                        data.push({id: 'yy', text: Lang.get('tripletrax.yy')});
                    } else {
                        if (!utils.isIDATField(newValue)) {
                            data.push({id: 'not_measurable', text: Lang.get('tripletrax.not_measurable_value')});
                        }
                    }

                    validator.reinitializeSelect2($(containerElement), 'tt-select2 tt-select2-data-view-property select2-container', '', data, true);
                }
                element.parents('form').find('[name="format_fields' + nameAppendix + '"]').val(formatFieldsValue).trigger('change.select2');

                // Datenbankangaben und Berechnung aus- bzw. einblenden
                if ((utils.isIDATField(newValue) && !utils.isIDATField(selectedValue))
                    || (!utils.isIDATField(newValue) && utils.isIDATField(selectedValue))
                    || (utils.isMatchFieldInDatabase(newValue) && !utils.isMatchFieldInDatabase(selectedValue))
                    || (!utils.isMatchFieldInDatabase(newValue) && utils.isMatchFieldInDatabase(selectedValue))) {

                    if (utils.isIDATField(newValue) || utils.isMatchFieldInDatabase(newValue)) {
                        // Datenbankangaben
                        element.parents('form').find('[data-tt-id^="database_"]').addClass('hide');
                        element.parents('form').find('[data-name="table"]').addClass('hide');
                        element.parents('form').find('[name="table"]').val('');
                        element.parents('form').find('[data-name="table_type"]').addClass('hide');
                        element.parents('form').find('[name="table_type"]').val(null).trigger('change.select2');
                        element.parents('form').find('[data-name="column' + nameAppendix + '"]').addClass('hide');
                        element.parents('form').find('[name="column' + nameAppendix + '"]').val('');
                        element.parents('form').find('[data-name="column_type' + nameAppendix + '"]').addClass('hide');
                        element.parents('form').find('[name="column_type' + nameAppendix + '"]').val(null).trigger('change.select2');
                        element.parents('form').find('[data-name="column_length' + nameAppendix + '"]').addClass('hide');
                        element.parents('form').find('[name="column_length' + nameAppendix + '"]').val('');
                        // Berechnung
                        element.parents('form').find('[data-name="calculation' + nameAppendix + '"]').addClass('hide');
                        element.parents('form').find('[name="calculation' + nameAppendix + '"]').val(null).trigger('change.select2');
                    } else {
                        // Datenbankangaben
                        element.parents('form').find('[data-tt-id^="database_"]').removeClass('hide');
                        element.parents('form').find('[data-name="table"]').removeClass('hide');
                        element.parents('form').find('[data-name="table_type"]').removeClass('hide');
                        element.parents('form').find('[data-name="column' + nameAppendix + '"]').removeClass('hide');
                        element.parents('form').find('[data-name="column_type' + nameAppendix + '"]').removeClass('hide');
                        element.parents('form').find('[data-name="column_length' + nameAppendix + '"]').removeClass('hide');
                        element.parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));
                        validator.triggerValidation(element.parents('form').find('[name="table"]')[0], true, true);
                        validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
                        validator.triggerValidation(element.parents('form').find('[name="column' + nameAppendix + '"]')[0], true, true);
                        validator.triggerValidation(element.parents('form').find('[name="column_type' + nameAppendix + '"]')[0], true, true);
                        validator.triggerValidation(element.parents('form').find('[name="column_length' + nameAppendix + '"]')[0], true, true);
                        // Berechnung
                        element.parents('form').find('[data-name="calculation' + nameAppendix + '"]').removeClass('hide');
                    }

                    element.parents('form').validate().settings.rules = validator.getRules(element.parents('form'));
                }
            }
        }
    });

    // Nestable Lists - Bei Herauslöschen des Entspricht-Feldes Formatangaben neu setzen bzw. Datenbankangaben wieder einblenden
    $('body').on('change', '[name="match"],[name="match_additionalfield_1"],[name="match_additionalfield_2"]', function (e) {

        // Format-Angaben bei Input und DatePanel neu setzen bzw. Datenbankangaben und Berechnungen wieder einblenden (nur wenn der Wert herausgelöscht wurde)
        var element = $(this);
        var selectedValue = element.select2('val');
        var nameAppendix = element[0].name.replace('match', '');
        var controlType = element.parents('form').find('[name="control_type' + nameAppendix + '"]').val();
        var formatFieldsValue = (!utils.isUndefined(element.parents('form').find('[name="format_fields' + nameAppendix + '"]').select2('val')) && element.parents('form').find('[name="format_fields' + nameAppendix + '"]').select2('val').length > 0) ? element.parents('form').find('[name="format_fields' + nameAppendix + '"]').select2('val') : [];

        if (selectedValue === '' || !utils.isIDATField(selectedValue)) {

            // Format-Angaben bei Input und DatePanel neu setzen
            if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'date_panel' || controlType === 'date_range') {

                var containerElement = $(element.parents('.tt-content').find('tr[data-name="format_fields' + nameAppendix + '"]').find('td')[1]).children();

                var data = [];
                if (!utils.isIDATField(selectedValue)) {
                    data.push({id: 'unknown', text: Lang.get('tripletrax.unknown_value')});
                    data.push({id: 'not_collected', text: Lang.get('tripletrax.not_collected_value')});
                }
                if (controlType === 'date_panel' || controlType === 'date_range') {
                    if (!utils.isIDATField(selectedValue)) {
                        data.push({id: 'continuing', text: Lang.get('tripletrax.continuing_value')});
                    }
                    data.push({id: 'full', text: Lang.get('tripletrax.full')});
                    data.push({id: 'mm/yy', text: Lang.get('tripletrax.mm/yy')});
                    data.push({id: 'yy', text: Lang.get('tripletrax.yy')});
                } else {
                    if (!utils.isIDATField(selectedValue)) {
                        data.push({id: 'not_measurable', text: Lang.get('tripletrax.not_measurable_value')});
                    }
                }

                validator.reinitializeSelect2($(containerElement), 'tt-select2 tt-select2-data-view-property select2-container', '', data, true);
            }

            // Datenbankangaben wieder einblenden
            element.parents('form').find('[data-tt-id^="database_"]').removeClass('hide');
            element.parents('form').find('[data-name="table"]').removeClass('hide');
            element.parents('form').find('[data-name="table_type"]').removeClass('hide');
            element.parents('form').find('[data-name="column' + nameAppendix + '"]').removeClass('hide');
            element.parents('form').find('[data-name="column_type' + nameAppendix + '"]').removeClass('hide');
            element.parents('form').find('[data-name="column_length' + nameAppendix + '"]').removeClass('hide');
            element.parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));
            validator.triggerValidation(element.parents('form').find('[name="table"]')[0], true, true);
            validator.triggerValidation(element.parents('form').find('[name="table_type"]')[0], true, true);
            validator.triggerValidation(element.parents('form').find('[name="column' + nameAppendix + '"]')[0], true, true);
            validator.triggerValidation(element.parents('form').find('[name="column_type' + nameAppendix + '"]')[0], true, true);
            validator.triggerValidation(element.parents('form').find('[name="column_length' + nameAppendix + '"]')[0], true, true);

            // Berechnung wieder einblenden
            element.parents('form').find('[data-name="calculation' + nameAppendix + '"]').removeClass('hide');
        }

        element.parents('form').find('[name="format_fields' + nameAppendix + '"]').val(formatFieldsValue).trigger('change.select2');
    });

    // Nestable Lists - Bei Löschen der Formatangaben Prüfung auf bestehende Daten
    $('body').on('select2:unselecting', '[name="format_fields"], [name="format_fields_additionalfield_1"],[name="format_fields_additionalfield_2"]', function (e) {

        // Bestehen bereits Daten, können keine Formatangaben gelöscht werden
        var element = $(this);
        var selectedValue = element.select2('val');
        var nameAppendix = element[0].name.replace('format_fields', '');

        var tableName = element.parents('form').find('[name="table"]').val();
        if (utils.isUndefined(tableName) || tableName === '' || !element.parents('form').find('[name="data_view_id"]').length || element.parents('form').find('[name="data_view_id"]').val() === '0') {
            return;
        }

        var columnName = '';
        if (element.parents('form').find('[name="column' + nameAppendix + '"]').length && element.parents('form').find('[name="column' + nameAppendix + '"]').prop("defaultValue") !== '') {
            columnName = element.parents('form').find('[name="column' + nameAppendix + '"]').prop("defaultValue") + '_format';
        }

        ajax.ajaxCall("admin/dataview/check/table/" + tableName + "/column/" + columnName + "/value/" + e.params.args.data.id, "GET", null, false, function(data) {

            if (data === 'existing') {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_format_fields_title'),
                    content: Lang.get('tripletrax.delete_format_fields_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                    // Formatangaben zurücksetzen
                    element.val(selectedValue).trigger('change.select2');
                    validator.triggerValidation(element[0], true, true);
                });
            }
        });
    });

    // Nestable Lists Dialog - Switch für alle anderen Ausprägungen auf OFF setzen - data value in dd3-content setzen
    $('body').on('change', '[type=checkbox].onoffswitch-checkbox', function (e) {

        if ($(this)[0].checked) {
            var currentName = $(this).prop('name');
            var currentValue = $(this).val();
            jQuery.each($(this).parents('.dd-list,.tt-datatable-detail').find('.onoffswitch-checkbox'), function (i, val) {
                if ($(val).prop('name') !== currentName || $(val).val() !== currentValue) {
                    $(val).removeAttr('checked');
                    $(val).parents('.tt-switch-nestable').removeClass('tt-switch-on').addClass('tt-button-nestable').addClass('hide');
                    if ($(val).parents('#table_data_views_control_type_dialog').length) {
                        $(val).parents('.dd3-content').data('activationAdditionalfield', 'off');
                    } else {
                        $(val).parents('.dd3-content').data('activation-additionalfield', 'off');
                    }
                }
            });
            $(this).parents('.tt-switch-nestable').removeClass('tt-button-nestable').addClass('tt-switch-on');
            if ($(this).parents('#table_data_views_control_type_dialog').length) {
                $(this).parents('.dd3-content').data('activationAdditionalfield', 'on');
            } else {
                $(this).parents('.dd3-content').data('activation-additionalfield', 'on');
            }
            if ($(this).parents('form').find('[name="default_language"]').length) {
                $(this).parents('form').find('[name="default_language"]').val($(this).val());
                $(this).parents('form').trigger('checkform.areYouSure');
            }
        } else {
            $(this).parents('.tt-switch-nestable').addClass('tt-button-nestable').removeClass('tt-switch-on');
            if ($(this).parents('#table_data_views_control_type_dialog').length) {
                $(this).parents('.dd3-content').data('activationAdditionalfield', 'off');
            } else {
                $(this).parents('.dd3-content').data('activation-additionalfield', 'off');
            }
            if ($(this).parents('form').find('[name="default_language"]').length) {
                $(this).parents('form').find('[name="default_language"]').val('');
                $(this).parents('form').trigger('checkform.areYouSure');
            }
        }
    });

    // Einstellungen - Speichern der ausgewählten Sprachen / Formatangaben bei Datum
    $('body').on('change', '[type=checkbox].tt-row-selector', function (e) {

        if ($(this)[0].checked) {

            // Alle anderen wieder abhaken - es darf nur ein Eintrag angehakt sein
            if  ($(this).parents('.tt-datatable-detail')[0].id === 'table_settings_date_formatting') {
                jQuery.each($(this).parents('.tt-datatable-detail').dataTable().fnGetNodes(), function (i, tr) {
                    $(tr).removeClass('tt-row-selected');
                    jQuery.each($(tr).find('.checkbox'), function (i, val) {
                        val.children[0].checked = false;
                    });
                });
            }

            $(this)[0].checked = true;
            $(this).parents('tr').addClass('tt-row-selected');
            $(this).parents('tr').find('.tt-switch-nestable').removeClass('hide');
        } else {
			if ($(this).parents('.tt-datatable-detail')[0].id === 'table_settings_languages') {
				if ($(this).parents('tr').find('.tt-switch-nestable').hasClass('tt-switch-on')) {
					if ($(this).parents('form').find('[name="default_language"]').length) {
						$(this).parents('form').find('[name="default_language"]').val('');
					}
				}
			}

            $(this).parents('tr').removeClass('tt-row-selected');
            $(this).parents('tr').find('.tt-switch-nestable').addClass('hide').addClass('tt-button-nestable').removeClass('tt-switch-on');
            $(this).parents('tr').find('.dd3-content').data('activation-additionalfield', 'off');

            $(this).parents('tr').find('.tt-switch-nestable').find('input').removeAttr('checked');
        }

        if ($(this).parents('.tt-datatable-detail')[0].id === 'table_settings_languages') {
            var selectedLanguages = '';
            jQuery.each($(this).parents('.tt-datatable-detail').find('.tt-row-selected'), function (i, val) {
                if (selectedLanguages !== '') {
                    selectedLanguages += '|';
                }
                selectedLanguages += $(val).find('.tt-row-selector').val();
            });
            $(this).parents('form').find('[name="selected_languages"]').val(selectedLanguages);
        } else if  ($(this).parents('.tt-datatable-detail')[0].id === 'table_settings_date_formatting') {
            var selectedDateFormatting = '';
            if ($(this).parents('.tt-datatable-detail').find('.tt-row-selected').length) {
                selectedDateFormatting = $(this).parents('.tt-datatable-detail').find('.tt-row-selected').find('.tt-row-selector').val();
            }
            $(this).parents('form').find('[name="selected_date_format"]').val(selectedDateFormatting);
        }

        $(this).parents('form').trigger('checkform.areYouSure');
    });

    // Nestable Lists Dialog - Ausgewähltes Element anzeigen
    $('body').on('click', '.dd3-content:not(.tt-monitoring-dd3-content,.tt-monitoring-dd3-content-inactive)', function (e) {
        $(this).parents('.dd-list').find('.tt-button-nestable').addClass('hide');
        $(this).parents('.dd-list').find('.dd3-content').removeClass('dd-content-active');

        $(this).find('.tt-button-nestable').removeClass('hide');
        $(this).addClass('dd-content-active');

        $(this).parents('.modal-content').find('.widget-dialog-title').addClass('hide');
        $(this).parents('.modal-content').find('.widget-dialog-content').removeClass('hide');

        $(this).parents('.modal-content').find('.tt-save-value-nestable').removeClass('disabled');
        $(this).parents('.modal-content').find('.tt-delete-value-nestable').removeClass('disabled');

        var data = $(this).data();
        $(this).parents('.modal-content').find('[name="selected_id"]').val(data.id);
        $(this).parents('.modal-content').find('[name="control_type_value"]').val(data.value);
        $(this).parents('.modal-content').find('[name="value_in_database"]').val(data.valueInDatabase);
        $(this).parents('.modal-content').find('[name="control_type_value_match"]').val(data.match);
        $(this).parents('.modal-content').find('[name="score_value"]').val(data.scoreValue);
		$(this).parents('.modal-content').find('[name="aggregation_value"]').val(data.aggregationValue);
        $(this).parents('.modal-content').find('[name="cave_text"]').val(data.caveText);
        if (data.caveTextFormatting.length) {
            $(this).parents('.modal-content').find('[name="cave_text_formatting"]').val(data.caveTextFormatting.split('|'));
        }
        $(this).parents('.modal-content').find('[name="cave_text_color"]').val(data.caveTextColor);
        $(this).parents('.modal-content').find('[name="cave_text_color"]').parent().colorpicker('setValue', data.caveTextColor);
        if (data.inactive) {
            $(this).parents('.modal-content').find('[name="control_type_value_inactive"]').prop('checked', 'checked');
        } else {
            $(this).parents('.modal-content').find('[name="control_type_value_inactive"]').removeAttr('checked');
        }
        $(this).parents('.modal-content').find('form').removeClass('dirty');
        $(this).parents('.modal-content').find('form').trigger('reinitialize.areYouSure');
    });

    // Nestable Lists Dialog - Speichern Button
    $('body').on('click', '.tt-save-value-nestable,.tt-save-value-modal', function (e) {
        e.preventDefault();

        var element = $(this);
        var formDialog = element.parents('.modal-content').find('form');

        checkDoSubmit(formDialog[0]).done(function (doSubmit) {

            if (doSubmit === 'false') {
                return;
            }

            // Timer eingebaut, da bei geöffnetem Kalender (Datepicker - Timer von 100ms) der Submit hängen geblieben ist
            setTimeout(function() {
                formDialog.submit();
            }, 110);
        });
    });

    // Nestable Lists Dialog - Abbrechen Button
    $('body').on('click', '.tt-cancel-value-nestable,.tt-cancel-value-modal', function (e) {
        e.preventDefault();

        $(this).parents('.modal-content').find('.dd-list').find('.tt-button-nestable').addClass('hide');
        $(this).parents('.modal-content').find('.dd-list').find('.dd3-content').removeClass('dd-content-active');

        $(this).parents('.modal-content').find('.tt-save-value-nestable').addClass('disabled');
        $(this).parents('.modal-content').find('.tt-delete-value-nestable').addClass('disabled');

        $(this).parents('.modal-content').find('.tt-delete').addClass('disabled');

        $(this).parents('.modal-content').find('.widget-dialog-title').removeClass('hide');
        $(this).parents('.modal-content').find('.widget-dialog-content').addClass('hide');

        $(this).parents('.modal-content').find('.tt-datatable-dialog').dataTable().$('tr.selected-row').removeClass('selected-row');

        $(this).parents('.modal-content').find('form').validate().resetForm();
        $(this).parents('.modal-content').find('form').find('input[type="hidden"]:not([data-no-reset="no-reset-value"])').val("");
        $(this).parents('.modal-content').find('form').find('.tt-select2').val(null).trigger('change.select2');
        $(this).parents('.modal-content').find('form').find('[type="checkbox"]').removeAttr('checked');
        $(this).parents('.modal-content').find('form').trigger('reinitialize.areYouSure');
    });

    // Nestable Lists Dialog - Löschen Button
    $('body').on('click', '.tt-delete-value-nestable:not(.tt-delete-monitoring-nestable)', function (e) {
        e.preventDefault();

        var element = $(this);
        var id = element.parents('.modal-content').find('[name="selected_id"]').val();
        var contentElement = element.parents('.modal-content').find('[data-id="' + id + '"]');

        var title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_data_view_control_type_value', { "value": "<span class='txt-color-orangeDark'><strong>" + contentElement.data().value + "</strong></span>" });
        var content = Lang.get('tripletrax.delete_data_view_control_type_value_desc');

        $.SmartMessageBox({
            title: title,
            content: content,
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === Lang.get('tripletrax.yes')) {

                contentElement.data('is-deleted', true);
                contentElement.parents('.dd-item').addClass('hide');

                element.parents('.modal-content').find('.dd-list').find('.tt-button-nestable').addClass('hide');
                element.parents('.modal-content').find('.dd-list').find('.dd3-content').removeClass('dd-content-active');

                element.parents('.modal-content').find('.tt-save-value-nestable').addClass('disabled');
                element.parents('.modal-content').find('.tt-delete-value-nestable').addClass('disabled');

                element.parents('.modal-content').find('.widget-dialog-title').removeClass('hide');
                element.parents('.modal-content').find('.widget-dialog-content').addClass('hide');

                element.parents('.modal-content').find('form').validate().resetForm();
                element.parents('.modal-content').find('form').trigger('reinitialize.areYouSure');
            }
        });
    });

    // Nestable Lists Dialog - Bereits angelegte Werte dem Dialog zur Neuanlage einer Ausprägung mitgeben
    $('body').on('click', '.tt-add-value-nestable', function (e) {

        var dialogId = $(this).attr('href');
        var listValues = '';
        var listValuesInDatabase = '';
        var listAggregationValues = '';
        jQuery.each($(this).parents('.modal-content').find('.dd').nestable('serializeContent'), function (i, val) {

            if (!val.isDeleted) {
                if (listValues !== '') {
                    listValues += '|';
                }
                listValues += val.value;

                if (listValuesInDatabase !== '') {
                    listValuesInDatabase += '|';
                }
                listValuesInDatabase += val.valueInDatabase;

				if (listAggregationValues !== '') {
					listAggregationValues += '|';
				}
				listAggregationValues += val.aggregationValue;
            }
        });

        $(dialogId).find('[name="list_values"]').val(listValues);
        $(dialogId).find('[name="list_values_in_database"]').val(listValuesInDatabase);
		$(dialogId).find('[name="list_aggregation_values"]').val(listAggregationValues);
    });

    // Nestable Lists - Hilfe Button
    $('body').on('click', '.tt-help-properties', function (e) {
        e.preventDefault();
    });

    // Vorschau mit F9
    $('body').on('keydown', function (e) {
        // F9
        if (e.which == 120) {
            e.preventDefault();

            if ($('body').find('.tt-preview').length > 0) {
                $('body').find('.tt-preview').click();
            }
        }
    });

    // Vorschau Klick
    $('body').on('click', '.tt-preview', function (e) {
        var parent_view_id = $('#table_data_views_detail_form').find('[data-name="parent_view_id"]').val();

        // Modalen Dialog neu erstellen, wenn dieser noch nicht vorhanden ist (wird beim ersten Klick auf den Button neu erstellt)
        setModalDialog($(this), 'preview_dialog', 'content-detail-modal-preview').done(function (dialogCreated) {

            if (dialogCreated) {
                $('#content-detail-modal-preview').find('.tt-preview-dialog').append('<iframe class="tt-iframe-preview" src="admin/dataview/preview/' + parent_view_id + '"></iframe>');
                $('[href="#preview_dialog"]').click();
            }
        });
    });

    // Umrechnungsfaktor bzw. Umrechnungsformel zurücksetzen
    $('body').on('change', '.tt-conversion-element', function (e) {
		e.preventDefault();

		if ($(this)[0].name == 'conversion_factor') {
			$(this).parents('.row').find('[name="conversion_formula"]').val(null).trigger('change.select2');
        } else {
			$(this).parents('.row').find('[name="conversion_factor"]').val('');
        }
	});

    // Plugins initialisieren bei Vorschau
    $('.tt-iframe-preview').ready(function () {
        initialize.initializeElements($(this).contents(), true, false);
    });
}

function registerDocumentationEvents() {

    // Linke Navigation - Länge anpassen
    $('body').on('classAdded', '.tab-pane', function (e) {
        e.preventDefault();
        changes.calculateLeftNavHeight();
    });

    // Dokumentation - Einrichtung wechseln
    $('body').on('click', '.facility-dropdown-element', function (e) {
        e.preventDefault();

        var element = $(this);

        $('#left-panel').find('nav').find('a').addClass('disabled');
        ajax.ajaxCall($(this).attr('href'), 'GET', null, false, function () {

            $('#left-panel').find('nav').find('li').removeClass('active');
            element.parents('ul').find('li').removeClass('active');
            element.parent().addClass('active');

            element.parents('.header-dropdown-list').find('.facility-dropdown').find('span').text(element.text());
            $('#left-panel').find('nav').find('a').removeClass('disabled');

            $('#start_nav').click();
            $('.tt-load-notifications').click();
        });
    });

    // Dokumentation - Dokument ansehen
    $('body').on('click', '.document-show-dropdown-element', function (e) {
        e.preventDefault();

        window.open($(this).attr('href'), '_blank');
    });

    // Dokumentation - Dokument drucken
    $('body').on('click', '.document-print-dropdown-element', function (e) {
        e.preventDefault();

        var print_document = window.open($(this).attr('href'), '_blank');
            print_document.print();
    });

    // Dokumentation - Neue Einwilligung hinzufügen
    $('body').on('click', '.tt-dialog-agreement-open', function (e) {

        $('#table_patient_agreement_create_form').find('[name="agreement"]').removeAttr('disabled');
        $('#table_patient_agreement_create_form').find('[name="begin_date"]').removeAttr('disabled');
        $('#table_patient_agreement_create_form').find('[name="end_date"]').removeAttr('disabled');
        $('#table_patient_agreement_create_form').find('[name="pat_id"]').removeAttr('disabled');

        if ($('#table_patient_agreement_create_form').find('.tt-selected-id').val() === '') {

            // Bei Neuanlage kann nur ja oder nein gewählt werden
            $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').prop('disabled', 'disabled');
            $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').parent().addClass('tt-label-disabled');
            $('#table_patient_agreement_create_form').find('[name="agreement"][value="3"]').prop('disabled', 'disabled');
            $('#table_patient_agreement_create_form').find('[name="agreement"][value="3"]').parent().addClass('tt-label-disabled');
            $('#table_patient_agreement_create_form').find('[name="agreement"][value="0"]').parent().removeClass('tt-label-disabled');
            $('#table_patient_agreement_create_form').find('[name="agreement"][value="1"]').parent().removeClass('tt-label-disabled');

            $('#table_patient_agreement_create_form').validate().settings.rules = validator.getRules($('#table_patient_agreement_create_form'));

        } else {

            // kein Recht zum Ändern der Einschreibung
            if (!utils.isUndefined($('#table_patient_agreement_create_form').find('.tt-select2').select2('data'))) {

                var dependingModels = $('#table_patient_agreement_create_form').find('.tt-select2').select2('data')[0].depending_models;
                if (dependingModels === '') {
                    dependingModels = '-1';
                }

                ajax.ajaxCallDeferred("doc/patient/patient/agreement/facility/" + views.getFacilityId() + "/patient/" + views.getPatientId() + "/depmodel/" + dependingModels, 'GET', null, false).done(function (data) {

                    // Bei bestehender Teilnahme überprüfen, ob abhängige Teilnahmen existieren
                    // -> wenn NEIN, dann darf an der Teilnahme nichts mehr geändert werden
                    var dependingAgreementExisting = false;
                    if (data === 'existing') {
                        dependingAgreementExisting = true;
                    }

                    if (dependingAgreementExisting && $('#table_patient_agreement_create_form').find('[name="end_date"]').data('picker').getDate() === null && $('#table_patient_agreement_create_form').find('[name="agreement"]:checked').val() === '0') {
                        // Ja -> Nein und erneuerungspflichtig kann nicht gewählt werden
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="1"]').prop('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="1"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').prop('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="0"]').parent().removeClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="3"]').parent().removeClass('tt-label-disabled');
                    } else if (dependingAgreementExisting && $('#table_patient_agreement_create_form').find('[name="end_date"]').data('picker').getDate() === null && $('#table_patient_agreement_create_form').find('[name="agreement"]:checked').val() === '2') {
                        // Erneuerungspflichtig -> Nein kann nicht gewählt werden
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="1"]').prop('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="1"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="0"]').parent().removeClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').parent().removeClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="3"]').parent().removeClass('tt-label-disabled');
                    } else if (dependingAgreementExisting && $('#table_patient_agreement_create_form').find('[name="end_date"]').data('picker').getDate() === null && $('#table_patient_agreement_create_form').find('[name="agreement"]:checked').val() === '1') {
                        // Nein -> Nur ja kann gewählt werden
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').prop('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="3"]').prop('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="3"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="0"]').parent().removeClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="1"]').parent().removeClass('tt-label-disabled');
                    } else {
                        // Widerrufen bzw. Enddatum ist angegeben -> Nichts mehr wählbar
                        $('#table_patient_agreement_create_form').find('[name="agreement"]').prop('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="0"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="1"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="2"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="agreement"][value="3"]').parent().addClass('tt-label-disabled');
                        $('#table_patient_agreement_create_form').find('[name="begin_date"]').attr('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="end_date"]').attr('disabled', 'disabled');
                        $('#table_patient_agreement_create_form').find('[name="pat_id"]').attr('disabled', 'disabled');
                    }

                    $('#table_patient_agreement_create_form').validate().settings.rules = validator.getRules($('#table_patient_agreement_create_form'));
                });
            }
        }
    });

    // Dokumentation - Bei Neuanlage Einwilligung -> Einwilligungsoptionen aktiv/inaktiv setzen
    $('body').on('change', '[name=agreement]', function (e) {
        e.preventDefault();

        $(this).parents('form').validate().settings.rules = validator.getRules($(this).parents('form'));
    });

    // Dokumentation - Datenerhebungsmodell wechseln
    $('body').on('change', '.tt-data-collection-type', function (e) {
        e.preventDefault();

		if (!utils.GLOBALS.programmaticClick) {
			var element = $(this);
			var currentValue = $(this).select2('val');

		    if (element.hasClass('tt-data-collection-type-additional')) {
                $('.tt-data-collection-type:not(.tt-data-collection-type-additional)').val(currentValue).trigger('change');
            } else {
				changeDataCollectionType(element, currentValue);
            }
		}
    });

    $('body').on('select2:selecting', '.tt-data-collection-type', function (e) {
        var currentValue = e.params.args.data.id;
        var element = $(this);
        changes.saveChanges(e).done(function(notCanceled) {
            if (!notCanceled) {
                e.preventDefault();
            } else {
                element.select2('close');
				// if (element.hasClass('tt-data-collection-type-additional')) {
				// 	$('.tt-data-collection-type:not(.tt-data-collection-type-additional)').val(currentValue).trigger('change.select2');
				// } else {
				// 	changeDataCollectionType(element, currentValue);
				// }
            }
        });
    });

    // Dokumentation - Bei Neuanlage eines Patienten die Pflichtfelder abhängig der ausgewählten Datenerhebungsart setzen
    $('body').on('change', '[name="patient_data_collection_model"]', function (e) {
        e.preventDefault();

        var element = $(this);
        var id = '0';
        if (!utils.isUndefined($(element).select2('data'))) {
            id = $(element).select2('data')[0].id;
        }

        $(element).parents('form').find('.tt-match-fields').find('[name]').removeClass('tt-mandatory_field');

        ajax.ajaxCallDeferred("doc/patient/patientlist/mandatory/" + id, "GET", null, false).done(function(data) {

            if (ajax.ajaxSucceeded(data)) {
                if (data.length > 0) {
                    jQuery.each(data, function (i, name) {
                        $(element).parents('form').find('.tt-match-fields').find('[name="' + name + '"]').addClass('tt-mandatory_field');
                    });
                }
                $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));

                jQuery.each($(element).parents('form').find('.tt-match-fields').find('[name]'), function (i, val) {
                    $(element).parents('form').validate().element($(val));
                });
            }
        });
    });

    // Untersuchung auswählen
    $('body').on('click', '.tt-select-examination-dropdown a', function (e) {
        e.preventDefault();

        changes.setSelectedExamination(true, $(this).parent().data().examinationId);
    });

    // Untersuchung davor auswählen
    $('body').on('click', '.tt-previous-examination', function (e) {
        e.preventDefault();

        $(this).attr('disabled', 'disabled');
        changes.setSelectedExamination(true, $(this).parent().find('li.active').next().data().examinationId);
    });

    // Untersuchung danach auswählen
    $('body').on('click', '.tt-next-examination', function (e) {
        e.preventDefault();

        $(this).attr('disabled', 'disabled');
        changes.setSelectedExamination(true, $(this).parent().find('li.active').prev().data().examinationId);
    });

    // Untersuchung anlegen
    $('body').on('click', '.tt-create-examination', function (e) {
        e.preventDefault();

		if ($('[name="limit_examination_list_completeness_selections"]').is(':checked')) {
			$('[name="limit_examination_list_completeness_selections"]').click();
		}

        // Hat der Patient eine ablaufende Einwilligung gegeben und besteht bereits eine neue Einwilligung,
        // so sollte eine Meldung erscheinen, dass eine neue Einwilligung gegeben werden muss
        patients.checkEndingAgreements(views.getPatientId()).done(function(addNewAgreement) {

            if (addNewAgreement) {
                return;
            }

            var showRenewCallback = false;
            jQuery.each($('#table_patient_agreement').dataTable().fnGetData(), function (i, val) {
                var dataCollectionTypes = val.data_collection_types.split('|');
                jQuery.each(dataCollectionTypes, function (i, dataCollectionType) {
                    if (dataCollectionType === views.getModelId() && val.converted_agreement === trans('tripletrax.agreement_remake') && val.end_date === null) {
                        showRenewCallback = true;
                        return false;
                    }
                });
            });

            if (showRenewCallback) {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i><span class='txt-color-orangeDark'><strong>" + Lang.get('tripletrax.add_examination') + "</strong></span>",
                    content: Lang.get('tripletrax.add_examination_with_agreement_renew'),
                    buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
                }, function (ButtonPressed) {
                    if (ButtonPressed === Lang.get('tripletrax.yes')) {
                        var helpText = '';
                        if (!utils.isUndefined($('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')) && $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data').length) {
                            helpText = $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')[0].helpExaminationdate;
                        }
                        $('#table_patient_examination_create_form').find('#help_examinationdate_format').text(helpText);

                        $('#table_patient_examination_create_dialog').modal('show');
                    }
                });
            } else {
                var helpText = '';
                if (!utils.isUndefined($('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')) && $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data').length) {
                    helpText = $('#content').find('.tt-data-collection-type.select2-hidden-accessible').select2('data')[0].helpExaminationdate;
                }
                $('#table_patient_examination_create_form').find('#help_examinationdate_format').text(helpText);

                $('#table_patient_examination_create_dialog').modal('show');
            }
        });
    });

    // Abbrechen Button
    $('body').on('click', '.tt-cancel-views', function (e) {
        e.preventDefault();

        changes.cancelViews(true, true);
    });

    // Speichern Button
    $('body').on('click', '.tt-save-views', function (e) {
        e.preventDefault();

        changes.saveViews(false).done(function() {
            jQuery.each(utils.getMaster().find('form'), function (i, form) {
                $(form).find('[calculate-other-examinations]').removeAttr('calculate-other-examinations');
                $(form).find('[check-completeness-all-patient]').removeAttr('check-completeness-all-patient');
                $(form).find('[check-completeness-all-examination]').removeAttr('check-completeness-all-examination');
                $(form).removeClass('dirty');
                $(form).trigger('reinitialize.areYouSure');
                jQuery.each($(form).find('.tt-history'), function (i, val) {
                    $(val)[0].dataset.content = '';
                });
            });
            jQuery.each(utils.getCourse().find('form'), function (i, form) {
                $(form).find('[calculate-other-examinations]').removeAttr('calculate-other-examinations');
                $(form).find('[check-completeness-all-patient]').removeAttr('check-completeness-all-patient');
                $(form).find('[check-completeness-all-examination]').removeAttr('check-completeness-all-examination');
                $(form).removeClass('dirty');
                $(form).trigger('reinitialize.areYouSure');
                jQuery.each($(form).find('.tt-history'), function (i, val) {
                    $(val)[0].dataset.content = '';
                });
            });
        });
    });

	// Dokumentation (Patientenliste) - Einschränkung der Tabelle auf Einwilligungen
	$('body').on('change', '.tt-agreement-restriction', function(e) {
		e.preventDefault();

		if (!utils.isUndefined($('#table_patientlist')[0].getAttribute('data-restriction-column'))) {
		    var searchString = '';
			var dataTable = $('#table_patientlist').dataTable();
			var restrictionColumn = parseInt($('#table_patientlist')[0].getAttribute('data-restriction-column'));

			var values = $(this).val();

			jQuery.each(values, function (i, value) {
			    if (searchString === '') {
					searchString += value;
                } else {
					searchString += '|' +value;
                }
			});

			dataTable.api({"search": {regex: true}}).column(restrictionColumn).search(searchString, true, false).draw();
		}
	});

    // Dokumentation - nicht weiterbehandelte Patienten in der Liste (nicht) anzeigen
    $('body').on('change', '[name="show_patients_active"],[name="show_patients_incomplete_master_data"],[name="show_patients_incomplete_course_data"],.tt-incomplete-course-data-year', function (e) {
        e.preventDefault();

        if ($(this)[0].name === "show_patients_incomplete_course_data") {
            if ($(this).is(':checked')) {
                $('.tt-incomplete-course-data-year').removeAttr('disabled');
                $('.tt-incomplete-course-data-year').val('past_year').trigger('change.select2');
                $('.tt-limit-examination-list').removeClass('hide');
                $('[name="limit_examination_list_completeness_selections"]').attr('checked', 'checked');
            } else {
                $('.tt-incomplete-course-data-year').attr('disabled', 'disabled');
                $('.tt-incomplete-course-data-year').val(null).trigger('change.select2');
				$('.tt-limit-examination-list').addClass('hide');
				$('[name="limit_examination_list_completeness_selections"]').removeAttr('checked');
            }
        }
        patients.loadPatientlist(false).done(function (patientData) {

            var list_data = patients.getPatientlist(patientData);
            $('#table_patientlist').dataTable().api().clear().rows.add(list_data).draw();

            changes.cancelViews(true, true);
        });
    });

    $('body').on('change', '[name="limit_examination_list_completeness_selections"]', function (e) {
		e.preventDefault();

		$('#table_patient_examination').dataTable().api().draw();
		validator.setExaminationSelectionList();
	});

    $('body').on('change', '[name="hide_patients_released"]', function (e) {
        e.preventDefault();

        $('#table_patientlist').dataTable().api().draw();
        var data = 'hide_patients_released=' + $('[name="hide_patients_released"]').is(':checked');
        ajax.ajaxCall("doc/patient/patientlist/update_user_settings", "POST", data, false, function (data) {});
    });

    // Dokumentation - Optionen ein- und ausblenden
    $('body').on('click', '#options', function (e) {
        e.preventDefault();

        $('.options').toggleClass('activate');
    });

    // Dokumentation - Patient löschen, bei sonstiger Grund Textfeld aktivieren
    $('body').on('change', '[name="delete_reason"]', function (e) {
        e.preventDefault();

        if ($(this).val() === 'other_reason') {
            $(this).parents('.row').find('[name="delete_reason_other"]').removeAttr('disabled');
        } else {
            $(this).parents('.row').find('[name="delete_reason_other"]').val('');
            $(this).parents('.row').find('[name="delete_reason_other"]').attr('disabled', 'disabled');
        }
    });

    // Untersuchung ändern
    $('body').on('click', '.tt-edit-examination', function (e) {
        e.preventDefault();

        var element = $(this);
        utils.GLOBALS.runningTableClickRequests.push(changes.tableSingleClick($(element.parents('tr')[0])).done(function() {
            utils.GLOBALS.runningTableClickRequests.length = 0;
            var aPos = element.parents('.tt-datatable,.tt-datatable-data').dataTable().fnGetPosition(element.parents('tr')[0]);
            var aData = element.parents('.tt-datatable,.tt-datatable-data').dataTable().fnGetData(aPos);
            changes.openChangeExaminationDialog(aData);
        }));
    });

    // Anzahl angezeigte Zeilen ändern
    $('body').on('click', '.tt-number-of-rows', function (e) {

        var table = $('#' + $(this).data().tableId).DataTable();
        $(this).parent().find('a').removeClass('margin-left-15').removeClass('tt-selected').removeClass('badge').addClass('padding-left-13');
        $(this).removeClass('padding-left-13').addClass('margin-left-15').addClass('tt-selected').addClass('badge');
        table.page.len(parseInt($(this).data().value)).draw();

        if ($(this).data().tableId === 'table_patientlist') {
            var patientId = $('.tt-nav-content-article').find('.tt-selected-id').val();
            if (patientId !== '') {
                table.page.jumpToData(parseInt(patientId), 0);
            }
        } else if ($(this).data().tableId === 'table_patient_examination') {
            var examinationId = $('.tt-nav-content-article').find('.tt-selected-examination-id').val();
            if (examinationId !== '') {
                table.page.jumpToData(parseInt(examinationId), 0);
            }
        }
    });

    // Startseite / Query - zum zuletzt bearbeiteten Patient springen
    $('body').on('click', '.tt-pseudonym,.tt-pseudonym-new', function (e) {
        e.preventDefault();
        e.stopPropagation();

        utils.updateGlobals('patientToShow', $(this).data().patientId);
        utils.updateGlobals('examinationToShow', $(this).data().examinationId);
        utils.updateGlobals('modelToShow', $(this).data().modelId);
        if ($(this).parent().hasClass('tt-notification')) {
            utils.updateGlobals('queryToShow', $(this).data().queryControlName);
            utils.updateGlobals('queryToShowTableType', $(this).data().queryTableType);
            utils.updateGlobals('queryToShowTableId', $(this).data().queryTableId);
            utils.updateGlobals('queryToShowTableName', $(this).data().queryTableName);
            $('#notifications').click();
        }

        if ($('#patient_nav').parent().hasClass('active')) {

            $('.tt-clear-search').click();

            $('#table_patientlist').DataTable().page.jumpToData(utils.GLOBALS.patientToShow, 0);
            if ($('#table_patientlist').find('tr[id="' + utils.GLOBALS.patientToShow + '"]').length) {

                if ($('#table_patientlist').find('tr[id="' + utils.GLOBALS.patientToShow + '"]').hasClass('selected-row')) {
                    if (!utils.isUndefined(utils.GLOBALS.examinationToShow) && utils.GLOBALS.examinationToShow !== '') {
                        $('#table_patient_examination').DataTable().page.jumpToData(utils.GLOBALS.examinationToShow, 0);

                        if ($('#table_patient_examination').find('tr[id="' + utils.GLOBALS.examinationToShow + '"]').hasClass('selected-row')) {
                            validator.goToControl(utils.GLOBALS.queryToShow, utils.GLOBALS.queryToShowTableType, utils.GLOBALS.queryToShowTableName);
                        } else {
                            $('#table_patient_examination').find('tr[id="' + utils.GLOBALS.examinationToShow + '"]').addClass('selected-row');
                            $('#table_patient_examination').find('tr[id="' + utils.GLOBALS.examinationToShow + '"]').find('td')[1].click();
                            $('#table_patient_examination').find('tr[id="' + utils.GLOBALS.examinationToShow + '"]').find('td')[1].click();

                            utils.updateGlobals('examinationToShow', null);
                        }
                    } else {
                        validator.goToControl(utils.GLOBALS.queryToShow, utils.GLOBALS.queryToShowTableType, utils.GLOBALS.queryToShowTableName);
                    }
                } else {
                    $('#table_patientlist').find('tr[id="' + utils.GLOBALS.patientToShow + '"]').find('td')[0].click();

                    // Wenn keine Untersuchung direkt ausgewählt werden soll, auf den ersten Tab der Stammdaten springen
                    if (utils.isUndefined(utils.GLOBALS.examinationToShow) || utils.GLOBALS.examinationToShow === '') {
                        $('#table_patientlist').find('tr[id="' + utils.GLOBALS.patientToShow + '"]').find('td')[0].click();
                    }
                }

                utils.updateGlobals('patientToShow', null);
            } else {
                utils.updateGlobals('showAllActivePatients', false);
                utils.updateGlobals('showAllIncompleteMasterPatients', false);
                utils.updateGlobals('showAllIncompleteCoursePatients', false);
				utils.updateGlobals('showAllIncompleteCourseYearPatients', '');
                $('#patient_nav').click();
            }
        }
        else {
            utils.updateGlobals('showAllActivePatients', false);
            utils.updateGlobals('showAllIncompleteMasterPatients', false);
            utils.updateGlobals('showAllIncompleteCoursePatients', false);
			utils.updateGlobals('showAllIncompleteCourseYearPatients', '');
            $('#patient_nav').click();
        }
    });

    // Startseite - Zur Liste der Patienten springen
    $('body').on('click', '.tt-dashboard-well', function (e) {

        utils.updateGlobals('showAllActivePatients', $(this).data().showAllActivePatients);
        utils.updateGlobals('showAllIncompleteMasterPatients', $(this).data().showAllIncompleteMasterPatients);
        utils.updateGlobals('showAllIncompleteCoursePatients', $(this).data().showAllIncompleteCoursePatients);
		utils.updateGlobals('showAllIncompleteCourseYearPatients', $(this).data().showAllIncompleteCourseYearPatients);
        utils.updateGlobals('searchString', $(this).data().searchString);

        $('#patient_nav').click();
    });

    // Zurück zur Vollständigkeitsliste springen
    $('body').on('click', '.tt-back-to-completeness-button', function (e) {
       e.preventDefault();

       $('[href="#content-detail-completeness"]').click();
    });
}

function setModalDialog(element, dialogId, contentId) {

    return $.Deferred(function (defer) {
        if (!$('#' + dialogId).length) {
            var url = element.data().buttonUrl;

            ajax.ajaxCallDeferred(url, 'GET', null, false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    utils.setHtmlData($('#' + contentId), data, true);
                    defer.resolve(true);
                } else {
                    defer.reject();
                }
            });
        } else {
            defer.resolve(false);
        }
    }).promise();
}

function checkForExistingData(element, table, id, aPos) {

    return $.Deferred(function (defer) {
        if (table[0].id === "table_facilities") {
            // Einrichtung darf nur gelöscht werden, wenn keine Teilnehmer zugeordnet sind und keine Untersuchungen existieren
            ajax.ajaxCallDeferred("admin/facility/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data === 'existingUsers') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_facility', {"facility": "<span class='txt-color-orangeDark'><strong>" + $("#facilityname").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_facility_not_possible_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else if (data === 'existingPatients') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_facility', {"facility": "<span class='txt-color-orangeDark'><strong>" + $("#facilityname").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_facility_not_possible_patient_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else if (data === 'existingExaminations') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_facility', {"facility": "<span class='txt-color-orangeDark'><strong>" + $("#facilityname").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_facility_not_possible_examination_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                } else {
                    defer.reject();
                }
            });
        } else if (table[0].id === "table_users") {
            // Teilnehmer darf nur gelöscht werden, wenn er noch keine Daten dokumentiert hat
            ajax.ajaxCallDeferred("admin/user/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data === 'existing') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_user', {"username": "<span class='txt-color-orangeDark'><strong>" + $("#username").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_user_not_possible_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                } else {
                    defer.reject();
                }
            });
        } else if (table[0].id === "table_roles") {
            // Rolle darf nur gelöscht werden, wenn keine Teilnehmer zugeordnet sind
            ajax.ajaxCallDeferred("admin/role/checkuser/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data === 'existing') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_role', {"role": "<span class='txt-color-orangeDark'><strong>" + $("#rolename").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_role_not_possible_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                } else {
                    defer.reject();
                }
            });
        } else if (table[0].id === "table_data_collection_types") {
            // Datenerhebungsmodell darf nur gelöscht werden, wenn keine Patienten daran teilnehmen bzw. teilgenommen haben und keine Untersuchungen existieren
            ajax.ajaxCallDeferred("admin/datacollectiontype/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data === 'existingPatients') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_datacollectiontype', {"datacollectiontype": "<span class='txt-color-orangeDark'><strong>" + $("#model").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_datacollectiontype_not_possible_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true, '');
                    } else if (data === 'existingExaminations') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_datacollectiontype', {"datacollectiontype": "<span class='txt-color-orangeDark'><strong>" + $("#model").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_datacollectiontype_not_possible_examination_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true, '');
                    } else if (data === 'existingRoles') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_datacollectiontype', {"datacollectiontype": "<span class='txt-color-orangeDark'><strong>" + $("#model").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_datacollectiontype_not_possible_role_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true, '');
                    } else if (data === 'existingAgreements') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_datacollectiontype', {"datacollectiontype": "<span class='txt-color-orangeDark'><strong>" + $("#model").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_datacollectiontype_not_possible_agreement_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true, '');
                    } else {
                        var dependingModels = '';
                        if (data !== 'notExisting') {
                            dependingModels = data;
                        }
                        defer.resolve(false, dependingModels);
                    }
                } else {
                    defer.reject();
                }
            });
        } else if (table[0].id === "dd_data_views") {
            var item = element.parents('.tt-content-datatable').find("[data-id='" + id + "']");
            var aData = item.find('.dd-handle')[0].textContent;
            aData = aData.substring(0, aData.indexOf("(") - 1);

            if (item.data().type === 'overview' || item.data().type === 'view') {
                // View darf nur gelöscht werden, wenn sie keinem Datenerhebungsmodell zugeordnet ist
                ajax.ajaxCallDeferred("admin/dataview/checkdatacollectiontype/" + item.data().viewId, "GET", id, false).done(function(data) {

                    if (ajax.ajaxSucceeded(data)) {
                        if (data === 'existing') {
                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_data_view_field_complete', {"field_name": "<span class='txt-color-orangeDark'><strong>" + aData + "</strong></span>"}),
                                content: Lang.get('tripletrax.delete_data_view_element_possible_desc'),
                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                            }, function (ButtonPressed) {
                            });
                            defer.resolve(true);
                        } else {
                            defer.resolve(false);
                        }
                    } else {
                        defer.reject();
                    }
                });
            } else if (item.data().type === "field") {
                // Datenfeld darf nur gelöscht werden, wenn keine Patientendaten dafür vorhanden sind bzw. es in keiner Abfrage vorkommt (wird nur geprüft, wenn das Feld endgültig gelöscht wird - aus momentan nicht verwendete Felder)
                if ($(item.parents('.dd-item')[0]).data().category === 'not_used_fields') {
                    ajax.ajaxCallDeferred("admin/dataview/checkdata/" + item.data().viewId, "GET", id, false).done(function (data) {

                        if (ajax.ajaxSucceeded(data)) {
                            if (data === 'existing') {
                                $.SmartMessageBox({
                                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_data_view_field_complete', {"field_name": "<span class='txt-color-orangeDark'><strong>" + aData + "</strong></span>"}),
                                    content: Lang.get('tripletrax.delete_data_view_field_possible_desc'),
                                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                }, function (ButtonPressed) {
                                });
                                defer.resolve(true);
                            } else {
                                ajax.ajaxCallDeferred("admin/dataview/checkmonitoring/" + item.data().viewId, "GET", id, false).done(function (data) {

                                    if (ajax.ajaxSucceeded(data)) {
                                        if (data === 'existing') {
                                            $.SmartMessageBox({
                                                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_data_view_field_complete', {"field_name": "<span class='txt-color-orangeDark'><strong>" + aData + "</strong></span>"}),
                                                content: Lang.get('tripletrax.delete_data_view_field_monitoring_possible_desc'),
                                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                                            }, function (ButtonPressed) {
                                            });
                                            defer.resolve(true);
                                        } else {
                                            defer.resolve(false);
                                        }
                                    } else {
                                        defer.reject();
                                    }
                                });
                            }
                        } else {
                            defer.reject();
                        }
                    });
                } else {
                    defer.resolve(false);
                }
            } else {
                defer.resolve(false);
            }
        } else if (table[0].id === "table_data_views_units") {
            // Standardeinheit darf nicht gelöscht werden
            if (table.dataTable().fnGetNodes().length > 1 && table.dataTable().fnGetNodes(aPos).children[0].children[0].children[0].checked) {
                $.SmartMessageBox({
                    title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_unit', {"unit": "<span class='txt-color-orangeDark'><strong>" + table.dataTable().fnGetData(aPos)[2] + "</strong></span>"}),
                    content: Lang.get('tripletrax.delete_unit_not_possible_desc'),
                    buttons: '[' + Lang.get('tripletrax.ok') + ']'
                }, function (ButtonPressed) {
                });
                defer.resolve(true);
                return;
            }

            // Einheiten dürfen nicht gelöscht werden, wenn Daten bereits bestehen
            var tableName = $('#content-detail').find('[name="table"]').val();

            if (tableName === '' || !$('#content-detail').find('[name="data_view_id"]').length || $('#content-detail').find('[name="data_view_id"]').val() === '0') {
                defer.resolve(false);
                return;
            }

            var nameAppendix = $('#table_data_views_units_dialog').find('[name="button_id"]').val().replace('button_edit_units', '');
            var columnName = '';
            if ($('#content-detail').find('[name="column' + nameAppendix + '"]').length && $('#content-detail').find('[name="column' + nameAppendix + '"]').prop("defaultValue") !== '') {
                columnName = $('#content-detail').find('[name="column' + nameAppendix + '"]').prop("defaultValue") + '_format';
            }

            ajax.ajaxCallDeferred("admin/dataview/check/table/" + tableName + "/column/" + columnName + "/value/" + table.dataTable().fnGetData(aPos)[2], "GET", null, false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data === 'existing') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_unit', {"unit": "<span class='txt-color-orangeDark'><strong>" + table.dataTable().fnGetData(aPos)[2] + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_unit_not_possible_existing_data_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                } else {
                    defer.reject();
                }
            });
        } else if (table[0].id === "table_patient_agreement") {
            var aData = table.dataTable().fnGetData(aPos);
            // Einwilligung darf nur gelöscht werden, falls keine Patientendaten dazu existieren (bzw. keine Daten zu einer abhängigen Datenerhebungsart)
            ajax.ajaxCallDeferred("doc/patient/patient/agreement/facility/" + views.getFacilityId() + "/patient/" + views.getPatientId() + "/model/" + aData.data_collection_types, "GET", null, false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data === 'existing') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_agreement', {"model": "<span class='txt-color-orangeDark'><strong>" + aData.description + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_agreement_possible_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else if (data !== '') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_agreement', {"model": "<span class='txt-color-orangeDark'><strong>" + aData.description + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_agreement_possible_depending_desc', {"depending_models": data}),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else {
                        // Datenerhebungsarten ermitteln, in welchen ich selbst als abhängige dokumentiert bin
                        var otherDependingModels = '';
                        $.each($.parseJSON($('#all_models').val()), function (j, dependingModel) {
                            if (dependingModel.depending_models === '' || dependingModel.depending_models === '-1') {
                                return true;
                            }

                            var dependingModels = dependingModel.depending_models.split('|');
                            $.each(dependingModels, function (j, depModel) {
                                if (depModel == aData.data_collection_types) {
                                    if (otherDependingModels !== '') {
                                        otherDependingModels += '|';
                                    }
                                    otherDependingModels += dependingModel.id;
                                }
                            });
                        });

                        if (otherDependingModels !== '') {
                            checkPatientAgreements($.parseJSON($('#models_with_delete_register_patient_right').val()), aData.data_collection_types, aData.description, otherDependingModels, null, true).done(function (doChange) {

                                defer.resolve(!doChange);
                            });
                        } else {
                            defer.resolve(false);
                        }
                    }
                } else {
                    defer.reject();
                }
            });
        } else if (table[0].id === "table_patient_examination") {
            // Untersuchung darf nur gelöscht werden, wenn alle Integritätsprüfungen (Abweichungen) korrekt sind.
            ajax.ajaxCallDeferred("doc/patient/patient/examination/" + views.getExaminationId() + "/model/" + views.getModelId() + "/patient/" + views.getPatientId() + "/checkdelete/" + views.getExaminationDate(), "GET", null, false).done(function(data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data.length > 0) {
                        if (data[0] === 'examination_has_other_facility_data') {

                            defer.resolve(false, Lang.get('tripletrax.' + data[0]));
                        } else {

                            var text = '';
                            for (var i = 0; i < data.length; i++) {
                                var dataText = data[i].split('$');
                                text += "<span class='txt-color-orangeDark'><strong>" + dataText[0] + ':</strong></span> ' + views.getIntegrityText(dataText[1].split('|'))[1].trim().substring(5) + '<br>';
                            }

                            $.SmartMessageBox({
                                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_exam', {"examination": "<span class='txt-color-orangeDark'><strong>" + utils.dateToLocaleTimeString(views.getExaminationDate()) + "</strong></span>"}),
                                content: Lang.get('tripletrax.delete_examination_possible_desc') + '<br><br>' + text,
                                buttons: '[' + Lang.get('tripletrax.ok') + ']'
                            }, function (ButtonPressed) {
                            });
                            defer.resolve(true, '');
                        }
                    } else {
                        defer.resolve(false, '');
                    }
                } else {
                    defer.reject();
                }
            });
        } else if (table[0].id === "table_devices") {
			// Gerät darf nur gelöscht werden, wenn es noch keine Daten dokumentiert hat
			ajax.ajaxCallDeferred("doc/devices/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function(data) {

				if (ajax.ajaxSucceeded(data)) {
					if (data === 'existing') {
						$.SmartMessageBox({
							title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_user', {"username": "<span class='txt-color-orangeDark'><strong>" + $("#username").val() + "</strong></span>"}),
							content: Lang.get('tripletrax.delete_device_not_possible_desc'),
							buttons: '[' + Lang.get('tripletrax.ok') + ']'
						}, function (ButtonPressed) {
						});
						defer.resolve(true);
					} else {
						defer.resolve(false);
					}
				} else {
					defer.reject();
				}
			});
        } else if (table[0].id === "table_agreement_types") {
            // Einwilligung darf nur gelöscht werden, wenn keine Patienten daran teilnehmen bzw. teilgenommen haben
            ajax.ajaxCallDeferred("admin/agreementtype/checkdata/" + $('#content-detail').find('.tt-selected-id').val(), "GET", $('#content-detail').find('.tt-selected-id').val(), false).done(function (data) {

                if (ajax.ajaxSucceeded(data)) {
                    if (data === 'existing') {
                        $.SmartMessageBox({
                            title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_agreement_type', {"agreement_type": "<span class='txt-color-orangeDark'><strong>" + $("#agreement_description").val() + "</strong></span>"}),
                            content: Lang.get('tripletrax.delete_agreement_type_not_possible_desc'),
                            buttons: '[' + Lang.get('tripletrax.ok') + ']'
                        }, function (ButtonPressed) {
                        });
                        defer.resolve(true);
                    } else {
                        defer.resolve(false);
                    }
                } else {
                    defer.reject();
                }
            });
		} else {
            defer.resolve(false, '');
        }
    }).promise();
}

function changeDataCollectionType(element, selectedValue) {

    var dataCollectionTypeControls = null;
	if (!utils.isUndefined(utils.getQuestionnaire())) {
		dataCollectionTypeControls = $.merge($.merge(utils.getMaster().find('.tt-data-collection-type'), utils.getCourse().find('.tt-data-collection-type')), utils.getQuestionnaire().find('.tt-data-collection-type'));
	} else {
		dataCollectionTypeControls = $.merge(utils.getMaster().find('.tt-data-collection-type'), utils.getCourse().find('.tt-data-collection-type'));
    }
    $.each(dataCollectionTypeControls, function (i, val) {
		utils.updateGlobals('programmaticClick', true);
        $(val).val(selectedValue).trigger('change.select2');
		utils.updateGlobals('programmaticClick', false);
    });

    validator.changeDataCollectionType(element).done(function () {
		var patientId = '';
        if ($('.tt-nav-content-article').find('.tt-selected-id').val() !== '') {
			patientId = $('.tt-nav-content-article').find('.tt-selected-id').val();
		}
		if ($('[name="show_patients_incomplete_master_data"]').is(':checked') || $('[name="show_patients_incomplete_course_data"]').is(':checked')) {

			$('#table_patientlist').dataTable().api().clear().draw();
			patients.loadPatientlist(true).done(function (patientData) {

				var list_data = patients.getPatientlist(patientData);
				$('#table_patientlist').dataTable().api().clear().rows.add(list_data).draw();

				if (patientId !== '') {
					$('#table_patientlist').DataTable().page.jumpToData(parseInt(patientId), 0);
				}
			});
		}
		if (patientId !== '') {

            if ($('#table_patientlist').find('tr[id="' + patientId + '"]').length) {

				// Patientenstammdaten neu laden wegen bestätigten Integritäten
                $('.tt-nav-content-article').find('.tt-selected-id').val('');
				$('.tt-nav-content-article').find('.tt-selected-patient-is-active').val('');
                $('.tt-nav-content-article').find('.tt-selected-patient-is-locked').val('');

				changes.tableSingleClick($('#table_patientlist').find('tr[id="' + patientId + '"]')).done(function () {

					validator.setExaminationList(true).done(function () {

					    var hrefActiveTab = $('.tt-nav-tab-container li.active a').attr('href');
						if (hrefActiveTab === '#content-detail-master' || hrefActiveTab === '#content-detail-course' || hrefActiveTab === '#content-detail-questionnaires') {

							if ($('#table_patient_examination').dataTable().fnGetData().length > 0) {
								changes.tableSingleClick($('#table_patient_examination tbody tr:eq(0)')).done(function () {
									if (hrefActiveTab === '#content-detail-master') {
										changes.selectNavigationTab($('[href="#content-detail-master"]'), null);
									} else if (hrefActiveTab === '#content-detail-course') {
										changes.selectNavigationTab($('[href="#content-detail-course"]'), null);
									} else if (hrefActiveTab === '#content-detail-questionnaires') {
										changes.selectNavigationTab($('[href="#content-detail-questionnaires"]'), null);
									}
								});
							} else {
								if (hrefActiveTab === '#content-detail-master') {
									$('[href="#content-detail-master"]').click();
								} else if (hrefActiveTab === '#content-detail-course') {
									$('[href="#content-detail-course"]').click();
								} else if (hrefActiveTab === '#content-detail-questionnaires') {
									$('[href="#content-detail-questionnaires"]').click();
								}
							}
						}
					})
				});
			} else {
				changes.cancelViews(true, true);
            }
        }
    });
}

function showNotifications(url, element) {

    $('.tt-load-notifications').button('loading');

    ajax.ajaxCall(url, "GET", 'search=' + $('.input-notification-search').val(), false, function(data) {
        $('.tt-load-notifications').parent().find('.tt-last-updated').text(utils.dateToLocaleTimeString(utils.dateToTimeString(moment()), false));
        utils.setHtmlData(element, data, false);

        utils.setIDATData(element).done(function() {
            searchNotifications($('.input-notification-search').val());
        });

        var counter = $('#notification_counter').val();
        $('#notifications .badge').text(counter);
        if (counter > 0) {
            $('#notifications .badge').addClass("bg-color-red bounceIn animated");
        } else {
            $('#notifications .badge').removeClass("bg-color-red bounceIn animated");
        }
        var counterAllQueries = $('#all_notification_counter').val();
        var counterOpenQueries = $('#notification_counter').val();
        if (counterAllQueries > 0) {
            $('.tt-number-of-notifications,.tt-search-notifications').removeClass('hide');
            $(element).parents('.ajax-dropdown').removeClass('tt-zero-notifications');
            var counterInProgressQueries = counterAllQueries - counterOpenQueries;

			if (counterOpenQueries == 1 && counterInProgressQueries == 0) {
				$('.tt-number-of-notifications').text(trans('tripletrax.one_open_and_zero_query'));
			} else if (counterOpenQueries > 1 && counterInProgressQueries == 0) {
				$('.tt-number-of-notifications').text(trans('tripletrax.number_of_open_and_zero_query', {'number_of_open_queries': counterOpenQueries}));
			} else if (counterOpenQueries == 0 && counterInProgressQueries == 1) {
				$('.tt-number-of-notifications').text(trans('tripletrax.zero_open_and_one_query'));
			} else if (counterOpenQueries == 1 && counterInProgressQueries == 1) {
				$('.tt-number-of-notifications').text(trans('tripletrax.one_open_and_one_query'));
			} else if (counterOpenQueries > 1 && counterInProgressQueries == 1) {
				$('.tt-number-of-notifications').text(trans('tripletrax.number_of_open_and_one_query', {'number_of_open_queries': counterOpenQueries}));
			} else if (counterOpenQueries == 0 && counterInProgressQueries > 1) {
				$('.tt-number-of-notifications').text(trans('tripletrax.zero_open_and_number_of_queries', {'number_of_queries': counterInProgressQueries}));
			} else if (counterOpenQueries == 1 && counterInProgressQueries > 1) {
				$('.tt-number-of-notifications').text(trans('tripletrax.one_open_and_number_of_queries', {'number_of_queries': counterInProgressQueries}));
            } else {
                $('.tt-number-of-notifications').text(trans('tripletrax.number_of_queries', {'number_of_open_queries': counterOpenQueries, 'number_of_queries': counterInProgressQueries}));
            }
        } else {
            $('.tt-number-of-notifications,.tt-search-notifications').addClass('hide');
            $(element).parents('.ajax-dropdown').addClass('tt-zero-notifications');
        }

        if ($('#close_query_right').val()) {
            $('.tt-close-all-queries').parent().removeClass('hide');
            $('.ajax-notifications')[0].style.height = '365px';
        } else {
            $('.tt-close-all-queries').parent().addClass('hide');
            $('.ajax-notifications')[0].style.height = '410px';
        }

        if ($('.tt-close-all-queries').length && $('.notification-body').find('.unread').length > 0) {
            $('.tt-close-all-queries').removeAttr('disabled', 'disabled');
        } else if ($('.tt-close-all-queries').length) {
            $('.tt-close-all-queries').attr('disabled', 'disabled');
        }
        $('.tt-load-notifications').button('reset');
    });
}

function searchNotifications(searchString) {
    $('.ajax-notifications .notification-body li').removeClass('hide');

    if (searchString !== '') {
        $.each($('.ajax-notifications .notification-body .tt-pseudonym'), function (i, element) {
            var data = $(element).data();
            var regex = '.*' + searchString.toLowerCase() + '.*';
            if (!data.name.toLowerCase().match(regex) && !data.prename.toLowerCase().match(regex) && !data.birthDateDisplay.toLowerCase().match(regex) && !data.pseudonym.toLowerCase().match(regex)) {
                $(element).parents('li').addClass('hide');
            }
        });
    }
}

function checkPatientAgreements(modelsWithRights, modelId, modelText, otherDependingModels, newEndDate, doDelete) {

    return $.Deferred(function (defer) {
        var showNoRightsMessage = false;
        var showDependingModelExistingMessage = false;
        $.each(modelId.split('|'), function (k, splittedModelId) {
            var existingModels = validator.getExistingPatientAgreements(newEndDate);
            var modelHierarchy = [];
            var currentModel = null;
            $.each($.parseJSON($('#all_models').val()), function (i, val) {
                if (val.id == splittedModelId) {
                    currentModel = val;
                }
            });

            if (utils.isUndefined(currentModel)) {
                return true;
            }

            validator.getDependingPatientAgreementExistingRecursive(currentModel, $.parseJSON($('#all_models').val()), modelHierarchy);

            var modelsWithRightsIds = [];
            $.each(modelsWithRights, function (i, model) {
                modelsWithRightsIds.push(model.id);
            });

            var noRights = false;
            $.each(existingModels, function (i, model) {
                // Einwilligung existiert, aber keine Rechte diese zu ändern
                if ($.inArray(model, modelHierarchy) >= 0 && model.id !== splittedModelId && $.inArray(model, modelsWithRightsIds) < 0) {
                    noRights = true;
                    return false;
                }
            });

            if (noRights) {
                showNoRightsMessage = true;
            } else {
                // In der Liste suchen, ob aktive Teilnahmen für die abhängigen Projekte/Studien vorhanden sind
                var dependingModelExisting = false;

                $.each(otherDependingModels.split('|'), function (j, dependingModel) {
                    if (jQuery.inArray(utils.stringToNumber(dependingModel), existingModels) >= 0) {
                        dependingModelExisting = true;
                    }
                });

                if (dependingModelExisting) {
                    showDependingModelExistingMessage = true;
                }
            }
        });

        if (showNoRightsMessage) {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + (doDelete ? Lang.get('tripletrax.delete_agreement', {"model": "<span class='txt-color-orangeDark'><strong>" + modelText + "</strong></span>"}) : Lang.get('tripletrax.change_agreement_title', {"model": "<span class='txt-color-orangeDark'><strong>" + modelText + "</strong></span>"})),
                content: (doDelete ? Lang.get('tripletrax.no_rights_delete_agreement_desc') : Lang.get('tripletrax.no_rights_change_agreement_desc')),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
            });
            defer.resolve(false);
        } else if (showDependingModelExistingMessage) {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + (doDelete ? Lang.get('tripletrax.delete_agreement', {"model": "<span class='txt-color-orangeDark'><strong>" + modelText + "</strong></span>"}) : Lang.get('tripletrax.change_agreement_title', {"model": "<span class='txt-color-orangeDark'><strong>" + modelText + "</strong></span>"})),
                content: (doDelete ? Lang.get('tripletrax.delete_agreement_with_others_desc') : Lang.get('tripletrax.change_agreement_desc')),
                buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
            }, function (ButtonPressed) {
                if (ButtonPressed === Lang.get('tripletrax.no')) {
                    defer.resolve(false);
                } else {
                    defer.resolve(true);
                }
            });
        }

        defer.resolve(true);
    }).promise();
}

function addCalculationRow(dialogId, counter, val, isAdditionalField, usedFieldsSelection) {

    var newRow = null;
    if (val == '' && $(dialogId).find('.tt-calculation-row-match-field').hasClass('hide')) {
        newRow = $(dialogId).find('.tt-calculation-dynamic-row.hide').clone().removeClass('hide');
        newRow.find('.label-tripletrax').text(trans('tripletrax.data_field'));
    } else if (!$(dialogId).find('.tt-calculation-row-match-field').hasClass('hide')) {
		newRow = $(dialogId).find('.tt-calculation-dynamic-match-list-row.hide').clone().removeClass('hide');
	} else {
        newRow = $(dialogId).find('.tt-calculation-row.hide').clone().removeClass('hide');
        newRow.data('used-field', val);
        newRow.find('.label-tripletrax').text(trans('tripletrax.data_view_field', {'field': trans('tripletrax.' + val)}));
    }

    newRow.find('select:not(.tt-select2)').addClass('tt-select2');

    var newData = [];
    var category = $('#content').find('[name="category"]').val();
    var tableIfItemIsInListOrAccordion = $('#content').find('[name="table_if_item_is_in_accordion_or_list"]').val()

    // Es dürfen nur Felder ausgewählt werden:
    // 1. bei Stammdaten nur Stammdaten
    // 2. bei Verlaufsdaten nur Stammdaten & Verlaufsdaten
    // 3. bei zeitraumbezogene Stammdaten nur Stammdaten und Felder der eigenen Tabelle
    // 4. bei zeitraumbezogene Verlaufsdaten nur Stammdatn, Verlaufsdaten und Felder der eigenen Tabelle
    jQuery.each($.parseJSON($(dialogId).find('[name="all_fields"]').val()), function (j, combo_val) {

        if (category === 'master') {
            if (((combo_val.table_type === 'master_table' || combo_val.table_type === 'master_facility_table' || (utils.isIDATField(combo_val.match_field) && !utils.isIDATFieldInDatabase(combo_val.match_field)))
                || ((combo_val.table_type === 'period_table' || combo_val.table_type === 'period_facility_table') && combo_val.table === tableIfItemIsInListOrAccordion))
                && combo_val.desc !== '') {
                newData.push({id: combo_val.id + '#' + combo_val.name, text: combo_val.desc + ' (' + combo_val.name + ')', table: combo_val.table, tableType: combo_val.table_type});
            }
        } else if (category === 'course') {
            if (((combo_val.table_type === 'master_table' || combo_val.table_type === 'master_facility_table' || (utils.isIDATField(combo_val.match_field) && !utils.isIDATFieldInDatabase(combo_val.match_field)) || combo_val.table_type === 'course_table' || combo_val.table_type === 'course_facility_table')
                || ((combo_val.table_type === 'period_table' || combo_val.table_type === 'period_facility_table') && combo_val.table === tableIfItemIsInListOrAccordion))
                && combo_val.desc !== '') {
                newData.push({id: combo_val.id + '#' + combo_val.name, text: combo_val.desc + ' (' + combo_val.name + ')', table: combo_val.table, tableType: combo_val.table_type});
            }
        }
    });

    // Untersuchungsdatum darf nur bei Erhebungsdatum in den Verlaufsdaten auswählbar sein
    if (val === 'reference_date' && category === 'course') {
        newData.push({id: '-1#examinationdate', text: Lang.get('tripletrax.examinationdate'), table: '', tableType: 'course_table'});
    }

    // wenn es sich um die Berechnung des Zusatzfeldes handelt und das Feld noch nicht gespeichert ist, dann auch das eigentliche Feld in den Berechnungen mit anzeigen
    if ($('#content').find('[name="data_view_id"]').val() === '0' && isAdditionalField
        && $('#content').find('[name="name"]').val() !== '' && $('#content').find('[name="desc"]').val() !== '') {
        newData.push({id: '[-2]#' + $('#content').find('[name="name"]').val(), text: $('#content').find('[name="desc"]').val() + ' (' + $('#content').find('[name="name"]').val() + ')', table: tableIfItemIsInListOrAccordion, tableType: category});
    }

	if (!$(dialogId).find('.tt-calculation-row-match-field').hasClass('hide') && $('.tt-calculation-row-match-field').length && !$('.tt-calculation-row-match-field').find('.tt-select2').val()) {
		$('.tt-calculation-row-match-field').find('select:not(.tt-select2)').addClass('tt-select2');
		$(dialogId).find('.tt-select2').parent().find('[name]')[0].setAttribute('name', $(dialogId).find('.tt-select2').parent().find('[name]').attr('name') + '_' + counter);
		validator.reinitializeSelect2($(dialogId).find('.tt-select2').parent(), 'input-sm tt-select2 select2-container tt-calculation-match-list-field', '', newData, false);
    } else if ($(dialogId).find('.tt-calculation-row-match-field').hasClass('hide')) {
		newRow.find('.tt-select2').parent().find('[name]')[0].setAttribute('name', $(newRow.find('.tt-select2').parent().find('[name]')[0]).attr('name') + '_' + counter);
		validator.reinitializeSelect2(newRow.find('.tt-select2').parent(), 'input-sm tt-select2 select2-container tt-calculation-single-field', '', newData, false);
    }




    if (usedFieldsSelection.length) {
        if (val === '' && $(dialogId).find('.tt-calculation-row-match-field').hasClass('hide')) {
            newRow.find('.tt-select2').val(usedFieldsSelection).trigger('change.select2');
        } else if (val === '' && !$(dialogId).find('.tt-calculation-row-match-field').hasClass('hide')) {
				newRow.find('[name="score_value"]').val(counter);
				newRow.find('[name="match_list_value"]').val(usedFieldsSelection);
		}  else {
            jQuery.each(usedFieldsSelection, function (k, usedVal) {
                if (k > 0) {
                    var usedFieldVal = usedVal.split(':');
                    if (usedFieldVal[0] === val) {
                        newRow.find('.tt-select2').val(usedFieldVal[1]).trigger('change.select2');
                    }
                }
            });
        }
    }

    initialize.initializeElements(newRow, true, false);
    $(dialogId).find('.tt-calculation-fields').append(newRow);
}

function clickSubmitButton(element) {

    var form = element.parents('.tt-content-detail').find('form');
    var formDialog = element.parents('.tt-content-detail,.tt-content-dialog').find('form');

    if (form.length && (form[0].id === "import_form" || form[0].id === "import_query_form")) {

        // Für den Import angeben, welcher der beiden Submit-Buttons angeklickt wurde
        form.find('[name="import_action"]').val(element.data().action);

        $('.tt-file-check-ok').addClass('hide');
        $('.tt-file-check-fail').addClass('hide');
        $('.tt-import-report').html('');

    } else if (form.length && form[0].id === "email_compose_form") {

        // Bei den Mails angeben, welcher Submit-Button angeklickt wurde
        form.find('[name="mail_folder"]').val(element.data().folder);

    } else if (formDialog.length && formDialog[0].id === "email_completeness_form") {

        // Bei den Mails angeben, welcher Submit-Button angeklickt wurde
        formDialog.find('[name="mail_folder"]').val('sent');

    } else if (form.length && form[0].id === "restore_patient_form") {

        // Beim Wiederherstellen des Patienten angeben, welcher Submit-Button angeklickt wurde
        form.find('[name="restore_action"]').val(element.data().action);

    } else if (formDialog[0].id === "table_aggregation_execution_3_form") {

        if (element[0].name === "preview_aggregation") {
            element.parents('form').find('[name="execute_button"]').val('preview');
        } else if (element[0].name === "execute_aggregation") {
            element.parents('form').find('[name="execute_button"]').val('execute');
            formDialog[0].action = 'admin/aggregation_execution/step4';
        }
        element.parents('form').validate().settings.rules = validator.getRules(element.parents('form'));
    }

    var isValid = true;
    if (formDialog.length
        && (formDialog[0].id === 'table_data_collection_types_detail_form'
            || formDialog[0].id === 'table_monitoring_detail_form'
            || formDialog[0].id === 'settings_language_form'
            || formDialog[0].id === 'settings_form')) {

        utils.updateGlobals('showValidationErrorMessageBox', true);
        jQuery.each($('#widget-grid-dialog').find('.tt-validation-form'), function (i, val) {
            if (!$(val).valid()) {
                isValid = false;
                utils.updateGlobals('showValidationErrorMessageBox', false);
            }
        });

    } else if (formDialog.length && formDialog[0].id === 'table_monitoring_restrictions_form') {
        isValid = !$('#dd_monitoring_restrictions').find('.tt-add-monitoring-restriction.txt-color-crimson').length;

        if (isValid) {
            element.parents('form').find('.tt-invalid-monitoring').addClass('hide');
        } else {
            element.parents('form').find('.tt-invalid-monitoring').removeClass('hide');
            validator.showValidationMessage();
        }
    } else if (formDialog.length && formDialog[0].id === "table_patient_examination_create_form") {
        isValid = !$('#table_patient_examination_create_form').find('.state-error').length;
        if (!isValid) {
            validator.showValidationMessage();
        }
    } else {
        isValid = element.parents('.tt-content-detail,.tt-content-dialog').find('.tt-validation-form').valid();
    }

    if (isValid) {

        checkDoSubmit(formDialog[0]).done(function (doSubmit) {

            if (doSubmit === 'false') {
                return;
            }

            // Timer eingebaut, da bei geöffnetem Kalender (Datepicker - Timer von 100ms) der Submit hängen geblieben ist
            setTimeout(function() {
                if (formDialog[0].id === 'table_monitoring_restrictions_form' || formDialog[0].id === 'table_monitoring_detail_form') {
                    $(formDialog[0]).submit();
                } else {
                    formDialog.submit();
                }
            }, 110);

            if (form.length && (form[0].id === "import_form" || form[0].id === "import_query_form")) {
                $('.tt-import').addClass('disabled');
                $('.tt-import-preview').addClass('disabled');
                $('.tt-last-import').addClass('hide');
            } else if (formDialog.length && formDialog[0].id === "table_collection_type_integrities_form" && doSubmit === 'true_change') {
                $('.tt-colored-completeness')[0].checked = false;
            } else if (formDialog.length && formDialog[0].id === "table_collection_type_integrities_form" && doSubmit === 'true_change_activation') {
                $('[name="colored_completeness_activated"]').val('0');
            } else if (formDialog[0].id === "table_aggregation_execution_3_form") {
                if (element[0].name === "preview_aggregation") {
                    $('.tt-content-dialog').find('.tt-show-aggregation-preview').removeClass('hide');
                } else if (element[0].name === "execute_aggregation") {
                    $('.tt-content-dialog').find('.tt-show-aggregation-preview').addClass('hide');
                }

                element.parents('form').find('.tt-save').addClass('disabled');
                element.parents('form').find('.tt-save').attr('disabled', 'disabled');
            } else {
                element.addClass('disabled');
            }
        });
    }
}

module.exports.registerCommonEvents = registerCommonEvents;
module.exports.registerNestableEvents = registerNestableEvents;
module.exports.registerDocumentationEvents = registerDocumentationEvents;
